(function () {
'use strict';

function loader() {
    var loading = document.querySelector('body.loading');
    if (loading) {
        if (loading.classList.contains('loading')) {
            loading.classList.add('loading--finished');

            setTimeout(function () {
                loading.classList.remove('loading--finished');
                loading.classList.remove('loading');

                document.dispatchEvent(new CustomEvent('bodyLoadingFinished'));
            }, 120);
        }
    }
}

if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', loader);
} else {
    // `DOMContentLoaded` has already fired
    loader();
}

/*!
 * @copyright Copyright (c) 2017 IcoMoon.io
 * @license   Licensed under MIT license
 *            See https://github.com/Keyamoon/svgxuse
 * @version   1.2.6
 */
/*jslint browser: true */
/*global XDomainRequest, MutationObserver, window */
(function () {
    "use strict";

    if (typeof window !== "undefined" && window.addEventListener) {
        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
        var checkUseElems;
        var tid; // timeout id
        var debouncedCheck = function debouncedCheck() {
            clearTimeout(tid);
            tid = setTimeout(checkUseElems, 100);
        };
        var unobserveChanges = function unobserveChanges() {
            return;
        };
        var observeChanges = function observeChanges() {
            var observer;
            window.addEventListener("resize", debouncedCheck, false);
            window.addEventListener("orientationchange", debouncedCheck, false);
            if (window.MutationObserver) {
                observer = new MutationObserver(debouncedCheck);
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                unobserveChanges = function unobserveChanges() {
                    try {
                        observer.disconnect();
                        window.removeEventListener("resize", debouncedCheck, false);
                        window.removeEventListener("orientationchange", debouncedCheck, false);
                    } catch (ignore) {}
                };
            } else {
                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
                unobserveChanges = function unobserveChanges() {
                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
                    window.removeEventListener("resize", debouncedCheck, false);
                    window.removeEventListener("orientationchange", debouncedCheck, false);
                };
            }
        };
        var createRequest = function createRequest(url) {
            // In IE 9, cross origin requests can only be sent using XDomainRequest.
            // XDomainRequest would fail if CORS headers are not set.
            // Therefore, XDomainRequest should only be used with cross origin requests.
            function getOrigin(loc) {
                var a;
                if (loc.protocol !== undefined) {
                    a = loc;
                } else {
                    a = document.createElement("a");
                    a.href = loc;
                }
                return a.protocol.replace(/:/g, "") + a.host;
            }
            var Request;
            var origin;
            var origin2;
            if (window.XMLHttpRequest) {
                Request = new XMLHttpRequest();
                origin = getOrigin(location);
                origin2 = getOrigin(url);
                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
                    Request = XDomainRequest || undefined;
                } else {
                    Request = XMLHttpRequest;
                }
            }
            return Request;
        };
        var xlinkNS = "http://www.w3.org/1999/xlink";
        checkUseElems = function checkUseElems() {
            var base;
            var bcr;
            var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
            var hash;
            var href;
            var i;
            var inProgressCount = 0;
            var isHidden;
            var Request;
            var url;
            var uses;
            var xhr;
            function observeIfDone() {
                // If done with making changes, start watching for chagnes in DOM again
                inProgressCount -= 1;
                if (inProgressCount === 0) {
                    // if all xhrs were resolved
                    unobserveChanges(); // make sure to remove old handlers
                    observeChanges(); // watch for changes to DOM
                }
            }
            function attrUpdateFunc(spec) {
                return function () {
                    if (cache[spec.base] !== true) {
                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
                        if (spec.useEl.hasAttribute("href")) {
                            spec.useEl.setAttribute("href", "#" + spec.hash);
                        }
                    }
                };
            }
            function onloadFunc(xhr) {
                return function () {
                    var body = document.body;
                    var x = document.createElement("x");
                    var svg;
                    xhr.onload = null;
                    x.innerHTML = xhr.responseText;
                    svg = x.getElementsByTagName("svg")[0];
                    if (svg) {
                        svg.setAttribute("aria-hidden", "true");
                        svg.style.position = "absolute";
                        svg.style.width = 0;
                        svg.style.height = 0;
                        svg.style.overflow = "hidden";
                        body.insertBefore(svg, body.firstChild);
                    }
                    observeIfDone();
                };
            }
            function onErrorTimeout(xhr) {
                return function () {
                    xhr.onerror = null;
                    xhr.ontimeout = null;
                    observeIfDone();
                };
            }
            unobserveChanges(); // stop watching for changes to DOM
            // find all use elements
            uses = document.getElementsByTagName("use");
            for (i = 0; i < uses.length; i += 1) {
                try {
                    bcr = uses[i].getBoundingClientRect();
                } catch (ignore) {
                    // failed to get bounding rectangle of the use element
                    bcr = false;
                }
                href = uses[i].getAttribute("href") || uses[i].getAttributeNS(xlinkNS, "href") || uses[i].getAttribute("xlink:href");
                if (href && href.split) {
                    url = href.split("#");
                } else {
                    url = ["", ""];
                }
                base = url[0];
                hash = url[1];
                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
                    // the use element is empty
                    // if there is a reference to an external SVG, try to fetch it
                    // use the optional fallback URL if there is no reference to an external SVG
                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
                        base = fallback;
                    }
                    if (uses[i].hasAttribute("href")) {
                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
                    }
                    if (base.length) {
                        // schedule updating xlink:href
                        xhr = cache[base];
                        if (xhr !== true) {
                            // true signifies that prepending the SVG was not required
                            setTimeout(attrUpdateFunc({
                                useEl: uses[i],
                                base: base,
                                hash: hash
                            }), 0);
                        }
                        if (xhr === undefined) {
                            Request = createRequest(base);
                            if (Request !== undefined) {
                                xhr = new Request();
                                cache[base] = xhr;
                                xhr.onload = onloadFunc(xhr);
                                xhr.onerror = onErrorTimeout(xhr);
                                xhr.ontimeout = onErrorTimeout(xhr);
                                xhr.open("GET", base);
                                xhr.send();
                                inProgressCount += 1;
                            }
                        }
                    }
                } else {
                    if (!isHidden) {
                        if (cache[base] === undefined) {
                            // remember this URL if the use element was not empty and no request was sent
                            cache[base] = true;
                        } else if (cache[base].onload) {
                            // if it turns out that prepending the SVG is not necessary,
                            // abort the in-progress xhr.
                            cache[base].abort();
                            delete cache[base].onload;
                            cache[base] = true;
                        }
                    } else if (base.length && cache[base]) {
                        setTimeout(attrUpdateFunc({
                            useEl: uses[i],
                            base: base,
                            hash: hash
                        }), 0);
                    }
                }
            }
            uses = "";
            inProgressCount += 1;
            observeIfDone();
        };
        var _winLoad;
        _winLoad = function winLoad() {
            window.removeEventListener("load", _winLoad, false); // to prevent memory leaks
            tid = setTimeout(checkUseElems, 0);
        };
        if (document.readyState !== "complete") {
            // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
            window.addEventListener("load", _winLoad, false);
        } else {
            // No need to add a listener if the document is already loaded, initialize immediately.
            _winLoad();
        }
    }
})();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();

/**
 * window.CustomEvent polyfill
 */

(function () {
	if (typeof window.CustomEvent === "function") {
		return false;
	}

	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent("CustomEvent");
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;
	window.CustomEvent = CustomEvent;
})();

/**
 * Element.matches() polyfill (simple version)
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
 */
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;

		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				this.parentNode.removeChild(this);
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('append')) {
			return;
		}
		Object.defineProperty(item, 'append', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function append() {
				var argArr = Array.prototype.slice.call(arguments),
				    docFrag = document.createDocumentFragment();

				argArr.forEach(function (argItem) {
					var isNode = argItem instanceof Node;
					docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
				});

				this.appendChild(docFrag);
			}
		});
	});
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
	String.prototype.padStart = function padStart(targetLength, padString) {
		targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
		padString = String(typeof padString !== 'undefined' ? padString : ' ');
		if (this.length >= targetLength) {
			return String(this);
		} else {
			targetLength = targetLength - this.length;
			if (targetLength > padString.length) {
				padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
			}
			return padString.slice(0, targetLength) + String(this);
		}
	};
}

/**
 * Node foreach polyfill
 * https://github.com/miguelcobain/ember-paper/issues/1058
 */
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * Node filter polyfill
 */
if (window.NodeList && !NodeList.prototype.filter) {
	NodeList.prototype.filter = Array.prototype.filter;
}

/**
 * ClassList polyfill
 */
// 1. String.prototype.trim polyfill
if (!"".trim) String.prototype.trim = function () {
	return this.replace(/^[\s﻿]+|[\s﻿]+$/g, '');
};
(function (window) {
	"use strict"; // prevent global namespace pollution

	if (!window.DOMException) (DOMException = function DOMException(reason) {
		this.message = reason;
	}).prototype = new Error();
	var wsRE = /[\11\12\14\15\40]/,
	    wsIndex = 0,
	    checkIfValidClassListEntry = function checkIfValidClassListEntry(O, V) {
		if (V === "") throw new DOMException("Failed to execute '" + O + "' on 'DOMTokenList': The token provided must not be empty.");
		if ((wsIndex = V.search(wsRE)) !== -1) throw new DOMException("Failed to execute '" + O + "' on 'DOMTokenList': " + "The token provided ('" + V[wsIndex] + "') contains HTML space characters, which are not valid in tokens.");
	};
	// 2. Implement the barebones DOMTokenList livelyness polyfill
	if (typeof DOMTokenList !== "function") (function (window) {
		var document = window.document,
		    Object = window.Object,
		    hasOwnProp = Object.prototype.hasOwnProperty;
		var defineProperty$$1 = Object.defineProperty,
		    allowTokenListConstruction = 0,
		    skipPropChange = 0;
		function DOMTokenList() {
			if (!allowTokenListConstruction) throw TypeError("Illegal constructor"); // internally let it through
		}
		DOMTokenList.prototype.toString = DOMTokenList.prototype.toLocaleString = function () {
			return this.value;
		};
		DOMTokenList.prototype.add = function () {
			a: for (var v = 0, argLen = arguments.length, val = "", ele = this[" uCL"], proto = ele[" uCLp"]; v !== argLen; ++v) {
				val = arguments[v] + "", checkIfValidClassListEntry("add", val);
				for (var i = 0, Len = proto.length, resStr = val; i !== Len; ++i) {
					if (this[i] === val) continue a;else resStr += " " + this[i];
				}this[Len] = val, proto.length += 1, proto.value = resStr;
			}
			skipPropChange = 1, ele.className = proto.value, skipPropChange = 0;
		};
		DOMTokenList.prototype.remove = function () {
			for (var v = 0, argLen = arguments.length, val = "", ele = this[" uCL"], proto = ele[" uCLp"]; v !== argLen; ++v) {
				val = arguments[v] + "", checkIfValidClassListEntry("remove", val);
				for (var i = 0, Len = proto.length, resStr = "", is = 0; i !== Len; ++i) {
					if (is) {
						this[i - 1] = this[i];
					} else {
						if (this[i] !== val) {
							resStr += this[i] + " ";
						} else {
							is = 1;
						}
					}
				}if (!is) continue;
				delete this[Len], proto.length -= 1, proto.value = resStr;
			}
			skipPropChange = 1, ele.className = proto.value, skipPropChange = 0;
		};
		window.DOMTokenList = DOMTokenList;
		function whenPropChanges() {
			var evt = window.event,
			    prop = evt.propertyName;
			if (!skipPropChange && (prop === "className" || prop === "classList" && !defineProperty$$1)) {
				var target = evt.srcElement,
				    protoObjProto = target[" uCLp"],
				    strval = "" + target[prop];
				var tokens = strval.trim().split(wsRE),
				    resTokenList = target[prop === "classList" ? " uCL" : "classList"];
				var oldLen = protoObjProto.length;
				a: for (var cI = 0, cLen = protoObjProto.length = tokens.length, sub = 0; cI !== cLen; ++cI) {
					for (var innerI = 0; innerI !== cI; ++innerI) {
						if (tokens[innerI] === tokens[cI]) {
							sub++;continue a;
						}
					}resTokenList[cI - sub] = tokens[cI];
				}
				for (var i = cLen - sub; i < oldLen; ++i) {
					delete resTokenList[i];
				} //remove trailing indexs
				if (prop !== "classList") return;
				skipPropChange = 1, target.classList = resTokenList, target.className = strval;
				skipPropChange = 0, resTokenList.length = tokens.length - sub;
			}
		}
		function polyfillClassList(ele) {
			if (!ele || !("innerHTML" in ele)) throw TypeError("Illegal invocation");
			ele.detachEvent("onpropertychange", whenPropChanges); // prevent duplicate handler infinite loop
			allowTokenListConstruction = 1;
			try {
				var _protoObj = function _protoObj() {};

				_protoObj.prototype = new DOMTokenList();
			} finally {
				allowTokenListConstruction = 0;
			}
			var protoObjProto = protoObj.prototype,
			    resTokenList = new protoObj();
			a: for (var toks = ele.className.trim().split(wsRE), cI = 0, cLen = toks.length, sub = 0; cI !== cLen; ++cI) {
				for (var innerI = 0; innerI !== cI; ++innerI) {
					if (toks[innerI] === toks[cI]) {
						sub++;continue a;
					}
				}this[cI - sub] = toks[cI];
			}
			protoObjProto.length = cLen - sub, protoObjProto.value = ele.className, protoObjProto[" uCL"] = ele;
			if (defineProperty$$1) {
				defineProperty$$1(ele, "classList", { // IE8 & IE9 allow defineProperty on the DOM
					enumerable: 1, get: function get$$1() {
						return resTokenList;
					},
					configurable: 0, set: function set$$1(newVal) {
						skipPropChange = 1, ele.className = protoObjProto.value = newVal += "", skipPropChange = 0;
						var toks = newVal.trim().split(wsRE),
						    oldLen = protoObjProto.length;
						a: for (var cI = 0, cLen = protoObjProto.length = toks.length, sub = 0; cI !== cLen; ++cI) {
							for (var innerI = 0; innerI !== cI; ++innerI) {
								if (toks[innerI] === toks[cI]) {
									sub++;continue a;
								}
							}resTokenList[cI - sub] = toks[cI];
						}
						for (var i = cLen - sub; i < oldLen; ++i) {
							delete resTokenList[i];
						} //remove trailing indexs
					}
				});defineProperty$$1(ele, " uCLp", { // for accessing the hidden prototype
					enumerable: 0, configurable: 0, writeable: 0, value: protoObj.prototype
				});defineProperty$$1(protoObjProto, " uCL", {
					enumerable: 0, configurable: 0, writeable: 0, value: ele
				});
			} else {
				ele.classList = resTokenList, ele[" uCL"] = resTokenList, ele[" uCLp"] = protoObj.prototype;
			}
			ele.attachEvent("onpropertychange", whenPropChanges);
		}
		try {
			// Much faster & cleaner version for IE8 & IE9:
			// Should work in IE8 because Element.prototype instanceof Node is true according to the specs
			window.Object.defineProperty(window.Element.prototype, "classList", {
				enumerable: 1, get: function get$$1(val) {
					if (!hasOwnProp.call(this, "classList")) polyfillClassList(this);
					return this.classList;
				},
				configurable: 0, set: function set$$1(val) {
					this.className = val;
				}
			});
		} catch (e) {
			// Less performant fallback for older browsers (IE 6-8):
			window[" uCL"] = polyfillClassList;
			// the below code ensures polyfillClassList is applied to all current and future elements in the doc.
			document.documentElement.firstChild.appendChild(document.createElement('style')).styleSheet.cssText = '_*{x-uCLp:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}' + //  IE6
			'[class]{x-uCLp/**/:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}' //IE7-8
			;
		}
	})(window);
	// 3. Patch in unsupported methods in DOMTokenList
	(function (DOMTokenListProto, testClass) {
		if (!DOMTokenListProto.item) DOMTokenListProto.item = function (i) {
			function NullCheck(n) {
				return n === void 0 ? null : n;
			}return NullCheck(this[i]);
		};
		if (!DOMTokenListProto.toggle || testClass.toggle("a", 0) !== false) DOMTokenListProto.toggle = function (val) {
			if (arguments.length > 1) return this[arguments[1] ? "add" : "remove"](val), !!arguments[1];
			var oldValue = this.value;
			return this.remove(oldValue), oldValue === this.value && (this.add(val), true) /*|| false*/;
		};
		if (!DOMTokenListProto.replace || typeof testClass.replace("a", "b") !== "boolean") DOMTokenListProto.replace = function (oldToken, newToken) {
			checkIfValidClassListEntry("replace", oldToken), checkIfValidClassListEntry("replace", newToken);
			var oldValue = this.value;
			return this.remove(oldToken), this.value !== oldValue && (this.add(newToken), true);
		};
		if (!DOMTokenListProto.contains) DOMTokenListProto.contains = function (value) {
			for (var i = 0, Len = this.length; i !== Len; ++i) {
				if (this[i] === value) return true;
			}return false;
		};
		if (!DOMTokenListProto.forEach) DOMTokenListProto.forEach = function (f) {
			if (arguments.length === 1) for (var i = 0, Len = this.length; i !== Len; ++i) {
				f(this[i], i, this);
			} else for (var i = 0, Len = this.length, tArg = arguments[1]; i !== Len; ++i) {
				f.call(tArg, this[i], i, this);
			}
		};
		if (!DOMTokenListProto.entries) DOMTokenListProto.entries = function () {
			var nextIndex = 0,
			    that = this;
			return { next: function next() {
					return nextIndex < that.length ? { value: [nextIndex, that[nextIndex]], done: false } : { done: true };
				} };
		};
		if (!DOMTokenListProto.values) DOMTokenListProto.values = function () {
			var nextIndex = 0,
			    that = this;
			return { next: function next() {
					return nextIndex < that.length ? { value: that[nextIndex], done: false } : { done: true };
				} };
		};
		if (!DOMTokenListProto.keys) DOMTokenListProto.keys = function () {
			var nextIndex = 0,
			    that = this;
			return { next: function next() {
					return nextIndex < that.length ? { value: nextIndex, done: false } : { done: true };
				} };
		};
	})(window.DOMTokenList.prototype, window.document.createElement("div").classList);
})(window);

// object length ~ object size
Object.size = function (obj) {
	return Object.keys(obj).length;

	var size = 0,
	    key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)) size++;
	}
	return size;
};

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
	Object.keys = function () {
		'use strict';

		var hasOwnProperty = Object.prototype.hasOwnProperty,
		    hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
		    dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'],
		    dontEnumsLength = dontEnums.length;

		return function (obj) {
			if (typeof obj !== 'function' && ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== 'object' || obj === null)) {
				throw new TypeError('Object.keys called on non-object');
			}

			var result = [],
			    prop,
			    i;

			for (prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					result.push(prop);
				}
			}

			if (hasDontEnumBug) {
				for (i = 0; i < dontEnumsLength; i++) {
					if (hasOwnProperty.call(obj, dontEnums[i])) {
						result.push(dontEnums[i]);
					}
				}
			}
			return result;
		};
	}();
}

// object size
Object.size = function (obj) {
	var size = 0,
	    key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)) size++;
	}
	return size;
};

// POLLYFILL FOR SVGSPRITE
// https://github.com/Keyamoon/svgxuse
/**
 * Author: Jason Farrell
 * Author URI: http://useallfive.com/
 *
 * Description: Checks if a DOM element is truly visible.
 * Package URL: https://github.com/UseAllFive/true-visibility
 */
Element.prototype.isVisible = function () {

	'use strict';

	/**
  * Checks if a DOM element is visible. Takes into
  * consideration its parents and overflow.
  *
  * @param (el)      the DOM element to check if is visible
  *
  * These params are optional that are sent in recursively,
  * you typically won't use these:
  *
  * @param (t)       Top corner position number
  * @param (r)       Right corner position number
  * @param (b)       Bottom corner position number
  * @param (l)       Left corner position number
  * @param (w)       Element width number
  * @param (h)       Element height number
  */

	function _isVisible(el, t, r, b, l, w, h) {
		var p = el.parentNode,
		    VISIBLE_PADDING = 2;

		if (!_elementInDocument(el)) {
			return false;
		}

		//-- Return true for document node
		if (9 === p.nodeType) {
			return true;
		}

		//-- Return false if our element is invisible
		if ('0' === _getStyle(el, 'opacity') || 'none' === _getStyle(el, 'display') || 'hidden' === _getStyle(el, 'visibility')) {
			return false;
		}

		if ('undefined' === typeof t || 'undefined' === typeof r || 'undefined' === typeof b || 'undefined' === typeof l || 'undefined' === typeof w || 'undefined' === typeof h) {
			t = el.offsetTop;
			l = el.offsetLeft;
			b = t + el.offsetHeight;
			r = l + el.offsetWidth;
			w = el.offsetWidth;
			h = el.offsetHeight;
		}
		//-- If we have a parent, let's continue:
		if (p) {
			//-- Check if the parent can hide its children.
			if ('hidden' === _getStyle(p, 'overflow') || 'scroll' === _getStyle(p, 'overflow')) {
				//-- Only check if the offset is different for the parent
				if (
				//-- If the target element is to the right of the parent elm
				l + VISIBLE_PADDING > p.offsetWidth + p.scrollLeft ||
				//-- If the target element is to the left of the parent elm
				l + w - VISIBLE_PADDING < p.scrollLeft ||
				//-- If the target element is under the parent elm
				t + VISIBLE_PADDING > p.offsetHeight + p.scrollTop ||
				//-- If the target element is above the parent elm
				t + h - VISIBLE_PADDING < p.scrollTop) {
					//-- Our target element is out of bounds:
					return false;
				}
			}
			//-- Add the offset parent's left/top coords to our element's offset:
			if (el.offsetParent === p) {
				l += p.offsetLeft;
				t += p.offsetTop;
			}
			//-- Let's recursively check upwards:
			return _isVisible(p, t, r, b, l, w, h);
		}
		return true;
	}

	//-- Cross browser method to get style properties:
	function _getStyle(el, property) {
		if (window.getComputedStyle) {
			return document.defaultView.getComputedStyle(el, null)[property];
		}
		if (el.currentStyle) {
			return el.currentStyle[property];
		}
	}

	function _elementInDocument(element) {
		while (element = element.parentNode) {
			if (element == document) {
				return true;
			}
		}
		return false;
	}

	return _isVisible(this);
};

/**
 * NonDocumentTypeChildNode.previousElementSibling
 * Polyfill for Internet Explorer 9+ and Safari
 *
 * Source: https://github.com/jserz/js_piece/blob/master/DOM/NonDocumentTypeChildNode/previousElementSibling/previousElementSibling.md
 */
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('previousElementSibling')) {
			return;
		}
		Object.defineProperty(item, 'previousElementSibling', {
			configurable: true,
			enumerable: true,
			get: function get$$1() {
				var el = this;
				while (el = el.previousSibling) {
					if (el.nodeType === 1) {
						return el;
					}
				}
				return null;
			},
			set: undefined
		});
	});
})([Element.prototype, CharacterData.prototype]);

/**
 * TRIM METHODS
 *
 * https://www.sitepoint.com/trimming-strings-in-javascript/
 */
String.prototype.ltrim = function (charlist) {
	if (charlist === undefined) {
		charlist = "\s";
	}

	return this.replace(new RegExp("^[" + charlist + "]+"), "");
};

String.prototype.rtrim = function (charlist) {
	if (charlist === undefined) {
		charlist = "\s";
	}

	return this.replace(new RegExp("[" + charlist + "]+$"), "");
};

/*******
 *
 * polyfill for asign
 *
 *
 */

if (typeof Object.assign != 'function') {
	Object.assign = function (target) {
		'use strict';

		if (target == null) {
			throw new TypeError('Cannot convert undefined or null to object');
		}

		target = Object(target);
		for (var index = 1; index < arguments.length; index++) {
			var source = arguments[index];
			if (source != null) {
				for (var key in source) {
					if (Object.prototype.hasOwnProperty.call(source, key)) {
						target[key] = source[key];
					}
				}
			}
		}
		return target;
	};
}

/**
 *	polyfill for IE picuter
 *
 */

/*
 PicturePolyfill
 Responsive Images that work today (and mimic the proposed Picture element with span elements)
 Author: Andrea Verlicchi
 License: MIT/GPLv2
 Please "/dist/picturePolyfill.min.js" for production purposes
 */
/*! Picturefill - v2.3.1 - 2015-04-09
* http://scottjehl.github.io/picturefill
* Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT */
/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */

window.matchMedia || (window.matchMedia = function () {
	"use strict";

	// For browsers that support matchMedium api such as IE 9 and webkit

	var styleMedia = window.styleMedia || window.media;

	// For those that don't support matchMedium
	if (!styleMedia) {
		var style = document.createElement('style'),
		    script = document.getElementsByTagName('script')[0],
		    info = null;

		style.type = 'text/css';
		style.id = 'matchmediajs-test';

		script.parentNode.insertBefore(style, script);

		// 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
		info = 'getComputedStyle' in window && window.getComputedStyle(style, null) || style.currentStyle;

		styleMedia = {
			matchMedium: function matchMedium(media) {
				var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

				// 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
				if (style.styleSheet) {
					style.styleSheet.cssText = text;
				} else {
					style.textContent = text;
				}

				// Test if media query is true or false
				return info.width === '1px';
			}
		};
	}

	return function (media) {
		return {
			matches: styleMedia.matchMedium(media || 'all'),
			media: media || 'all'
		};
	};
}());
/*! Picturefill - Responsive Images that work today.
*  Author: Scott Jehl, Filament Group, 2012 ( new proposal implemented by Shawn Jansepar )
*  License: MIT/GPLv2
*  Spec: http://picture.responsiveimages.org/
*/
(function (w, doc, image) {
	// Enable strict mode
	"use strict";

	function expose(picturefill) {
		/* expose picturefill */
		if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {
			// CommonJS, just export
			module.exports = picturefill;
		} else if (typeof define === "function" && define.amd) {
			// AMD support
			define("picturefill", function () {
				return picturefill;
			});
		}
		if ((typeof w === "undefined" ? "undefined" : _typeof(w)) === "object") {
			// If no AMD and we are in the browser, attach to window
			w.picturefill = picturefill;
		}
	}

	// If picture is supported, well, that's awesome. Let's get outta here...
	if (w.HTMLPictureElement) {
		expose(function () {});
		return;
	}

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	doc.createElement("picture");

	// local object for method references and testing exposure
	var pf = w.picturefill || {};

	var regWDesc = /\s+\+?\d+(e\d+)?w/;

	// namespace
	pf.ns = "picturefill";

	// srcset support test
	(function () {
		pf.srcsetSupported = "srcset" in image;
		pf.sizesSupported = "sizes" in image;
		pf.curSrcSupported = "currentSrc" in image;
	})();

	// just a string trim workaround
	pf.trim = function (str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
	};

	/**
  * Gets a string and returns the absolute URL
  * @param src
  * @returns {String} absolute URL
  */
	pf.makeUrl = function () {
		var anchor = doc.createElement("a");
		return function (src) {
			anchor.href = src;
			return anchor.href;
		};
	}();

	/**
  * Shortcut method for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
  */
	pf.restrictsMixedContent = function () {
		return w.location.protocol === "https:";
	};
	/**
  * Shortcut method for matchMedia ( for easy overriding in tests )
  */

	pf.matchesMedia = function (media) {
		return w.matchMedia && w.matchMedia(media).matches;
	};

	// Shortcut method for `devicePixelRatio` ( for easy overriding in tests )
	pf.getDpr = function () {
		return w.devicePixelRatio || 1;
	};

	/**
  * Get width in css pixel value from a "length" value
  * http://dev.w3.org/csswg/css-values-3/#length-value
  */
	pf.getWidthFromLength = function (length) {
		var cssValue;
		// If a length is specified and doesn’t contain a percentage, and it is greater than 0 or using `calc`, use it. Else, abort.
		if (!(length && length.indexOf("%") > -1 === false && (parseFloat(length) > 0 || length.indexOf("calc(") > -1))) {
			return false;
		}

		/**
   * If length is specified in  `vw` units, use `%` instead since the div we’re measuring
   * is injected at the top of the document.
   *
   * TODO: maybe we should put this behind a feature test for `vw`? The risk of doing this is possible browser inconsistancies with vw vs %
   */
		length = length.replace("vw", "%");

		// Create a cached element for getting length value widths
		if (!pf.lengthEl) {
			pf.lengthEl = doc.createElement("div");

			// Positioning styles help prevent padding/margin/width on `html` or `body` from throwing calculations off.
			pf.lengthEl.style.cssText = "border:0;display:block;font-size:1em;left:0;margin:0;padding:0;position:absolute;visibility:hidden";

			// Add a class, so that everyone knows where this element comes from
			pf.lengthEl.className = "helper-from-picturefill-js";
		}

		pf.lengthEl.style.width = "0px";

		try {
			pf.lengthEl.style.width = length;
		} catch (e) {}

		doc.body.appendChild(pf.lengthEl);

		cssValue = pf.lengthEl.offsetWidth;

		if (cssValue <= 0) {
			cssValue = false;
		}

		doc.body.removeChild(pf.lengthEl);

		return cssValue;
	};

	pf.detectTypeSupport = function (type, typeUri) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new w.Image();
		image.onerror = function () {
			pf.types[type] = false;
			picturefill();
		};
		image.onload = function () {
			pf.types[type] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;

		return "pending";
	};
	// container of supported mime types that one might need to qualify before using
	pf.types = pf.types || {};

	pf.initTypeDetects = function () {
		// Add support for standard mime types
		pf.types["image/jpeg"] = true;
		pf.types["image/gif"] = true;
		pf.types["image/png"] = true;
		pf.types["image/svg+xml"] = doc.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1");
		pf.types["image/webp"] = pf.detectTypeSupport("image/webp", "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=");
	};

	pf.verifyTypeSupport = function (source) {
		var type = source.getAttribute("type");
		// if type attribute exists, return test result, otherwise return true
		if (type === null || type === "") {
			return true;
		} else {
			var pfType = pf.types[type];
			// if the type test is a function, run it and return "pending" status. The function will rerun picturefill on pending elements once finished.
			if (typeof pfType === "string" && pfType !== "pending") {
				pf.types[type] = pf.detectTypeSupport(type, pfType);
				return "pending";
			} else if (typeof pfType === "function") {
				pfType();
				return "pending";
			} else {
				return pfType;
			}
		}
	};

	// Parses an individual `size` and returns the length, and optional media query
	pf.parseSize = function (sourceSizeStr) {
		var match = /(\([^)]+\))?\s*(.+)/g.exec(sourceSizeStr);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	};

	// Takes a string of sizes and returns the width in pixels as a number
	pf.findWidthFromSourceSize = function (sourceSizeListStr) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//                            or (min-width:30em) calc(30% - 15px)
		var sourceSizeList = pf.trim(sourceSizeListStr).split(/\s*,\s*/),
		    winningLength;

		for (var i = 0, len = sourceSizeList.length; i < len; i++) {
			// Match <media-condition>? length, ie ( min-width: 50em ) 100%
			var sourceSize = sourceSizeList[i],

			// Split "( min-width: 50em ) 100%" into separate strings
			parsedSize = pf.parseSize(sourceSize),
			    length = parsedSize.length,
			    media = parsedSize.media;

			if (!length) {
				continue;
			}
			// if there is no media query or it matches, choose this as our winning length
			if ((!media || pf.matchesMedia(media)) && (
			// pass the length to a method that can properly determine length
			// in pixels based on these formats: http://dev.w3.org/csswg/css-values-3/#length-value
			winningLength = pf.getWidthFromLength(length))) {
				break;
			}
		}

		//if we have no winningLength fallback to 100vw
		return winningLength || Math.max(w.innerWidth || 0, doc.documentElement.clientWidth);
	};

	pf.parseSrcset = function (srcset) {
		/**
   * A lot of this was pulled from Boris Smus’ parser for the now-defunct WHATWG `srcset`
   * https://github.com/borismus/srcset-polyfill/blob/master/js/srcset-info.js
   *
   * 1. Let input (`srcset`) be the value passed to this algorithm.
   * 2. Let position be a pointer into input, initially pointing at the start of the string.
   * 3. Let raw candidates be an initially empty ordered list of URLs with associated
   *    unparsed descriptors. The order of entries in the list is the order in which entries
   *    are added to the list.
   */
		var candidates = [];

		while (srcset !== "") {
			srcset = srcset.replace(/^\s+/g, "");

			// 5. Collect a sequence of characters that are not space characters, and let that be url.
			var pos = srcset.search(/\s/g),
			    url,
			    descriptor = null;

			if (pos !== -1) {
				url = srcset.slice(0, pos);

				var last = url.slice(-1);

				// 6. If url ends with a U+002C COMMA character (,), remove that character from url
				// and let descriptors be the empty string. Otherwise, follow these substeps
				// 6.1. If url is empty, then jump to the step labeled descriptor parser.

				if (last === "," || url === "") {
					url = url.replace(/,+$/, "");
					descriptor = "";
				}
				srcset = srcset.slice(pos + 1);

				// 6.2. Collect a sequence of characters that are not U+002C COMMA characters (,), and
				// let that be descriptors.
				if (descriptor === null) {
					var descpos = srcset.indexOf(",");
					if (descpos !== -1) {
						descriptor = srcset.slice(0, descpos);
						srcset = srcset.slice(descpos + 1);
					} else {
						descriptor = srcset;
						srcset = "";
					}
				}
			} else {
				url = srcset;
				srcset = "";
			}

			// 7. Add url to raw candidates, associated with descriptors.
			if (url || descriptor) {
				candidates.push({
					url: url,
					descriptor: descriptor
				});
			}
		}
		return candidates;
	};

	pf.parseDescriptor = function (descriptor, sizesattr) {
		// 11. Descriptor parser: Let candidates be an initially empty source set. The order of entries in the list
		// is the order in which entries are added to the list.
		var sizes = sizesattr || "100vw",
		    sizeDescriptor = descriptor && descriptor.replace(/(^\s+|\s+$)/g, ""),
		    widthInCssPixels = pf.findWidthFromSourceSize(sizes),
		    resCandidate;

		if (sizeDescriptor) {
			var splitDescriptor = sizeDescriptor.split(" ");

			for (var i = splitDescriptor.length - 1; i >= 0; i--) {
				var curr = splitDescriptor[i],
				    lastchar = curr && curr.slice(curr.length - 1);

				if ((lastchar === "h" || lastchar === "w") && !pf.sizesSupported) {
					resCandidate = parseFloat(parseInt(curr, 10) / widthInCssPixels);
				} else if (lastchar === "x") {
					var res = curr && parseFloat(curr, 10);
					resCandidate = res && !isNaN(res) ? res : 1;
				}
			}
		}
		return resCandidate || 1;
	};

	/**
  * Takes a srcset in the form of url/
  * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
  *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
  *     "images/pic-small.png"
  * Get an array of image candidates in the form of
  *      {url: "/foo/bar.png", resolution: 1}
  * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
  * If sizes is specified, resolution is calculated
  */
	pf.getCandidatesFromSourceSet = function (srcset, sizes) {
		var candidates = pf.parseSrcset(srcset),
		    formattedCandidates = [];

		for (var i = 0, len = candidates.length; i < len; i++) {
			var candidate = candidates[i];

			formattedCandidates.push({
				url: candidate.url,
				resolution: pf.parseDescriptor(candidate.descriptor, sizes)
			});
		}
		return formattedCandidates;
	};

	/**
  * if it's an img element and it has a srcset property,
  * we need to remove the attribute so we can manipulate src
  * (the property's existence infers native srcset support, and a srcset-supporting browser will prioritize srcset's value over our winning picture candidate)
  * this moves srcset's value to memory for later use and removes the attr
  */
	pf.dodgeSrcset = function (img) {
		if (img.srcset) {
			img[pf.ns].srcset = img.srcset;
			img.srcset = "";
			img.setAttribute("data-pfsrcset", img[pf.ns].srcset);
		}
	};

	// Accept a source or img element and process its srcset and sizes attrs
	pf.processSourceSet = function (el) {
		var srcset = el.getAttribute("srcset"),
		    sizes = el.getAttribute("sizes"),
		    candidates = [];

		// if it's an img element, use the cached srcset property (defined or not)
		if (el.nodeName.toUpperCase() === "IMG" && el[pf.ns] && el[pf.ns].srcset) {
			srcset = el[pf.ns].srcset;
		}

		if (srcset) {
			candidates = pf.getCandidatesFromSourceSet(srcset, sizes);
		}
		return candidates;
	};

	pf.backfaceVisibilityFix = function (picImg) {
		// See: https://github.com/scottjehl/picturefill/issues/332
		var style = picImg.style || {},
		    WebkitBackfaceVisibility = "webkitBackfaceVisibility" in style,
		    currentZoom = style.zoom;

		if (WebkitBackfaceVisibility) {
			style.zoom = ".999";

			WebkitBackfaceVisibility = picImg.offsetWidth;

			style.zoom = currentZoom;
		}
	};

	pf.setIntrinsicSize = function () {
		var urlCache = {};
		var setSize = function setSize(picImg, width, res) {
			if (width) {
				picImg.setAttribute("width", parseInt(width / res, 10));
			}
		};
		return function (picImg, bestCandidate) {
			var img;
			if (!picImg[pf.ns] || w.pfStopIntrinsicSize) {
				return;
			}
			if (picImg[pf.ns].dims === undefined) {
				picImg[pf.ns].dims = picImg.getAttribute("width") || picImg.getAttribute("height");
			}
			if (picImg[pf.ns].dims) {
				return;
			}

			if (bestCandidate.url in urlCache) {
				setSize(picImg, urlCache[bestCandidate.url], bestCandidate.resolution);
			} else {
				img = doc.createElement("img");
				img.onload = function () {
					urlCache[bestCandidate.url] = img.width;

					//IE 10/11 don't calculate width for svg outside document
					if (!urlCache[bestCandidate.url]) {
						try {
							doc.body.appendChild(img);
							urlCache[bestCandidate.url] = img.width || img.offsetWidth;
							doc.body.removeChild(img);
						} catch (e) {}
					}

					if (picImg.src === bestCandidate.url) {
						setSize(picImg, urlCache[bestCandidate.url], bestCandidate.resolution);
					}
					picImg = null;
					img.onload = null;
					img = null;
				};
				img.src = bestCandidate.url;
			}
		};
	}();

	pf.applyBestCandidate = function (candidates, picImg) {
		var candidate, length, bestCandidate;

		candidates.sort(pf.ascendingSort);

		length = candidates.length;
		bestCandidate = candidates[length - 1];

		for (var i = 0; i < length; i++) {
			candidate = candidates[i];
			if (candidate.resolution >= pf.getDpr()) {
				bestCandidate = candidate;
				break;
			}
		}

		if (bestCandidate) {

			bestCandidate.url = pf.makeUrl(bestCandidate.url);

			if (picImg.src !== bestCandidate.url) {
				if (pf.restrictsMixedContent() && bestCandidate.url.substr(0, "http:".length).toLowerCase() === "http:") {
					if (window.console !== undefined) {
						console.warn("Blocked mixed content image " + bestCandidate.url);
					}
				} else {
					picImg.src = bestCandidate.url;
					// currentSrc attribute and property to match
					// http://picture.responsiveimages.org/#the-img-element
					if (!pf.curSrcSupported) {
						picImg.currentSrc = picImg.src;
					}

					pf.backfaceVisibilityFix(picImg);
				}
			}

			pf.setIntrinsicSize(picImg, bestCandidate);
		}
	};

	pf.ascendingSort = function (a, b) {
		return a.resolution - b.resolution;
	};

	/**
  * In IE9, <source> elements get removed if they aren't children of
  * video elements. Thus, we conditionally wrap source elements
  * using <!--[if IE 9]><video style="display: none;"><![endif]-->
  * and must account for that here by moving those source elements
  * back into the picture element.
  */
	pf.removeVideoShim = function (picture) {
		var videos = picture.getElementsByTagName("video");
		if (videos.length) {
			var video = videos[0],
			    vsources = video.getElementsByTagName("source");
			while (vsources.length) {
				picture.insertBefore(vsources[0], video);
			}
			// Remove the video element once we're finished removing its children
			video.parentNode.removeChild(video);
		}
	};

	/**
  * Find all `img` elements, and add them to the candidate list if they have
  * a `picture` parent, a `sizes` attribute in basic `srcset` supporting browsers,
  * a `srcset` attribute at all, and they haven’t been evaluated already.
  */
	pf.getAllElements = function () {
		var elems = [],
		    imgs = doc.getElementsByTagName("img");

		for (var h = 0, len = imgs.length; h < len; h++) {
			var currImg = imgs[h];

			if (currImg.parentNode.nodeName.toUpperCase() === "PICTURE" || currImg.getAttribute("srcset") !== null || currImg[pf.ns] && currImg[pf.ns].srcset !== null) {
				elems.push(currImg);
			}
		}
		return elems;
	};

	pf.getMatch = function (img, picture) {
		var sources = picture.childNodes,
		    match;

		// Go through each child, and if they have media queries, evaluate them
		for (var j = 0, slen = sources.length; j < slen; j++) {
			var source = sources[j];

			// ignore non-element nodes
			if (source.nodeType !== 1) {
				continue;
			}

			// Hitting the `img` element that started everything stops the search for `sources`.
			// If no previous `source` matches, the `img` itself is evaluated later.
			if (source === img) {
				return match;
			}

			// ignore non-`source` nodes
			if (source.nodeName.toUpperCase() !== "SOURCE") {
				continue;
			}
			// if it's a source element that has the `src` property set, throw a warning in the console
			if (source.getAttribute("src") !== null && (typeof console === "undefined" ? "undefined" : _typeof(console)) !== undefined) {
				console.warn("The `src` attribute is invalid on `picture` `source` element; instead, use `srcset`.");
			}

			var media = source.getAttribute("media");

			// if source does not have a srcset attribute, skip
			if (!source.getAttribute("srcset")) {
				continue;
			}

			// if there's no media specified, OR w.matchMedia is supported
			if (!media || pf.matchesMedia(media)) {
				var typeSupported = pf.verifyTypeSupport(source);

				if (typeSupported === true) {
					match = source;
					break;
				} else if (typeSupported === "pending") {
					return false;
				}
			}
		}

		return match;
	};

	function picturefill(opt) {
		var elements,
		    element,
		    parent,
		    firstMatch,
		    candidates,
		    options = opt || {};

		elements = options.elements || pf.getAllElements();

		// Loop through all elements
		for (var i = 0, plen = elements.length; i < plen; i++) {
			element = elements[i];
			parent = element.parentNode;
			firstMatch = undefined;
			candidates = undefined;

			// immediately skip non-`img` nodes
			if (element.nodeName.toUpperCase() !== "IMG") {
				continue;
			}

			// expando for caching data on the img
			if (!element[pf.ns]) {
				element[pf.ns] = {};
			}

			// if the element has already been evaluated, skip it unless
			// `options.reevaluate` is set to true ( this, for example,
			// is set to true when running `picturefill` on `resize` ).
			if (!options.reevaluate && element[pf.ns].evaluated) {
				continue;
			}

			// if `img` is in a `picture` element
			if (parent && parent.nodeName.toUpperCase() === "PICTURE") {

				// IE9 video workaround
				pf.removeVideoShim(parent);

				// return the first match which might undefined
				// returns false if there is a pending source
				// TODO the return type here is brutal, cleanup
				firstMatch = pf.getMatch(element, parent);

				// if any sources are pending in this picture due to async type test(s)
				// remove the evaluated attr and skip for now ( the pending test will
				// rerun picturefill on this element when complete)
				if (firstMatch === false) {
					continue;
				}
			} else {
				firstMatch = undefined;
			}

			// Cache and remove `srcset` if present and we’re going to be doing `picture`/`srcset`/`sizes` polyfilling to it.
			if (parent && parent.nodeName.toUpperCase() === "PICTURE" || !pf.sizesSupported && element.srcset && regWDesc.test(element.srcset)) {
				pf.dodgeSrcset(element);
			}

			if (firstMatch) {
				candidates = pf.processSourceSet(firstMatch);
				pf.applyBestCandidate(candidates, element);
			} else {
				// No sources matched, so we’re down to processing the inner `img` as a source.
				candidates = pf.processSourceSet(element);

				if (element.srcset === undefined || element[pf.ns].srcset) {
					// Either `srcset` is completely unsupported, or we need to polyfill `sizes` functionality.
					pf.applyBestCandidate(candidates, element);
				} // Else, resolution-only `srcset` is supported natively.
			}

			// set evaluated to true to avoid unnecessary reparsing
			element[pf.ns].evaluated = true;
		}
	}

	/**
  * Sets up picture polyfill by polling the document and running
  * the polyfill every 250ms until the document is ready.
  * Also attaches picturefill on resize
  */
	function runPicturefill() {
		pf.initTypeDetects();
		picturefill();
		var intervalId = setInterval(function () {
			// When the document has finished loading, stop checking for new images
			// https://github.com/ded/domready/blob/master/ready.js#L15
			picturefill();

			if (/^loaded|^i|^c/.test(doc.readyState)) {
				clearInterval(intervalId);
				return;
			}
		}, 250);

		var resizeTimer;
		var handleResize = function handleResize() {
			picturefill({ reevaluate: true });
		};
		function checkResize() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(handleResize, 60);
		}

		if (w.addEventListener) {
			w.addEventListener("resize", checkResize, false);
		} else if (w.attachEvent) {
			w.attachEvent("onresize", checkResize);
		}
	}

	runPicturefill();

	/* expose methods for testing */
	picturefill._ = pf;

	expose(picturefill);
})(window, window.document, new window.Image());

/**
 *
 * Prepend polyfill
 *
 */

(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('prepend')) {
			return;
		}
		Object.defineProperty(item, 'prepend', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function prepend() {
				var argArr = Array.prototype.slice.call(arguments),
				    docFrag = document.createDocumentFragment();

				argArr.forEach(function (argItem) {
					var isNode = argItem instanceof Node;
					docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
				});

				this.insertBefore(docFrag, this.firstChild);
			}
		});
	});
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

// polyfill
function polyfill() {
	// aliases
	var w = window;
	var d = document;

	// return if scroll behavior is supported and polyfill is not forced
	if ('scrollBehavior' in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) {
		return;
	}

	// globals
	var Element = w.HTMLElement || w.Element;
	var SCROLL_TIME = 468;

	// object gathering original scroll methods
	var original = {
		scroll: w.scroll || w.scrollTo,
		scrollBy: w.scrollBy,
		elementScroll: Element.prototype.scroll || scrollElement,
		scrollIntoView: Element.prototype.scrollIntoView
	};

	// define timing method
	var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;

	/**
  * indicates if a the current browser is made by Microsoft
  * @method isMicrosoftBrowser
  * @param {String} userAgent
  * @returns {Boolean}
  */
	function isMicrosoftBrowser(userAgent) {
		var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

		return new RegExp(userAgentPatterns.join('|')).test(userAgent);
	}

	/*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
	var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

	/**
  * changes scroll position inside an element
  * @method scrollElement
  * @param {Number} x
  * @param {Number} y
  * @returns {undefined}
  */
	function scrollElement(x, y) {
		this.scrollLeft = x;
		this.scrollTop = y;
	}

	/**
  * returns result of applying ease math function to a number
  * @method ease
  * @param {Number} k
  * @returns {Number}
  */
	function ease(k) {
		return 0.5 * (1 - Math.cos(Math.PI * k));
	}

	/**
  * indicates if a smooth behavior should be applied
  * @method shouldBailOut
  * @param {Number|Object} firstArg
  * @returns {Boolean}
  */
	function shouldBailOut(firstArg) {
		if (firstArg === null || (typeof firstArg === 'undefined' ? 'undefined' : _typeof(firstArg)) !== 'object' || firstArg.behavior === undefined || firstArg.behavior === 'auto' || firstArg.behavior === 'instant') {
			// first argument is not an object/null
			// or behavior is auto, instant or undefined
			return true;
		}

		if ((typeof firstArg === 'undefined' ? 'undefined' : _typeof(firstArg)) === 'object' && firstArg.behavior === 'smooth') {
			// first argument is an object and behavior is smooth
			return false;
		}

		// throw error when behavior is not supported
		throw new TypeError('behavior member of ScrollOptions ' + firstArg.behavior + ' is not a valid value for enumeration ScrollBehavior.');
	}

	/**
  * indicates if an element has scrollable space in the provided axis
  * @method hasScrollableSpace
  * @param {Node} el
  * @param {String} axis
  * @returns {Boolean}
  */
	function hasScrollableSpace(el, axis) {
		if (axis === 'Y') {
			return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
		}

		if (axis === 'X') {
			return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
		}
	}

	/**
  * indicates if an element has a scrollable overflow property in the axis
  * @method canOverflow
  * @param {Node} el
  * @param {String} axis
  * @returns {Boolean}
  */
	function canOverflow(el, axis) {
		var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

		return overflowValue === 'auto' || overflowValue === 'scroll';
	}

	/**
  * indicates if an element can be scrolled in either axis
  * @method isScrollable
  * @param {Node} el
  * @param {String} axis
  * @returns {Boolean}
  */
	function isScrollable(el) {
		var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
		var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

		return isScrollableY || isScrollableX;
	}

	/**
  * finds scrollable parent of an element
  * @method findScrollableParent
  * @param {Node} el
  * @returns {Node} el
  */
	function findScrollableParent(el) {
		while (el !== d.body && isScrollable(el) === false) {
			el = el.parentNode || el.host;
		}

		return el;
	}

	/**
  * self invoked function that, given a context, steps through scrolling
  * @method step
  * @param {Object} context
  * @returns {undefined}
  */
	function step(context) {
		var time = now();
		var value;
		var currentX;
		var currentY;
		var elapsed = (time - context.startTime) / SCROLL_TIME;

		// avoid elapsed times higher than one
		elapsed = elapsed > 1 ? 1 : elapsed;

		// apply easing to elapsed time
		value = ease(elapsed);

		currentX = context.startX + (context.x - context.startX) * value;
		currentY = context.startY + (context.y - context.startY) * value;

		context.method.call(context.scrollable, currentX, currentY);

		// scroll more if we have not reached our destination
		if (currentX !== context.x || currentY !== context.y) {
			w.requestAnimationFrame(step.bind(w, context));
		}
	}

	/**
  * scrolls window or element with a smooth behavior
  * @method smoothScroll
  * @param {Object|Node} el
  * @param {Number} x
  * @param {Number} y
  * @returns {undefined}
  */
	function smoothScroll(el, x, y) {
		var scrollable;
		var startX;
		var startY;
		var method;
		var startTime = now();

		// define scroll context
		if (el === d.body) {
			scrollable = w;
			startX = w.scrollX || w.pageXOffset;
			startY = w.scrollY || w.pageYOffset;
			method = original.scroll;
		} else {
			scrollable = el;
			startX = el.scrollLeft;
			startY = el.scrollTop;
			method = scrollElement;
		}

		// scroll looping over a frame
		step({
			scrollable: scrollable,
			method: method,
			startTime: startTime,
			startX: startX,
			startY: startY,
			x: x,
			y: y
		});
	}

	// ORIGINAL METHODS OVERRIDES
	// w.scroll and w.scrollTo
	w.scroll = w.scrollTo = function () {
		// avoid action when no arguments are passed
		if (arguments[0] === undefined) {
			return;
		}

		// avoid smooth behavior if not required
		if (shouldBailOut(arguments[0]) === true) {
			original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : _typeof(arguments[0]) !== 'object' ? arguments[0] : w.scrollX || w.pageXOffset,
			// use top prop, second argument if present or fallback to scrollY
			arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);

			return;
		}

		// LET THE SMOOTHNESS BEGIN!
		smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
	};

	// w.scrollBy
	w.scrollBy = function () {
		// avoid action when no arguments are passed
		if (arguments[0] === undefined) {
			return;
		}

		// avoid smooth behavior if not required
		if (shouldBailOut(arguments[0])) {
			original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : _typeof(arguments[0]) !== 'object' ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);

			return;
		}

		// LET THE SMOOTHNESS BEGIN!
		smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
	};

	// Element.prototype.scroll and Element.prototype.scrollTo
	Element.prototype.scroll = Element.prototype.scrollTo = function () {
		// avoid action when no arguments are passed
		if (arguments[0] === undefined) {
			return;
		}

		// avoid smooth behavior if not required
		if (shouldBailOut(arguments[0]) === true) {
			// if one number is passed, throw error to match Firefox implementation
			if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
				throw new SyntaxError('Value could not be converted');
			}

			original.elementScroll.call(this,
			// use left prop, first number argument or fallback to scrollLeft
			arguments[0].left !== undefined ? ~~arguments[0].left : _typeof(arguments[0]) !== 'object' ? ~~arguments[0] : this.scrollLeft,
			// use top prop, second argument or fallback to scrollTop
			arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);

			return;
		}

		var left = arguments[0].left;
		var top = arguments[0].top;

		// LET THE SMOOTHNESS BEGIN!
		smoothScroll.call(this, this, typeof left === 'undefined' ? this.scrollLeft : ~~left, typeof top === 'undefined' ? this.scrollTop : ~~top);
	};

	// Element.prototype.scrollBy
	Element.prototype.scrollBy = function () {
		// avoid action when no arguments are passed
		if (arguments[0] === undefined) {
			return;
		}

		// avoid smooth behavior if not required
		if (shouldBailOut(arguments[0]) === true) {
			original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);

			return;
		}

		this.scroll({
			left: ~~arguments[0].left + this.scrollLeft,
			top: ~~arguments[0].top + this.scrollTop,
			behavior: arguments[0].behavior
		});
	};

	// Element.prototype.scrollIntoView
	Element.prototype.scrollIntoView = function () {
		// avoid smooth behavior if not required
		if (shouldBailOut(arguments[0]) === true) {
			original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);

			return;
		}

		// LET THE SMOOTHNESS BEGIN!
		var scrollableParent = findScrollableParent(this);
		var parentRects = scrollableParent.getBoundingClientRect();
		var clientRects = this.getBoundingClientRect();

		if (scrollableParent !== d.body) {
			// reveal element inside parent
			smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);

			// reveal parent in viewport unless is fixed
			if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
				w.scrollBy({
					left: parentRects.left,
					top: parentRects.top,
					behavior: 'smooth'
				});
			}
		} else {
			// reveal element in viewport
			w.scrollBy({
				left: clientRects.left,
				top: clientRects.top,
				behavior: 'smooth'
			});
		}
	};
}

if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined') {
	// commonjs
	module.exports = { polyfill: polyfill };
} else {
	// global
	polyfill();
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}

/*!
 * GSAP 3.7.1
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
};
var _defaults = {
  duration: .5,
  overwrite: false,
  delay: 0
};
var _suppressOverwrites;
var _bigNum = 1e8;
var _tinyNum = 1 / _bigNum;
var _2PI = Math.PI * 2;
var _HALF_PI = _2PI / 4;
var _gsID = 0;
var _sqrt = Math.sqrt;
var _cos = Math.cos;
var _sin = Math.sin;
var _isString = function _isString(value) {
  return typeof value === "string";
};
var _isFunction = function _isFunction(value) {
  return typeof value === "function";
};
var _isNumber = function _isNumber(value) {
  return typeof value === "number";
};
var _isUndefined = function _isUndefined(value) {
  return typeof value === "undefined";
};
var _isObject = function _isObject(value) {
  return (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object";
};
var _isNotFalse = function _isNotFalse(value) {
  return value !== false;
};
var _windowExists = function _windowExists() {
  return typeof window !== "undefined";
};
var _isFuncOrString = function _isFuncOrString(value) {
  return _isFunction(value) || _isString(value);
};
var _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {};
var _isArray = Array.isArray;
var _strictNumExp = /(?:-?\.?\d|\.)+/gi;
var _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g;
var _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g;
var _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi;
var _relExp = /[+-]=-?[.\d]+/;
var _delimitedValueExp = /[^,'"\[\]\s]+/gi;
var _unitExp = /[\d.+\-=]+(?:e[-+]\d*)*/i;
var _globalTimeline;
var _win;
var _coreInitted;
var _doc;
var _globals = {};
var _installScope = {};
var _coreReady;
var _install = function _install(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
};
var _missingPlugin = function _missingPlugin(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
};
var _warn = function _warn(message, suppress) {
  return !suppress && console.warn(message);
};
var _addGlobal = function _addGlobal(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
};
var _emptyFunc = function _emptyFunc() {
  return 0;
};
var _reservedProps = {};
var _lazyTweens = [];
var _lazyLookup = {};
var _lastRenderedFrame;
var _plugins = {};
var _effects = {};
var _nextGCFrame = 30;
var _harnessPlugins = [];
var _callbackNames = "";
var _harness = function _harness(targets) {
  var target = targets[0],
      harnessPlugin,
      i;
  _isObject(target) || _isFunction(target) || (targets = [targets]);

  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
    i = _harnessPlugins.length;

    while (i-- && !_harnessPlugins[i].targetTest(target)) {}

    harnessPlugin = _harnessPlugins[i];
  }

  i = targets.length;

  while (i--) {
    targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
  }

  return targets;
};
var _getCache = function _getCache(target) {
  return target._gsap || _harness(toArray$1(target))[0]._gsap;
};
var _getProperty = function _getProperty(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
};
var _forEachName = function _forEachName(names, func) {
  return (names = names.split(",")).forEach(func) || names;
};
var _round = function _round(value) {
  return Math.round(value * 100000) / 100000 || 0;
};
var _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
  //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
  var l = toFind.length,
      i = 0;

  for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

  return i < l;
};
var _lazyRender = function _lazyRender() {
  var l = _lazyTweens.length,
      a = _lazyTweens.slice(0),
      i,
      tween;

  _lazyLookup = {};
  _lazyTweens.length = 0;

  for (i = 0; i < l; i++) {
    tween = a[i];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
};
var _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
  _lazyTweens.length && _lazyRender();
  animation.render(time, suppressEvents, force);
  _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
};
var _numericIfPossible = function _numericIfPossible(value) {
  var n = parseFloat(value);
  return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
};
var _passThrough = function _passThrough(p) {
  return p;
};
var _setDefaults = function _setDefaults(obj, defaults$$1) {
  for (var p in defaults$$1) {
    p in obj || (obj[p] = defaults$$1[p]);
  }

  return obj;
};
var _setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults$$1) {
  for (var p in defaults$$1) {
    p in obj || p === "duration" || p === "ease" || (obj[p] = defaults$$1[p]);
  }
};
var _merge = function _merge(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }

  return base;
};
var _mergeDeep = function _mergeDeep(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }

  return base;
};
var _copyExcluding = function _copyExcluding(obj, excluding) {
  var copy = {},
      p;

  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }

  return copy;
};
var _inheritDefaults = function _inheritDefaults(vars) {
  var parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults : _setDefaults;

  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }

  return vars;
};
var _arraysMatch = function _arraysMatch(a1, a2) {
  var i = a1.length,
      match = i === a2.length;

  while (match && i-- && a1[i] === a2[i]) {}

  return i < 0;
};
var _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = parent[lastProp],
      t;

  if (sortBy) {
    t = child[sortBy];

    while (prev && prev[sortBy] > t) {
      prev = prev._prev;
    }
  }

  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }

  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }

  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
};
var _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = child._prev,
      next = child._next;

  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }

  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }

  child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
};
var _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
  child._act = 0;
};
var _uncache = function _uncache(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
    var a = animation;

    while (a) {
      a._dirty = 1;
      a = a.parent;
    }
  }

  return animation;
};
var _recacheAncestors = function _recacheAncestors(animation) {
  var parent = animation.parent;

  while (parent && parent.parent) {
    //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }

  return animation;
};
var _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
};
var _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
};
var _animationCycle = function _animationCycle(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
};
var _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
};
var _setEnd = function _setEnd(animation) {
  return animation._end = _round(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
};
var _alignPlayhead = function _alignPlayhead(animation, totalTime) {
  // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
  var parent = animation._dp;

  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _round(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

    _setEnd(animation);

    parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
  }

  return animation;
};
var _postAddChecks = function _postAddChecks(timeline, child) {
  var t;

  if (child._time || child._initted && !child._dur) {
    //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
    t = _parentToChildTotalTime(timeline.rawTime(), child);

    if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
      child.render(t, true);
    }
  } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.


  if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
    //in case any of the ancestors had completed but should now be enabled...
    if (timeline._dur < timeline.duration()) {
      t = timeline;

      while (t._dp) {
        t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.

        t = t._dp;
      }
    }

    timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
  }
};
var _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _round((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
  child._end = _round(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

  _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

  _isFromOrFromStart(child) || (timeline._recent = child);
  skipChecks || _postAddChecks(timeline, child);
  return timeline;
};
var _scrollTrigger = function _scrollTrigger(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
};
var _attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
  _initTween(tween, totalTime);

  if (!tween._initted) {
    return 1;
  }

  if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);

    tween._lazy = [totalTime, suppressEvents];
    return 1;
  }
};
var _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
};
var _isFromOrFromStart = function _isFromOrFromStart(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
};
var _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio,
      ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,

  // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
  repeatDelay = tween._rDelay,
      tTime = 0,
      pt,
      iteration,
      prevIteration;

  if (repeatDelay && tween._repeat) {
    // in case there's a zero-duration tween that has a repeat with a repeatDelay
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    prevIteration = _animationCycle(tween._tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

    if (iteration !== prevIteration) {
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }

  if (ratio !== prevRatio || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents)) {
      // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
      return;
    }

    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

    suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.

    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }

    tween._startAt && totalTime < 0 && tween._startAt.render(totalTime, true, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);

      if (!suppressEvents) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
};
var _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
  var child;

  if (time > prevTime) {
    child = animation._first;

    while (child && child._start <= time) {
      if (!child._dur && child.data === "isPause" && child._start > prevTime) {
        return child;
      }

      child = child._next;
    }
  } else {
    child = animation._last;

    while (child && child._start >= time) {
      if (!child._dur && child.data === "isPause" && child._start < prevTime) {
        return child;
      }

      child = child._prev;
    }
  }
};
var _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
  var repeat = animation._repeat,
      dur = _round(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _round(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress && !leavePlayhead ? _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress) : animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
};
var _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
};
var _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
};
var _parsePosition = function _parsePosition(animation, position, percentAnimation) {
  var labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,

  //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
  i,
      offset,
      isPercent;

  if (_isString(position) && (isNaN(position) || position in labels)) {
    //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i = position.indexOf("=");

    if (offset === "<" || offset === ">") {
      i >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }

    if (i < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }

    offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }

    return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
  }

  return position == null ? clippedDuration : +position;
};
var _createTweenType = function _createTweenType(type, params, timeline) {
  var isLegacy = _isNumber(params[1]),
      varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
      vars = params[varsIndex],
      irVars,
      parent;

  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline;

  if (type) {
    irVars = vars;
    parent = timeline;

    while (parent && !("immediateRender" in irVars)) {
      // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }

    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
  }

  return new Tween(params[0], vars, params[varsIndex + 1]);
};
var _conditionalReturn = function _conditionalReturn(value, func) {
  return value || value === 0 ? func(value) : func;
};
var _clamp = function _clamp(min, max, value) {
  return value < min ? min : value > max ? max : value;
};
var getUnit = function getUnit(value) {
  if (typeof value !== "string") {
    return "";
  }

  var v = _unitExp.exec(value);

  return v ? value.substr(v.index + v[0].length) : "";
};
var clamp = function clamp(min, max, value) {
  return _conditionalReturn(value, function (v) {
    return _clamp(min, max, v);
  });
};
var _slice = [].slice;
var _isArrayLike = function _isArrayLike(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
};
var _flatten = function _flatten(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }

  return ar.forEach(function (value) {
    var _accumulator;

    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray$1(value)) : accumulator.push(value);
  }) || accumulator;
};
var toArray$1 = function toArray$$1(value, scope, leaveStrings) {
  return _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
};
var selector = function selector(value) {
  value = toArray$1(value)[0] || _warn("Invalid scope") || {};
  return function (v) {
    var el = value.current || value.nativeElement || value;
    return toArray$1(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
  };
};
var shuffle = function shuffle(a) {
  return a.sort(function () {
    return .5 - Math.random();
  });
};
var distribute = function distribute(v) {
  if (_isFunction(v)) {
    return v;
  }

  var vars = _isObject(v) ? v : {
    each: v
  },

  //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  ease = _parseEase(vars.ease),
      from = vars.from || 0,
      base = parseFloat(vars.base) || 0,
      cache = {},
      isDecimal = from > 0 && from < 1,
      ratios = isNaN(from) || isDecimal,
      axis = vars.axis,
      ratioX = from,
      ratioY = from;

  if (_isString(from)) {
    ratioX = ratioY = {
      center: .5,
      edges: .5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }

  return function (i, target, a) {
    var l = (a || vars).length,
        distances = cache[l],
        originX,
        originY,
        x,
        y,
        d,
        j,
        max,
        min,
        wrapAt;

    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];

      if (!wrapAt) {
        max = -_bigNum;

        while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

        wrapAt--;
      }

      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
      originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum;

      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }

      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0; //unit

      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }

    l = (distances[i] - distances.min) / distances.max || 0;
    return _round(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  };
};
var _roundModifier = function _roundModifier(v) {
  //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()

  return function (raw) {
    var n = Math.round(parseFloat(raw) / v) * v * p;
    return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  };
};
var snap = function snap(snapTo, value) {
  var isArray = _isArray(snapTo),
      radius,
      is2D;

  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum;

    if (snapTo.values) {
      snapTo = toArray$1(snapTo.values);

      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }

  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function (raw) {
    var x = parseFloat(is2D ? raw.x : raw),
        y = parseFloat(is2D ? raw.y : 0),
        min = _bigNum,
        closest = 0,
        i = snapTo.length,
        dx,
        dy;

    while (i--) {
      if (is2D) {
        dx = snapTo[i].x - x;
        dy = snapTo[i].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i] - x);
      }

      if (dx < min) {
        min = dx;
        closest = i;
      }
    }

    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
};
var random = function random(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
};
var pipe = function pipe() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (value) {
    return functions.reduce(function (v, f) {
      return f(v);
    }, value);
  };
};
var unitize = function unitize(func, unit) {
  return function (value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
};
var normalize = function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value);
};
var _wrapArray = function _wrapArray(a, wrapper, value) {
  return _conditionalReturn(value, function (index) {
    return a[~~wrapper(index)];
  });
};
var wrap = function wrap(min, max, value) {
  // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
    return (range + (value - min) % range) % range + min;
  });
};
var wrapYoyo = function wrapYoyo(min, max, value) {
  var range = max - min,
      total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
    value = (total + (value - min) % total) % total || 0;
    return min + (value > range ? total - value : value);
  });
};
var _replaceRandom = function _replaceRandom(value) {
  //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
  var prev = 0,
      s = "",
      i,
      nums,
      end,
      isArray;

  while (~(i = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i);
    isArray = value.charAt(i + 7) === "[";
    nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }

  return s + value.substr(prev, value.length - prev);
};
var mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin,
      outRange = outMax - outMin;
  return _conditionalReturn(value, function (value) {
    return outMin + ((value - inMin) / inRange * outRange || 0);
  });
};
var interpolate = function interpolate(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function (p) {
    return (1 - p) * start + p * end;
  };

  if (!func) {
    var isString = _isString(start),
        master = {},
        p,
        i,
        interpolators,
        l,
        il;

    progress === true && (mutate = 1) && (progress = null);

    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;

      for (i = 1; i < l; i++) {
        interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
      }

      l--;

      func = function func(p) {
        p *= l;
        var i = Math.min(il, ~~p);
        return interpolators[i](p - i);
      };

      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }

    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }

      func = function func(p) {
        return _renderPropTweens(p, master) || (isString ? start.p : start);
      };
    }
  }

  return _conditionalReturn(progress, func);
};
var _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
  //used for nextLabel() and previousLabel()
  var labels = timeline.labels,
      min = _bigNum,
      p,
      distance,
      label;

  for (p in labels) {
    distance = labels[p] - fromTime;

    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }

  return label;
};
var _callback = function _callback(animation, type, executeLazyFirst) {
  var v = animation.vars,
      callback = v[type],
      params,
      scope;

  if (!callback) {
    return;
  }

  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.

  return params ? callback.apply(scope, params) : callback.call(scope);
};
var _interrupt = function _interrupt(animation) {
  _removeFromParent(animation);

  animation.scrollTrigger && animation.scrollTrigger.kill(false);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
};
var _quickTween;
var _createPlugin = function _createPlugin(config) {
  config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.

  var name = config.name,
      isFunc = _isFunction(config),
      Plugin = name && !isFunc && config.init ? function () {
    this._props = [];
  } : config,

  //in case someone passes in an object that's not a plugin, like CustomEase
  instanceDefaults = {
    init: _emptyFunc,
    render: _renderPropTweens,
    add: _addPropTween,
    kill: _killPropTweensOf,
    modifier: _addPluginModifier,
    rawVars: 0
  },
      statics = {
    targetTest: 0,
    get: 0,
    getSetter: _getSetter,
    aliases: {},
    register: 0
  };

  _wake();

  if (config !== Plugin) {
    if (_plugins[name]) {
      return;
    }

    _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods


    _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods


    _plugins[Plugin.prop = name] = Plugin;

    if (config.targetTest) {
      _harnessPlugins.push(Plugin);

      _reservedProps[name] = 1;
    }

    name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
  }

  _addGlobal(name, Plugin);

  config.register && config.register(gsap, Plugin, PropTween);
};
var _255 = 255;
var _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
};
var _hue = function _hue(h, m1, m2) {
  h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
};
var splitColor = function splitColor(v, toHSL, forceAlpha) {
  var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
      r,
      g,
      b,
      h,
      s,
      l,
      max,
      min,
      d,
      wasHSL;

  if (!a) {
    if (v.substr(-1) === ",") {
      //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
      v = v.substr(0, v.length - 1);
    }

    if (_colorLookup[v]) {
      a = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        //for shorthand like #9F0 or #9F0F (could have alpha)
        r = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }

      if (v.length === 9) {
        // hex with alpha, like #fd5e53ff
        a = parseInt(v.substr(1, 6), 16);
        return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
      }

      v = parseInt(v.substr(1), 16);
      a = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a = wasHSL = v.match(_strictNumExp);

      if (!toHSL) {
        h = +a[0] % 360 / 360;
        s = +a[1] / 100;
        l = +a[2] / 100;
        g = l <= .5 ? l * (s + 1) : l + s - l * s;
        r = l * 2 - g;
        a.length > 3 && (a[3] *= 1); //cast as number

        a[0] = _hue(h + 1 / 3, r, g);
        a[1] = _hue(h, r, g);
        a[2] = _hue(h - 1 / 3, r, g);
      } else if (~v.indexOf("=")) {
        //if relative values are found, just return the raw strings with the relative prefixes in place.
        a = v.match(_numExp);
        forceAlpha && a.length < 4 && (a[3] = 1);
        return a;
      }
    } else {
      a = v.match(_strictNumExp) || _colorLookup.transparent;
    }

    a = a.map(Number);
  }

  if (toHSL && !wasHSL) {
    r = a[0] / _255;
    g = a[1] / _255;
    b = a[2] / _255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }

    a[0] = ~~(h + .5);
    a[1] = ~~(s * 100 + .5);
    a[2] = ~~(l * 100 + .5);
  }

  forceAlpha && a.length < 4 && (a[3] = 1);
  return a;
};
var _colorOrderData = function _colorOrderData(v) {
  // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
  var values = [],
      c = [],
      i = -1;
  v.split(_colorExp).forEach(function (v) {
    var a = v.match(_numWithUnitExp) || [];
    values.push.apply(values, a);
    c.push(i += a.length + 1);
  });
  values.c = c;
  return values;
};
var _formatColors = function _formatColors(s, toHSL, orderMatchData) {
  var result = "",
      colors = (s + result).match(_colorExp),
      type = toHSL ? "hsla(" : "rgba(",
      i = 0,
      c,
      shell,
      d,
      l;

  if (!colors) {
    return s;
  }

  colors = colors.map(function (color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });

  if (orderMatchData) {
    d = _colorOrderData(s);
    c = orderMatchData.c;

    if (c.join(result) !== d.c.join(result)) {
      shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }

  if (!shell) {
    shell = s.split(_colorExp);
    l = shell.length - 1;

    for (; i < l; i++) {
      result += shell[i] + colors[i];
    }
  }

  return result + shell[l];
};
var _colorExp = function () {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",

  //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
  p;

  for (p in _colorLookup) {
    s += "|" + p + "\\b";
  }

  return new RegExp(s + ")", "gi");
}();
var _hslExp = /hsl[a]?\(/;
var _colorStringFilter = function _colorStringFilter(a) {
  var combined = a.join(" "),
      toHSL;
  _colorExp.lastIndex = 0;

  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a[1] = _formatColors(a[1], toHSL);
    a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.

    return true;
  }
};
var _tickerActive;
var _ticker = function () {
  var _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners = [],
      _id,
      _req,
      _raf,
      _self,
      _delta,
      _i,
      _tick = function _tick(v) {
    var elapsed = _getTime() - _lastUpdate,
        manual = v === true,
        overlap,
        dispatch,
        time,
        frame;

    elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;

    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1000;
      _self.time = time = time / 1000;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }

    manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.

    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };

  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1000 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists()) {
          _win = _coreInitted = window;
          _doc = _win.document || {};
          _globals.gsap = gsap;
          (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);

          _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});

          _raf = _win.requestAnimationFrame;
        }

        _id && _self.sleep();

        _req = _raf || function (f) {
          return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
        };

        _tickerActive = 1;

        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || 1 / _tinyNum; //zero should be interpreted as basically unlimited

      _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
    },
    fps: function fps(_fps) {
      _gap = 1000 / (_fps || 240);
      _nextTime = _self.time * 1000 + _gap;
    },
    add: function add(callback) {
      _listeners.indexOf(callback) < 0 && _listeners.push(callback);

      _wake();
    },
    remove: function remove(callback) {
      var i;
      ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
    },
    _listeners: _listeners
  };
  return _self;
}();
var _wake = function _wake() {
  return !_tickerActive && _ticker.wake();
};
var _easeMap = {};
var _customEaseExp = /^[\d.\-M][\d.\-,\s]/;
var _quotesExp = /["']/g;
var _parseObjectInString = function _parseObjectInString(value) {
  //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
  var obj = {},
      split = value.substr(1, value.length - 3).split(":"),
      key = split[0],
      i = 1,
      l = split.length,
      index,
      val,
      parsedVal;

  for (; i < l; i++) {
    val = split[i];
    index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }

  return obj;
};
var _valueInParentheses = function _valueInParentheses(value) {
  var open = value.indexOf("(") + 1,
      close = value.indexOf(")"),
      nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
};
var _configEaseFromString = function _configEaseFromString(name) {
  //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
  var split = (name + "").split("("),
      ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
};
var _invertEase = function _invertEase(ease) {
  return function (p) {
    return 1 - ease(1 - p);
  };
};
var _propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
  var child = timeline._first,
      ease;

  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }

    child = child._next;
  }
};
var _parseEase = function _parseEase(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
};
var _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut(p) {
      return 1 - easeIn(1 - p);
    };
  }

  if (easeInOut === void 0) {
    easeInOut = function easeInOut(p) {
      return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }

  var ease = {
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut
  },
      lowercaseName;

  _forEachName(names, function (name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });

  return ease;
};
var _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
  return function (p) {
    return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
  };
};
var _configElastic = function _configElastic(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1,

  //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
  p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = function easeOut(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  p2 = _2PI / p2; //precalculate to optimize

  ease.config = function (amplitude, period) {
    return _configElastic(type, amplitude, period);
  };

  return ease;
};
var _configBack = function _configBack(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }

  var easeOut = function easeOut(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  ease.config = function (overshoot) {
    return _configBack(type, overshoot);
  };

  return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };


_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
  var power = i < 5 ? i + 1 : i;

  _insertEase(name + ",Power" + (power - 1), i ? function (p) {
    return Math.pow(p, power);
  } : function (p) {
    return p;
  }, function (p) {
    return 1 - Math.pow(1 - p, power);
  }, function (p) {
    return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});

_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

(function (n, c) {
  var n1 = 1 / c,
      n2 = 2 * n1,
      n3 = 2.5 * n1,
      easeOut = function easeOut(p) {
    return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
  };

  _insertEase("Bounce", function (p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);

_insertEase("Expo", function (p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});

_insertEase("Circ", function (p) {
  return -(_sqrt(1 - p * p) - 1);
});

_insertEase("Sine", function (p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});

_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }

    var p1 = 1 / steps,
        p2 = steps + (immediateStart ? 0 : 1),
        p3 = immediateStart ? 1 : 0,
        max = 1 - _tinyNum;
    return function (p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];

_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
  return _callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */

var GSCache = function GSCache(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

var Animation = /*#__PURE__*/function () {
  function Animation(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;

    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }

    this._ts = 1;

    _setDuration(this, +vars.duration, 1, 1);

    this.data = vars.data;
    _tickerActive || _ticker.wake();
  }

  var _proto = Animation.prototype;

  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }

    return this._delay;
  };

  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };

  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };

  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();

    if (!arguments.length) {
      return this._tTime;
    }

    var parent = this._dp;

    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);

      !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
      //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.

      while (parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }

        parent = parent.parent;
      }

      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }

    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
      this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
      //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
      //   this._lock = 1;

      _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
      //}
    }

    return this;
  };

  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
  };

  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
  };

  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
  };

  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;

    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  } // potential future addition:
  // isPlayingBackwards() {
  // 	let animation = this,
  // 		orientation = 1; // 1 = forward, -1 = backward
  // 	while (animation) {
  // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
  // 		animation = animation.parent;
  // 	}
  // 	return orientation < 0;
  // }
  ;

  _proto.timeScale = function timeScale(value) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }

    if (this._rts === value) {
      return this;
    }

    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
    // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
    //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.

    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.

    return _recacheAncestors(this.totalTime(_clamp(-this._delay, this._tDur, tTime), true));
  };

  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }

    if (this._ps !== value) {
      this._ps = value;

      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.

        this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
      } else {
        _wake();

        this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.

        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
      }
    }

    return this;
  };

  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }

    return this._start;
  };

  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
  };

  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp; // _dp = detached parent

    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };

  _proto.globalTime = function globalTime(rawTime) {
    var animation = this,
        time = arguments.length ? rawTime : animation.rawTime();

    while (animation) {
      time = animation._start + time / (animation._ts || 1);
      animation = animation._dp;
    }

    return time;
  };

  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }

    return this._repeat === -2 ? Infinity : this._repeat;
  };

  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;

      _onUpdateTotalDuration(this);

      return time ? this.time(time) : this;
    }

    return this._rDelay;
  };

  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }

    return this._yoyo;
  };

  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };

  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };

  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };

  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };

  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };

  _proto.resume = function resume() {
    return this.paused(false);
  };

  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.

      return this;
    }

    return this._rts < 0;
  };

  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };

  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp,
        start = this._start,
        rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };

  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;

    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }

      return this;
    }

    return vars[type];
  };

  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function (resolve) {
      var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
          _resolve = function _resolve() {
        var _then = self.then;
        self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)

        _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
        resolve(f);
        self.then = _then;
      };

      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };

  _proto.kill = function kill() {
    _interrupt(this);
  };

  return Animation;
}();

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */

var Timeline = /*#__PURE__*/function (_Animation) {
  _inheritsLoose(Timeline, _Animation);

  function Timeline(vars, position) {
    var _this;

    if (vars === void 0) {
      vars = {};
    }

    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }

  var _proto2 = Timeline.prototype;

  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);

    return this;
  };

  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);

    return this;
  };

  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);

    return this;
  };

  _proto2.set = function set$$1(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };

  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  } //ONLY for backward compatibility! Maybe delete?
  ;

  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };

  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._dirty ? this.totalDuration() : this._tDur,
        dur = this._dur,
        tTime = this !== _globalTimeline && totalTime > tDur - _tinyNum && totalTime >= 0 ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
        time,
        child,
        next,
        iteration,
        cycleDuration,
        prevPaused,
        pauseTween,
        timeScale,
        prevStart,
        prevIteration,
        yoyo,
        isYoyo;

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _round(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005

        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */

        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1,
              doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : dur;
          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _round(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.

          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat

          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          } //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.


          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _round(prevTime), _round(time));

        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;

        while (child) {
          next = child._next;

          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.

        while (child) {
          next = child._prev;

          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

        if (this._ts) {
          //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.

          _setEnd(this);

          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto2.add = function add(child, position) {
    var _this2 = this;

    _isNumber(position) || (position = _parsePosition(this, position, child));

    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function (obj) {
          return _this2.add(obj, position);
        });
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  };

  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }

    if (tweens === void 0) {
      tweens = true;
    }

    if (timelines === void 0) {
      timelines = true;
    }

    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum;
    }

    var a = [],
        child = this._first;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a.push(child);
        } else {
          timelines && a.push(child);
          nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
        }
      }

      child = child._next;
    }

    return a;
  };

  _proto2.getById = function getById(id) {
    var animations = this.getChildren(1, 1, 1),
        i = animations.length;

    while (i--) {
      if (animations[i].vars.id === id) {
        return animations[i];
      }
    }
  };

  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);

    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  };

  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = 1;

    if (!this._dp && this._ts) {
      //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _round(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }

    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

    this._forcing = 0;
    return this;
  };

  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };

  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };

  _proto2.addPause = function addPause(position, callback, params) {
    var t = Tween.delayedCall(0, callback || _emptyFunc, params);
    t.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t, _parsePosition(this, position));
  };

  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);

    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }

      child = child._next;
    }
  };

  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive),
        i = tweens.length;

    while (i--) {
      _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
    }

    return this;
  };

  _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
    var a = [],
        parsedTargets = toArray$1(targets),
        child = this._first,
        isGlobalTime = _isNumber(onlyActive),

    // a number is interpreted as a global time. If the animation spans
    children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push.apply(a, children);
      }

      child = child._next;
    }

    return a;
  } // potential future feature - targets() on timelines
  // targets() {
  // 	let result = [];
  // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
  // 	return result.filter((v, i) => result.indexOf(v) === i);
  // }
  ;

  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};

    var tl = this,
        endTime = _parsePosition(tl, position),
        _vars = vars,
        startAt = _vars.startAt,
        _onStart = _vars.onStart,
        onStartParams = _vars.onStartParams,
        immediateRender = _vars.immediateRender,
        initted,
        tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();

        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }

        _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
      }
    }, vars));

    return immediateRender ? tween.render(0) : tween;
  };

  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };

  _proto2.recent = function recent() {
    return this._recent;
  };

  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };

  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };

  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };

  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }

    var child = this._first,
        labels = this.labels,
        p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }

      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  };

  _proto2.invalidate = function invalidate() {
    var child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate();
      child = child._next;
    }

    return _Animation.prototype.invalidate.call(this);
  };

  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }

    var child = this._first,
        next;

    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }

    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };

  _proto2.totalDuration = function totalDuration(value) {
    var max = 0,
        self = this,
        child = self._last,
        prevStart = _bigNum,
        prev,
        start,
        parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...

        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.

        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) {
          //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().

          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) {
          //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

      self._dirty = 0;
    }

    return self._tDur;
  };

  Timeline.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

      _lastRenderedFrame = _ticker.frame;
    }

    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }

        child || _ticker.sleep();
      }
    }
  };

  return Timeline;
}(Animation);

_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});

var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
  //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result,
      startNums,
      color,
      endNum,
      chunk,
      startNum,
      hasRandom,
      a;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }

  if (stringFilter) {
    a = [start, end];
    stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.

    start = a[0];
    end = a[1];
  }

  startNums = start.match(_complexStringNumExp) || [];

  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);

    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }

    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.

      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }

  pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)

  pt.fp = funcParam;

  if (_relExp.test(end) || hasRandom) {
    pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
  }

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

  return pt;
};
var _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop],
      parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt;

  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (end.charAt(1) === "=") {
      pt = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + (getUnit(parsedStart) || 0);

      if (pt || pt === 0) {
        // to avoid isNaN, like if someone passes in a value like "!= whatever"
        end = pt;
      }
    }
  }

  if (parsedStart !== end) {
    if (!isNaN(parsedStart * end) && end !== "") {
      // fun fact: any number multiplied by "" is evaluated as the number 0!
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }

    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
};
var _processVars = function _processVars(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }

  var copy = {},
      p;

  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }

  return copy;
};
var _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i;

  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.

      i = plugin._props.length;

      while (i--) {
        ptLookup[plugin._props[i]] = pt;
      }
    }
  }

  return plugin;
};
var _overwritingTween;
var _initTween = function _initTween(tween, time) {
  var vars = tween.vars,
      ease = vars.ease,
      startAt = vars.startAt,
      immediateRender = vars.immediateRender,
      lazy = vars.lazy,
      onUpdate = vars.onUpdate,
      onUpdateParams = vars.onUpdateParams,
      callbackScope = vars.callbackScope,
      runBackwards = vars.runBackwards,
      yoyoEase = vars.yoyoEase,
      keyframes = vars.keyframes,
      autoRevert = vars.autoRevert,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets,
      autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars,
      i,
      p,
      pt,
      target,
      hasPriority,
      gsData,
      harness,
      plugin,
      ptLookup,
      index,
      harnessVars,
      overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

  if (yoyoEase && tween._yoyo && !tween._repeat) {
    //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }

  tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

  if (!tl) {
    //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.

    cleanVars = _copyExcluding(vars, _reservedProps);
    prevStartAt && prevStartAt.render(-1, true).kill();

    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent: parent,
        immediateRender: true,
        lazy: _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate,
        onUpdateParams: onUpdateParams,
        callbackScope: callbackScope,
        stagger: 0
      }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);


      time < 0 && !immediateRender && !autoRevert && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

      if (immediateRender) {
        time > 0 && !autoRevert && (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.

        if (dur && time <= 0) {
          time && (tween._zTime = time);
          return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        } // if (time > 0) {
        // 	autoRevert || (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
        // } else if (dur && !(time < 0 && prevStartAt)) {
        // 	time && (tween._zTime = time);
        // 	return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        // }
      } else if (autoRevert === false) {
        tween._startAt = 0;
      }
    } else if (runBackwards && dur) {
      //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
      if (prevStartAt) {
        !autoRevert && (tween._startAt = 0);
      } else {
        time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0

        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && _isNotFalse(lazy),
          immediateRender: immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})

        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})

        _removeFromParent(tween._startAt = Tween.set(targets, p));

        time < 0 && tween._startAt.render(-1, true); // rare edge case, like if a render is forced in the negative direction of a non-initted from() tween.

        if (!immediateRender) {
          _initTween(tween._startAt, _tinyNum); //ensures that the initial values are recorded
        } else if (!time) {
          return;
        }
      }
    }

    tween._pt = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;

    for (i = 0; i < targets.length; i++) {
      target = targets[i];
      gsData = target._gsap || _harness(targets)[i]._gsap;
      tween._ptLookup[i] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)

      index = fullTargets === targets ? i : fullTargets.indexOf(target);

      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

        plugin._props.forEach(function (name) {
          ptLookup[name] = pt;
        });

        plugin.priority && (hasPriority = 1);
      }

      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }

      tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;

        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(0)); //Also make sure the overwriting doesn't overwrite THIS tween!!!


        overwritten = !tween.parent;
        _overwritingTween = 0;
      }

      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }

    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
  }

  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
};
var _addAliasesToVars = function _addAliasesToVars(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0,
      propertyAliases = harness && harness.aliases,
      copy,
      p,
      i,
      aliases;

  if (!propertyAliases) {
    return vars;
  }

  copy = _merge({}, vars);

  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i = aliases.length;

      while (i--) {
        copy[aliases[i]] = copy[p];
      }
    }
  }

  return copy;
};
var _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
  return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
};
var _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase";
var _staggerPropsToSkip = (_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger").split(",");
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */

var Tween = /*#__PURE__*/function (_Animation2) {
  _inheritsLoose(Tween, _Animation2);

  function Tween(targets, vars, position, skipInherit) {
    var _this3;

    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }

    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars,
        duration = _this3$vars.duration,
        delay = _this3$vars.delay,
        immediateRender = _this3$vars.immediateRender,
        stagger = _this3$vars.stagger,
        overwrite = _this3$vars.overwrite,
        keyframes = _this3$vars.keyframes,
        defaults$$1 = _this3$vars.defaults,
        scrollTrigger = _this3$vars.scrollTrigger,
        yoyoEase = _this3$vars.yoyoEase,
        parent = vars.parent || _globalTimeline,
        parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray$1(targets),
        tl,
        i,
        copy,
        l,
        p,
        curTarget,
        staggerFunc,
        staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _this3._overwrite = overwrite;

    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults$$1 || {}
      });
      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;

      if (keyframes) {
        _setDefaults(tl.vars.defaults, {
          ease: "none"
        });

        stagger ? parsedTargets.forEach(function (t, i) {
          return keyframes.forEach(function (frame, j) {
            return tl.to(t, frame, j ? ">" : i * stagger);
          });
        }) : keyframes.forEach(function (frame) {
          return tl.to(parsedTargets, frame, ">");
        });
      } else {
        l = parsedTargets.length;
        staggerFunc = stagger ? distribute(stagger) : _emptyFunc;

        if (_isObject(stagger)) {
          //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }

        for (i = 0; i < l; i++) {
          copy = {};

          for (p in vars) {
            if (_staggerPropsToSkip.indexOf(p) < 0) {
              copy[p] = vars[p];
            }
          }

          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.

          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

          if (!stagger && l === 1 && copy.delay) {
            // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }

          tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
        }

        tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
      }

      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
    }

    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);

      _globalTimeline.killTweensOf(parsedTargets);

      _overwritingTween = 0;
    }

    _addToTimeline(parent, _assertThisInitialized(_this3), position);

    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);

    if (immediateRender || !duration && !keyframes && _this3._start === _round(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)

      _this3.render(Math.max(0, -delay)); //in case delay is negative
    }

    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }

  var _proto3 = Tween.prototype;

  _proto3.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._tDur,
        dur = this._dur,
        tTime = totalTime > tDur - _tinyNum && totalTime >= 0 ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        time,
        pt,
        iteration,
        cycleDuration,
        prevIteration,
        isYoyo,
        ratio,
        timeline,
        yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== totalTime < 0) {
      //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _round(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && iteration & 1;

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality

          if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.

            this.render(_round(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, totalTime < 0 ? totalTime : time, force, suppressEvents)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (dur !== this._dur) {
          // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);

      if (this._onUpdate && !suppressEvents) {
        totalTime < 0 && this._startAt && this._startAt.render(totalTime, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.

        _callback(this, "onUpdate");
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        totalTime < 0 && this._startAt && !this._onUpdate && this._startAt.render(totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
          // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto3.targets = function targets() {
    return this._targets;
  };

  _proto3.invalidate = function invalidate() {
    this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate();
    return _Animation2.prototype.invalidate.call(this);
  };

  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }

    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }

    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.

      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.

      return this;
    }

    var parsedTargets = this._targets,
        killingTargets = targets ? toArray$1(targets) : parsedTargets,
        propTweenLookup = this._ptLookup,
        firstPT = this._pt,
        overwrittenProps,
        curLookup,
        curOverwriteProps,
        props,
        p,
        pt,
        i;

    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }

    overwrittenProps = this._op = this._op || [];

    if (vars !== "all") {
      //so people can pass in a comma-delimited list of property names
      if (_isString(vars)) {
        p = {};

        _forEachName(vars, function (name) {
          return p[name] = 1;
        });

        vars = p;
      }

      vars = _addAliasesToVars(parsedTargets, vars);
    }

    i = parsedTargets.length;

    while (i--) {
      if (~killingTargets.indexOf(parsedTargets[i])) {
        curLookup = propTweenLookup[i];

        if (vars === "all") {
          overwrittenProps[i] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
          props = vars;
        }

        for (p in props) {
          pt = curLookup && curLookup[p];

          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }

            delete curLookup[p];
          }

          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }

    this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.

    return this;
  };

  Tween.to = function to(targets, vars) {
    return new Tween(targets, vars, arguments[2]);
  };

  Tween.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };

  Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay: delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    });
  };

  Tween.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };

  Tween.set = function set$$1(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween(targets, vars);
  };

  Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };

  return Tween;
}(Animation);

_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.


_forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
  Tween[name] = function () {
    var tl = new Timeline(),
        params = _slice.call(arguments, 0);

    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */

var _setterPlain = function _setterPlain(target, property, value) {
  return target[property] = value;
};
var _setterFunc = function _setterFunc(target, property, value) {
  return target[property](value);
};
var _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
  return target[property](data.fp, value);
};
var _setterAttribute = function _setterAttribute(target, property, value) {
  return target.setAttribute(property, value);
};
var _getSetter = function _getSetter(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
};
var _renderPlain = function _renderPlain(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
};
var _renderBoolean = function _renderBoolean(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
};
var _renderComplexString = function _renderComplexString(ratio, data) {
  var pt = data._pt,
      s = "";

  if (!ratio && data.b) {
    //b = beginning string
    s = data.b;
  } else if (ratio === 1 && data.e) {
    //e = ending string
    s = data.e;
  } else {
    while (pt) {
      s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.

      pt = pt._next;
    }

    s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
  }

  data.set(data.t, data.p, s, data);
};
var _renderPropTweens = function _renderPropTweens(ratio, data) {
  var pt = data._pt;

  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
};
var _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
  var pt = this._pt,
      next;

  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
};
var _killPropTweensOf = function _killPropTweensOf(property) {
  var pt = this._pt,
      hasNonDependentRemaining,
      next;

  while (pt) {
    next = pt._next;

    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }

    pt = next;
  }

  return !hasNonDependentRemaining;
};
var _setterWithModifier = function _setterWithModifier(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
};
var _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
  var pt = parent._pt,
      next,
      pt2,
      first,
      last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)

  while (pt) {
    next = pt._next;
    pt2 = first;

    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }

    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }

    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }

    pt = next;
  }

  parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)


var PropTween = /*#__PURE__*/function () {
  function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;

    if (next) {
      next._prev = this;
    }
  }

  var _proto4 = PropTween.prototype;

  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)

    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target

    this.tween = tween;
  };

  return PropTween;
}(); //Initialization tasks

_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
  return _reservedProps[name] = 1;
});

_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */

var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    args.forEach(function (config) {
      return _createPlugin(config);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray$1(target)[0]); //in case selector text or an array is passed in

    var getter = _getCache(target || {}).get,
        format = unit ? _passThrough : _numericIfPossible;

    unit === "native" && (unit = "");
    return !target ? target : !property ? function (property, unit, uncache) {
      return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray$1(target);

    if (target.length > 1) {
      var setters = target.map(function (t) {
        return gsap.quickSetter(t, property, unit);
      }),
          l = setters.length;
      return function (value) {
        var i = l;

        while (i--) {
          setters[i](value);
        }
      };
    }

    target = target[0] || {};

    var Plugin = _plugins[property],
        cache = _getCache(target),
        p = cache.harness && (cache.harness.aliases || {})[property] || property,

    // in case it's an alias, like "rotate" for "rotation".
    setter = Plugin ? function (value) {
      var p = new Plugin();
      _quickTween._pt = 0;
      p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p.render(1, p);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);

    return Plugin ? setter : function (value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults$$1(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name,
        effect = _ref3.effect,
        plugins = _ref3.plugins,
        defaults$$1 = _ref3.defaults,
        extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function (pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });

    _effects[name] = function (targets, vars, tl) {
      return effect(toArray$1(targets), _setDefaults(vars || {}, defaults$$1), tl);
    };

    if (extendTimeline) {
      Timeline.prototype[name] = function (targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }

    var tl = new Timeline(vars),
        child,
        next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

    _globalTimeline.remove(tl);

    tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).

    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;

    while (child) {
      next = child._next;

      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }

      child = next;
    }

    _addToTimeline(_globalTimeline, tl, 0);

    return tl;
  },
  utils: {
    wrap: wrap,
    wrapYoyo: wrapYoyo,
    distribute: distribute,
    random: random,
    snap: snap,
    normalize: normalize,
    getUnit: getUnit,
    clamp: clamp,
    splitColor: splitColor,
    toArray: toArray$1,
    selector: selector,
    mapRange: mapRange,
    pipe: pipe,
    unitize: unitize,
    interpolate: interpolate,
    shuffle: shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween: PropTween,
    globals: _addGlobal,
    Tween: Tween,
    Timeline: Timeline,
    Animation: Animation,
    getCache: _getCache,
    _removeLinkedListItem: _removeLinkedListItem,
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};

_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
  return _gsap[name] = Tween[name];
});

_ticker.add(Timeline.updateRoot);

_quickTween = _gsap.to({}, {
  duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------

var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
  var pt = plugin._pt;

  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }

  return pt;
};
var _addModifiers = function _addModifiers(tween, modifiers) {
  var targets = tween._targets,
      p,
      i,
      pt;

  for (p in modifiers) {
    i = targets.length;

    while (i--) {
      pt = tween._ptLookup[i][p];

      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          // is a plugin
          pt = _getPluginPropTween(pt, p);
        }

        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
      }
    }
  }
};
var _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
  return {
    name: name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init(target, vars, tween) {
      tween._onInit = function (tween) {
        var temp, p;

        if (_isString(vars)) {
          temp = {};

          _forEachName(vars, function (name) {
            return temp[name] = 1;
          }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.


          vars = temp;
        }

        if (modifier) {
          temp = {};

          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }

          vars = temp;
        }

        _addModifiers(tween, vars);
      };
    }
  };
}; //register core plugins


var gsap = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt;

    for (p in vars) {
      pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
      pt && (pt.op = p);

      this._props.push(p);
    }
  }
}, {
  name: "endArray",
  init: function init(target, value) {
    var i = value.length;

    while (i--) {
      this.add(target, i, target[i] || 0, value[i]);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.

Tween.version = Timeline.version = gsap.version = "3.7.1";
_coreReady = 1;
_windowExists() && _wake();

/*!
 * CSSPlugin 3.7.1
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _win$1;
var _doc$1;
var _docElement;
var _pluginInitted;
var _tempDiv;
var _tempDivStyler;
var _recentSetterPlugin;
var _windowExists$1 = function _windowExists() {
  return typeof window !== "undefined";
};
var _transformProps = {};
var _RAD2DEG = 180 / Math.PI;
var _DEG2RAD = Math.PI / 180;
var _atan2 = Math.atan2;
var _bigNum$1 = 1e8;
var _capsExp = /([A-Z])/g;
var _horizontalExp = /(?:left|right|width|margin|padding|x)/i;
var _complexExp = /[\s,\(]\S/;
var _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
};
var _renderCSSProp = function _renderCSSProp(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
};
var _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
};
var _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
};
var _renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
};
var _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
};
var _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
};
var _setterCSSStyle = function _setterCSSStyle(target, property, value) {
  return target.style[property] = value;
};
var _setterCSSProp = function _setterCSSProp(target, property, value) {
  return target.style.setProperty(property, value);
};
var _setterTransform = function _setterTransform(target, property, value) {
  return target._gsap[property] = value;
};
var _setterScale = function _setterScale(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
};
var _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
};
var _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
};
var _transformProp = "transform";
var _transformOriginProp = _transformProp + "Origin";
var _supports3D;
var _createElement = function _createElement(type, ns) {
  var e = _doc$1.createElementNS ? _doc$1.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc$1.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.

  return e.style ? e : _doc$1.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
};
var _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
};
var _prefixes = "O,Moz,ms,Ms,Webkit".split(",");
var _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
  var e = element || _tempDiv,
      s = e.style,
      i = 5;

  if (property in s && !preferPrefix) {
    return property;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);

  while (i-- && !(_prefixes[i] + property in s)) {}

  return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
};
var _initCore = function _initCore() {
  if (_windowExists$1() && window.document) {
    _win$1 = window;
    _doc$1 = _win$1.document;
    _docElement = _doc$1.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _tempDivStyler = _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.

    _supports3D = !!_checkPropPrefix("perspective");
    _pluginInitted = 1;
  }
};
var _getBBoxHack = function _getBBoxHack(swapIfPossible) {
  //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
      oldParent = this.parentNode,
      oldSibling = this.nextSibling,
      oldCSS = this.style.cssText,
      bbox;

  _docElement.appendChild(svg);

  svg.appendChild(this);
  this.style.display = "block";

  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox; //store the original

      this.getBBox = _getBBoxHack;
    } catch (e) {}
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }

  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }

  _docElement.removeChild(svg);

  this.style.cssText = oldCSS;
  return bbox;
};
var _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
  var i = attributesArray.length;

  while (i--) {
    if (target.hasAttribute(attributesArray[i])) {
      return target.getAttribute(attributesArray[i]);
    }
  }
};
var _getBBox = function _getBBox(target) {
  var bounds;

  try {
    bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }

  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.

  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
};
var _isSVG = function _isSVG(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
};
var _removeProperty = function _removeProperty(target, property) {
  if (property) {
    var style = target.style;

    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }

    if (style.removeProperty) {
      if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") {
        //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
        property = "-" + property;
      }

      style.removeProperty(property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
      style.removeAttribute(property);
    }
  }
};
var _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;

  plugin._props.push(property);

  return pt;
};
var _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
};
var _convertToUnit = function _convertToUnit(target, property, value, unit) {
  var curValue = parseFloat(value) || 0,
      curUnit = (value + "").trim().substr((curValue + "").length) || "px",

  // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
  style = _tempDiv.style,
      horizontal = _horizontalExp.test(property),
      isRootSVG = target.tagName.toLowerCase() === "svg",
      measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
      amount = 100,
      toPixels = unit === "px",
      toPercent = unit === "%",
      px,
      parent,
      cache,
      isSVG;

  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }

  curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);

  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
  }

  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }

  if (!parent || parent === _doc$1 || !parent.appendChild) {
    parent = _doc$1.body;
  }

  cache = parent._gsap;

  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time) {
    return _round(curValue / cache.width * amount);
  } else {
    (toPercent || curUnit === "%") && (style.position = _getComputedProperty(target, "position"));
    parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.

    parent.appendChild(_tempDiv);
    px = _tempDiv[measureProperty];
    parent.removeChild(_tempDiv);
    style.position = "absolute";

    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }

  return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
};
var _get = function _get(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();

  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];

    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }

  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];

    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
  }

  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
};
var _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
  //note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  if (!start || start === "none") {
    // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
    var p = _checkPropPrefix(prop, target, 1),
        s = p && _getComputedProperty(target, p, 1);

    if (s && s !== start) {
      prop = p;
      start = s;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
  }

  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
      index = 0,
      matchIndex = 0,
      a,
      result,
      startValues,
      startNum,
      color,
      startValue,
      endValue,
      endNum,
      chunk,
      endUnit,
      startUnit,
      relative,
      endValues;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (end === "auto") {
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    target.style[prop] = start;
  }

  a = [start, end];

  _colorStringFilter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().


  start = a[0];
  end = a[1];
  startValues = start.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];

  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }

      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;

        if (relative) {
          endValue = endValue.substr(2);
        }

        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;

        if (!endUnit) {
          //if something like "perspective:300" is passed in and we must add a unit to the end
          endUnit = endUnit || _config.units[prop] || startUnit;

          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }

        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        } //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.


        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: relative ? relative * endNum : endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }

  _relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.

  return pt;
};
var _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
};
var _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
  var split = value.split(" "),
      x = split[0],
      y = split[1] || "50%";

  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    //the user provided them in the wrong order, so flip them
    value = x;
    x = y;
    y = value;
  }

  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
};
var _renderClearProps = function _renderClearProps(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t,
        style = target.style,
        props = data.u,
        cache = target._gsap,
        prop,
        clearTransforms,
        i;

    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i = props.length;

      while (--i > -1) {
        prop = props[i];

        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }

        _removeProperty(target, prop);
      }
    }

    if (clearTransforms) {
      _removeProperty(target, _transformProp);

      if (cache) {
        cache.svg && target.removeAttribute("transform");

        _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.


        cache.uncache = 1;
      }
    }
  }
};
var _specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;

      plugin._props.push(property);

      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://greensock.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */

};
var _identity2DMatrix = [1, 0, 0, 1, 0, 0];
var _rotationalProperties = {};
var _isNullTransform = function _isNullTransform(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
};
var _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
  var matrixString = _getComputedProperty(target, _transformProp);

  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
};
var _getMatrix = function _getMatrix(target, force2D) {
  var cache = target._gsap || _getCache(target),
      style = target.style,
      matrix = _getComputedTransformMatrixAsArray(target),
      parent,
      nextSibling,
      temp,
      addedToDOM;

  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.

    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;

    if (!parent || !target.offsetParent) {
      // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
      addedToDOM = 1; //flag

      nextSibling = target.nextSibling;

      _docElement.appendChild(target); //we must add it to the DOM in order to get values properly
    }

    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");

    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }

  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
};
var _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap,
      matrix = matrixArray || _getMatrix(target, true),
      xOriginOld = cache.xOrigin || 0,
      yOriginOld = cache.yOrigin || 0,
      xOffsetOld = cache.xOffset || 0,
      yOffsetOld = cache.yOffset || 0,
      a = matrix[0],
      b = matrix[1],
      c = matrix[2],
      d = matrix[3],
      tx = matrix[4],
      ty = matrix[5],
      originSplit = origin.split(" "),
      xOrigin = parseFloat(originSplit[0]) || 0,
      yOrigin = parseFloat(originSplit[1]) || 0,
      bounds,
      determinant,
      x,
      y;

  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
  } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
    //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
    x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y;
  }

  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }

  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).

  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }

  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
};
var _parseTransform = function _parseTransform(target, uncache) {
  var cache = target._gsap || new GSCache(target);

  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }

  var style = target.style,
      invertedScaleX = cache.scaleX < 0,
      px = "px",
      deg = "deg",
      origin = _getComputedProperty(target, _transformOriginProp) || "0",
      x,
      y,
      z,
      scaleX,
      scaleY,
      rotation,
      rotationX,
      rotationY,
      skewX,
      skewY,
      perspective,
      xOrigin,
      yOrigin,
      matrix,
      angle,
      cos,
      sin,
      a,
      b,
      c,
      d,
      a12,
      a22,
      t1,
      t2,
      t3,
      a13,
      a23,
      a33,
      a42,
      a43,
      a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));
  matrix = _getMatrix(target, cache.svg);

  if (cache.svg) {
    t1 = (!cache.uncache || origin === "0px 0px") && !uncache && target.getAttribute("data-svg-origin"); // if origin is 0,0 and cache.uncache is true, let the recorded data-svg-origin stay. Otherwise, whenever we set cache.uncache to true, we'd need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.

    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }

  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;

  if (matrix !== _identity2DMatrix) {
    a = matrix[0]; //a11

    b = matrix[1]; //a21

    c = matrix[2]; //a31

    d = matrix[3]; //a41

    x = a12 = matrix[4];
    y = a22 = matrix[5]; //2D matrix

    if (matrix.length === 6) {
      scaleX = Math.sqrt(a * a + b * b);
      scaleY = Math.sqrt(d * d + c * c);
      rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).

      skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

      if (cache.svg) {
        x -= xOrigin - (xOrigin * a + yOrigin * c);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      } //3D matrix
    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG; //rotationX

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      } //rotationY


      angle = _atan2(-c, a33);
      rotationY = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a = t1;
        b = t2;
        c = t3;
      } //rotationZ


      angle = _atan2(b, a);
      rotation = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a * sin;
        a22 = a22 * cos - a12 * sin;
        a = t1;
        a12 = t2;
      }

      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }

      scaleX = _round(Math.sqrt(a * a + b * b + c * c));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }

    if (cache.svg) {
      //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }

  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }

  cache.x = x - ((cache.xPercent = x && (cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;

  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }

  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
};
var _firstTwoOnly = function _firstTwoOnly(value) {
  return (value = value.split(" "))[0] + " " + value[1];
};
var _addPxTranslate = function _addPxTranslate(target, start, value) {
  var unit = getUnit(start);
  return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
};
var _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;

  _renderCSSTransforms(ratio, cache);
};
var _zeroDeg = "0deg";
var _zeroPx = "0px";
var _endParenthesis = ") ";
var _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
  var _ref = cache || this,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      rotation = _ref.rotation,
      rotationY = _ref.rotationY,
      rotationX = _ref.rotationX,
      skewX = _ref.skewX,
      skewY = _ref.skewY,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      transformPerspective = _ref.transformPerspective,
      force3D = _ref.force3D,
      target = _ref.target,
      zOrigin = _ref.zOrigin,
      transforms = "",
      use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)


  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD,
        a13 = Math.sin(angle),
        a33 = Math.cos(angle),
        cos;

    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }

  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }

  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }

  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }

  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }

  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }

  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }

  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }

  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }

  target.style[_transformProp] = transforms || "translate(0, 0)";
};
var _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
  var _ref2 = cache || this,
      xPercent = _ref2.xPercent,
      yPercent = _ref2.yPercent,
      x = _ref2.x,
      y = _ref2.y,
      rotation = _ref2.rotation,
      skewX = _ref2.skewX,
      skewY = _ref2.skewY,
      scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY,
      target = _ref2.target,
      xOrigin = _ref2.xOrigin,
      yOrigin = _ref2.yOrigin,
      xOffset = _ref2.xOffset,
      yOffset = _ref2.yOffset,
      forceCSS = _ref2.forceCSS,
      tx = parseFloat(x),
      ty = parseFloat(y),
      a11,
      a21,
      a12,
      a22,
      temp;

  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);

  if (skewY) {
    //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }

  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;

    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;

      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }

    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }

  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }

  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }

  if (xPercent || yPercent) {
    //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }

  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the  transform attribute changes!)
};
var _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
  var cap = 360,
      isString = _isString(endValue),
      endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
      change = relative ? endNum * relative : endNum - startNum,
      finalValue = startNum + change + "deg",
      direction,
      pt;

  if (isString) {
    direction = endValue.split("_")[1];

    if (direction === "short") {
      change %= cap;

      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }

    if (direction === "cw" && change < 0) {
      change = (change + cap * _bigNum$1) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * _bigNum$1) % cap - ~~(change / cap) * cap;
    }
  }

  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";

  plugin._props.push(property);

  return pt;
};
var _assign = function _assign(target, source) {
  // Internet Explorer doesn't have Object.assign(), so we recreate it here.
  for (var p in source) {
    target[p] = source[p];
  }

  return target;
};
var _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
  //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
  var startCache = _assign({}, target._gsap),
      exclude = "perspective,force3D,transformOrigin,svgOrigin",
      style = target.style,
      endCache,
      p,
      startValue,
      endValue,
      startNum,
      endNum,
      startUnit,
      endUnit;

  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);

    _removeProperty(target, _transformProp);

    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }

  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];

    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;

      plugin._props.push(p);
    }
  }

  _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.


_forEachName("padding,margin,Width,Radius", function (name, index) {
  var t = "Top",
      r = "Right",
      b = "Bottom",
      l = "Left",
      props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
    return index < 2 ? name + side : "border" + side + name;
  });

  _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
    var a, vars;

    if (arguments.length < 4) {
      // getter, passed target, property, and unit (from _get())
      a = props.map(function (prop) {
        return _get(plugin, prop, property);
      });
      vars = a.join(" ");
      return vars.split(a[0]).length === 5 ? a[0] : vars;
    }

    a = (endValue + "").split(" ");
    vars = {};
    props.forEach(function (prop, i) {
      return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});

var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init(target, vars, tween, index, targets) {
    var props = this._props,
        style = target.style,
        startAt = tween.vars.startAt,
        startValue,
        endValue,
        endNum,
        startNum,
        type,
        specialProp,
        p,
        startUnit,
        endUnit,
        relative,
        isTransformRelated,
        transformPropTween,
        cache,
        smooth,
        hasPriority;
    _pluginInitted || _initCore();

    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }

      endValue = vars[p];

      if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
        // plugins
        continue;
      }

      type = typeof endValue === "undefined" ? "undefined" : _typeof(endValue);
      specialProp = _specialProps[p];

      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue === "undefined" ? "undefined" : _typeof(endValue);
      }

      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }

      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        //CSS variable
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;

        if (!_colorExp.test(startValue)) {
          // colors don't have units
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
        }

        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          p in _config.units && !getUnit(startValue) && (startValue += _config.units[p]); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.

          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
        } else {
          startValue = _get(target, p);
        }

        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);

        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
              startNum = 0;
            }

            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }

          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }

        isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---

        if (isTransformRelated) {
          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.

            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)

            transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
          }

          if (p === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? relative * endNum : endNum - cache.scaleY) || 0);
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.

            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!

              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }

            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);

            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, endValue, relative);

            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);

            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }

        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0); // protect against NaN

          endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;

          if (startUnit !== endUnit) {
            //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
            this.add(target, p, startValue || target[p], endValue, index, targets);
          } else {
            _missingPlugin(p, endValue);

            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, endValue);
        }

        props.push(p);
      }
    }

    hasPriority && _sortPropTweensByPriority(this);
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty: _removeProperty,
    _getMatrix: _getMatrix
  }
};
gsap.utils.checkPrefix = _checkPropPrefix;

(function (positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
    _transformProps[name] = 1;
  });

  _forEachName(rotation, function (name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });

  _propertyAliases[all[13]] = positionAndScale + "," + rotation;

  _forEachName(aliases, function (name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
  _config.units[name] = "px";
});

gsap.registerPlugin(CSSPlugin);

var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap;

var cookieBar = {
    timeline: null,

    init: function init() {
        var self = this;
        self._resolveCookie();
    },
    _getCookie: function _getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
    },
    _checkCookie: function _checkCookie(cookieConsidered, cookieBar) {
        if (cookieConsidered === "true") {

            cookieBar.classList.add('c-cookie-bar--hidden');
            return;
        } else {
            cookieBar.classList.remove('c-cookie-bar--hidden');
        }
    },
    _resolveCookie: function _resolveCookie() {
        var self = this;
        var cookieBar = document.querySelector('.c-cookie-bar');
        var cookieConsidered = self._getCookie("GDPRcookieConsidered");
        var cookieButton = document.querySelector('.c-cookie-bar__button');

        if (!cookieButton) {
            return;
        }

        var button = document.querySelector('.c-cookie-bar__button');
        button.addEventListener('click', function () {
            if (!cookieBar.classList.contains('c-cookie-bar--hidden')) {
                //cookieBar.classList.add('c-cookie-bar--hidden');
                gsapWithCSS.to(cookieBar, {
                    duration: 0.3,
                    autoAlpha: 0,
                    bottom: '-80px',
                    ease: 'power2.out'
                });
            }

            if (cookieConsidered !== "true") {
                self._setCookie("GDPRcookieConsidered", true);
            }
        });

        self._checkCookie(cookieConsidered, cookieBar);
    },
    _setCookie: function _setCookie(key, state) {
        var exdays = 3650;
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = key + "=" + state + ";" + expires + ";path=/" + "; secure";
    }
};

cookieBar.init();

document.addEventListener('LokiRequestEnd', function () {
    cookieBar.init();
});

var mobileMenu = {
    tl: null,
    timeout: false,
    delay: 250,
    progress: 0,

    init: function init() {
        var self = this;
        self._initMenu();
    },

    _initMenu: function _initMenu() {
        var self = this;
        self._initDropdown();

        var burger = document.querySelector('.js-burger');
        var cross = document.querySelector('.js-close');
        var menu = document.querySelector('.c-navbar-mobile__content');

        var body = document.querySelector('body');
        if (body.classList.contains('body-fixed')) {
            body.classList.remove('body-fixed');
        }

        burger.addEventListener('click', function (event) {
            event.preventDefault();
            self.timeline();

            if (menu.classList.contains('c-navbar-mobile__content--hidden')) {
                menu.classList.remove('c-navbar-mobile__content--hidden');
                self.tl.play();
            } else {
                menu.classList.add('c-navbar-mobile__content--hidden');
            }

            if (burger.classList.contains('c-navbar-mobile__opened')) {

                burger.classList.remove('c-navbar-mobile__opened');
                burger.classList.add('c-navbar-mobile__closed');
                cross.classList.add('c-navbar-mobile__opened');
                cross.classList.remove('c-navbar-mobile__closed');
                document.querySelector('body').classList.add('body-fixed');
            }
        });

        cross.addEventListener('click', function (event) {
            event.preventDefault();

            if (!menu.classList.contains('c-navbar-mobile__content--hidden')) {
                self.tl.reverse();
            }

            if (cross.classList.contains('c-navbar-mobile__opened')) {
                cross.classList.remove('c-navbar-mobile__opened');
                cross.classList.add('c-navbar-mobile__closed');
                burger.classList.add('c-navbar-mobile__opened');
                burger.classList.remove('c-navbar-mobile__closed');
                document.querySelector('body').classList.remove('body-fixed');
            }
        });

        if (menu) {
            var links = Array.prototype.slice.call(document.querySelectorAll('.c-navbar-mobile .c-navbar__nav-item'));
            var dropDownLinks = Array.prototype.slice.call(document.querySelectorAll('.c-navbar-mobile .c-navbar-dropdown-menu__content-item'));
            links.forEach(function (link) {
                link.addEventListener('click', function () {
                    if (!menu.classList.contains('c-navbar-mobile__content--hidden')) {
                        self.tl.reverse();
                    }

                    if (cross.classList.contains('c-navbar-mobile__opened')) {
                        cross.classList.remove('c-navbar-mobile__opened');
                        cross.classList.add('c-navbar-mobile__closed');
                        burger.classList.add('c-navbar-mobile__opened');
                        burger.classList.remove('c-navbar-mobile__closed');
                        document.querySelector('body').classList.remove('body-fixed');
                    }
                });
            });

            dropDownLinks.forEach(function (dropDownLink) {
                dropDownLink.addEventListener('click', function () {
                    if (!menu.classList.contains('c-navbar-mobile__content--hidden')) {
                        self.tl.reverse();
                    }

                    if (cross.classList.contains('c-navbar-mobile__opened')) {
                        cross.classList.remove('c-navbar-mobile__opened');
                        cross.classList.add('c-navbar-mobile__closed');
                        burger.classList.add('c-navbar-mobile__opened');
                        burger.classList.remove('c-navbar-mobile__closed');
                        document.querySelector('body').classList.remove('body-fixed');
                    }
                });
            });
        }
    },
    _initDropdown: function _initDropdown() {
        var dropDowns = document.querySelectorAll('.c-navbar-mobile .c-navbar__nav-item-dropdown');

        dropDowns.forEach(function (dropDown) {
            dropDown.addEventListener('click', function () {
                var dropDownContent = dropDown.parentElement.querySelector('.c-navbar-dropdown-menu__content');
                if (dropDownContent.classList.contains('c-navbar-dropdown-menu__content--closed')) {
                    dropDownContent.classList.remove('c-navbar-dropdown-menu__content--closed');
                    dropDownContent.classList.add('c-navbar-dropdown-menu__content--opened');

                    dropDown.parentElement.classList.add('c-navbar-dropdown-menu__arrow--opened');

                    if (dropDown.parentElement.querySelector('a').getAttribute('aria-expanded') === 'false') {
                        dropDown.parentElement.querySelector('a').setAttribute('aria-expanded', 'true');
                    }
                } else {
                    dropDownContent.classList.add('c-navbar-dropdown-menu__content--closed');
                    dropDownContent.classList.remove('c-navbar-dropdown-menu__content--opened');

                    dropDown.parentElement.classList.remove('c-navbar-dropdown-menu__arrow--opened');

                    if (dropDown.parentElement.querySelector('a').getAttribute('aria-expanded') === 'true') {
                        dropDown.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
                    }
                }
            });
        });
    },


    timeline: function timeline() {
        var reverseComplete = false;
        var self = this;
        var menu = document.querySelector('.c-navbar-mobile__content');

        self.tl = gsapWithCSS.timeline({ paused: true, reversed: true, onReverseComplete: function onReverseComplete() {
                reverseComplete = true;
                if (reverseComplete && !menu.classList.contains('c-navbar-mobile__content--hidden')) {
                    menu.classList.add('c-navbar-mobile__content--hidden');
                    self.progress = 0;
                    self.tl.kill();
                }
            } });

        self.tl.fromTo(document.querySelector('.c-navbar-mobile__content'), 0.25, { right: '-100%', delay: .05, ease: 'Power2.inOut' }, { right: 0 }).fromTo(document.querySelector('.c-navbar-mobile__content-col'), .25, { opacity: 0, ease: 'Power2.in' }, { opacity: 1, ease: 'Power2.out' });

        self.tl.progress(self.progress);
    },

    getDimension: function getDimension() {
        var self = this;
        self.progress = this.tl.progress();
        self.tl.kill();
        self.timeline();
    }
};

var navbarMobile = document.querySelector('.c-navbar-mobile');

if (navbarMobile) {
    mobileMenu.timeline();
    mobileMenu.getDimension();
    mobileMenu.init();
}

window.addEventListener('resize', function () {
    // clear the timeout
    clearTimeout(mobileMenu.timeout);
    // start timing for event "completion"
    mobileMenu.timeout = setTimeout(mobileMenu.getDimension(), mobileMenu.delay);
});

document.addEventListener('LokiRequestEnd', function () {
    if (navbarMobile) {
        mobileMenu.timeline();
        mobileMenu.getDimension();
        mobileMenu.init();
    }
});

/*!
 * Splide.js
 * Version  : 2.4.20
 * License  : MIT
 * Copyright: 2020 Naotoshi Fujita
 */
/******/(function () {
    // webpackBootstrap
    /******/"use strict";
    /******/ // The require scope
    /******/
    var __webpack_require__ = {};
    /******/
    /************************************************************************/
    /******/ /* webpack/runtime/define property getters */
    /******/!function () {
        /******/ // define getter functions for harmony exports
        /******/__webpack_require__.d = function (exports, definition) {
            /******/for (var key in definition) {
                /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                    /******/Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
                    /******/
                }
                /******/
            }
            /******/
        };
        /******/
    }();
    /******/
    /******/ /* webpack/runtime/hasOwnProperty shorthand */
    /******/!function () {
        /******/__webpack_require__.o = function (obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
        };
        /******/
    }();
    /******/
    /******/ /* webpack/runtime/make namespace object */
    /******/!function () {
        /******/ // define __esModule on exports
        /******/__webpack_require__.r = function (exports) {
            /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
                /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
                /******/
            }
            /******/Object.defineProperty(exports, '__esModule', { value: true });
            /******/
        };
        /******/
    }();
    /******/
    /************************************************************************/

    // UNUSED EXPORTS: Splide

    // NAMESPACE OBJECT: ./src/js/constants/states.js
    var states_namespaceObject = {};
    __webpack_require__.r(states_namespaceObject);
    __webpack_require__.d(states_namespaceObject, {
        "CREATED": function CREATED() {
            return _CREATED;
        },
        "DESTROYED": function DESTROYED() {
            return _DESTROYED;
        },
        "IDLE": function IDLE() {
            return _IDLE;
        },
        "MOUNTED": function MOUNTED() {
            return _MOUNTED;
        },
        "MOVING": function MOVING() {
            return _MOVING;
        }
    });

     // CONCATENATED MODULE: ./src/js/core/event.js
    /**
     * The function for providing an Event object simply managing events.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The function for providing an Event object simply managing events.
     */
    /* harmony default export */var core_event = function core_event() {
        /**
         * Store all event data.
         *
         * @type {Array}
         */
        var data = [];
        var Event = {
            /**
             * Subscribe the given event(s).
             *
             * @param {string}   events  - An event name. Use space to separate multiple events.
             *                             Also, namespace is accepted by dot, such as 'resize.{namespace}'.
             * @param {function} handler - A callback function.
             * @param {Element}  elm     - Optional. Native event will be listened to when this arg is provided.
             * @param {Object}   options - Optional. Options for addEventListener.
             */
            on: function on(events, handler, elm, options) {
                if (elm === void 0) {
                    elm = null;
                }

                if (options === void 0) {
                    options = {};
                }

                events.split(' ').forEach(function (event) {
                    if (elm) {
                        elm.addEventListener(event, handler, options);
                    }

                    data.push({
                        event: event,
                        handler: handler,
                        elm: elm,
                        options: options
                    });
                });
            },

            /**
             * Unsubscribe the given event(s).
             *
             * @param {string}  events - A event name or names split by space.
             * @param {Element} elm    - Optional. removeEventListener() will be called when this arg is provided.
             */
            off: function off(events, elm) {
                if (elm === void 0) {
                    elm = null;
                }

                events.split(' ').forEach(function (event) {
                    data = data.filter(function (item) {
                        if (item && item.event === event && item.elm === elm) {
                            unsubscribe(item);
                            return false;
                        }

                        return true;
                    });
                });
            },

            /**
             * Emit an event.
             * This method is only for custom events.
             *
             * @param {string}  event - An event name.
             * @param {*}       args  - Any number of arguments passed to handlers.
             */
            emit: function emit(event) {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                data.forEach(function (item) {
                    if (!item.elm && item.event.split('.')[0] === event) {
                        item.handler.apply(item, args);
                    }
                });
            },

            /**
             * Clear event data.
             */
            destroy: function destroy() {
                data.forEach(unsubscribe);
                data = [];
            }
        };
        /**
         * Remove the registered event listener.
         *
         * @param {Object} item - An object containing event data.
         */

        function unsubscribe(item) {
            if (item.elm) {
                item.elm.removeEventListener(item.event, item.handler, item.options);
            }
        }

        return Event;
    };
     // CONCATENATED MODULE: ./src/js/core/state.js
    /**
     * The function providing a super simple state system.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The function providing a super simple state system.
     *
     * @param {string|number} initialState - Provide the initial state value.
     */
    /* harmony default export */var state = function state(initialState) {
        /**
         * Store the current state.
         *
         * @type {string|number}
         */
        var curr = initialState;
        return {
            /**
             * Change state.
             *
             * @param {string|number} state - A new state.
             */
            set: function set$$1(state) {
                curr = state;
            },

            /**
             * Verify if the current state is given one or not.
             *
             * @param {string|number} state - A state name to be verified.
             *
             * @return {boolean} - True if the current state is the given one.
             */
            is: function is(state) {
                return state === curr;
            }
        };
    };
     // CONCATENATED MODULE: ./src/js/utils/object.js
    function _extends$$1() {
        _extends$$1 = Object.assign || function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }return target;
        };return _extends$$1.apply(this, arguments);
    }

    /**
     * Some utility functions related with Object, supporting IE.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */
    var keys = Object.keys;
    /**
     * Iterate an object like Array.forEach.
     * IE doesn't support forEach of HTMLCollection.
     *
     * @param {Object}    obj       - An object.
     * @param {function}  callback  - A function handling each value. Arguments are value, property and index.
     */

    function each(obj, callback) {
        keys(obj).some(function (key, index) {
            return callback(obj[key], key, index);
        });
    }
    /**
     * Return values of the given object as an array.
     * IE doesn't support Object.values.
     *
     * @param {Object} obj - An object.
     *
     * @return {Array} - An array containing all values of the given object.
     */

    function values(obj) {
        return keys(obj).map(function (key) {
            return obj[key];
        });
    }
    /**
     * Check if the given subject is object or not.
     *
     * @param {*} subject - A subject to be verified.
     *
     * @return {boolean} - True if object, false otherwise.
     */

    function isObject(subject) {
        return (typeof subject === 'undefined' ? 'undefined' : _typeof(subject)) === 'object';
    }
    /**
     * Merge two objects deeply.
     *
     * @param {Object} to   - An object where "from" is merged.
     * @param {Object} from - An object merged to "to".
     *
     * @return {Object} - A merged object.
     */

    function merge(_ref, from) {
        var to = _extends$$1({}, _ref);

        each(from, function (value, key) {
            if (isObject(value)) {
                if (!isObject(to[key])) {
                    to[key] = {};
                }

                to[key] = merge(to[key], value);
            } else {
                to[key] = value;
            }
        });
        return to;
    }
    /**
     * Assign all properties "from" to "to" object.
     *
     * @param {Object} to   - An object where properties are assigned.
     * @param {Object} from - An object whose properties are assigned to "to".
     *
     * @return {Object} - An assigned object.
     */

    function object_assign(to, from) {
        keys(from).forEach(function (key) {
            if (!to[key]) {
                Object.defineProperty(to, key, Object.getOwnPropertyDescriptor(from, key));
            }
        });
        return to;
    }
     // CONCATENATED MODULE: ./src/js/utils/utils.js
    /**
     * A package of some miscellaneous utility functions.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Convert the given value to array.
     *
     * @param {*} value - Any value.
     *
     * @return {*[]} - Array containing the given value.
     */

    function toArray$$1(value) {
        return Array.isArray(value) ? value : [value];
    }
    /**
     * Check if the given value is between min and max.
     * Min will be returned when the value is less than min or max will do when greater than max.
     *
     * @param {number} value - A number to be checked.
     * @param {number} m1    - Minimum or maximum number.
     * @param {number} m2    - Maximum or minimum number.
     *
     * @return {number} - A value itself, min or max.
     */

    function between(value, m1, m2) {
        return Math.min(Math.max(value, m1 > m2 ? m2 : m1), m1 > m2 ? m1 : m2);
    }
    /**
     * The sprintf method with minimum functionality.
     *
     * @param {string}       format       - The string format.
     * @param {string|Array} replacements - Replacements accepting multiple arguments.
     *
     * @returns {string} - Converted string.
     */

    function sprintf(format, replacements) {
        var i = 0;
        return format.replace(/%s/g, function () {
            return toArray$$1(replacements)[i++];
        });
    }
    /**
     * Append px unit to the given subject if necessary.
     *
     * @param {number|string} value - A value that may not include an unit.
     *
     * @return {string} - If the value is string, return itself.
     *                    If number, do value + "px". An empty string, otherwise.
     */

    function unit(value) {
        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

        if (type === 'number' && value > 0) {
            return parseFloat(value) + 'px';
        }

        return type === 'string' ? value : '';
    }
    /**
     * Pad start with 0.
     *
     * @param {number} number - A number to be filled with 0.
     *
     * @return {string|number} - Padded number.
     */

    function pad(number) {
        return number < 10 ? '0' + number : number;
    }
    /**
     * Convert the given value to pixel.
     *
     * @param {Element}       root  - Root element where a dummy div is appended.
     * @param {string|number} value - CSS value to be converted, such as 10rem.
     *
     * @return {number} - Pixel.
     */

    function toPixel(root, value) {
        if (typeof value === 'string') {
            var div = create('div', {});
            applyStyle(div, {
                position: 'absolute',
                width: value
            });
            append(root, div);
            value = div.clientWidth;
            dom_remove(div);
        }

        return +value || 0;
    }
     // CONCATENATED MODULE: ./src/js/utils/dom.js
    /**
     * Some utility functions related with DOM.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Find the first element matching the given selector.
     * Be aware that all selectors after a space are ignored.
     *
     * @param {Element|Node}  elm       - An ancestor element.
     * @param {string}        selector  - DOMString.
     *
     * @return {Element|null} - A found element or null.
     */

    function find(elm, selector) {
        return elm ? elm.querySelector(selector.split(' ')[0]) : null;
    }
    /**
     * Find a first child having the given tag or class name.
     *
     * @param {Element} parent         - A parent element.
     * @param {string}  tagOrClassName - A tag or class name.
     *
     * @return {Element|undefined} - A found element on success or undefined on failure.
     */

    function child(parent, tagOrClassName) {
        return children(parent, tagOrClassName)[0];
    }
    /**
     * Return chile elements that matches the provided tag or class name.
     *
     * @param {Element} parent         - A parent element.
     * @param {string}  tagOrClassName - A tag or class name.
     *
     * @return {Element[]} - Found elements.
     */

    function children(parent, tagOrClassName) {
        if (parent) {
            return values(parent.children).filter(function (child) {
                return hasClass(child, tagOrClassName.split(' ')[0]) || child.tagName === tagOrClassName;
            });
        }

        return [];
    }
    /**
     * Create an element with some optional attributes.
     *
     * @param {string} tag   - A tag name.
     * @param {Object} attrs - An object any attribute pairs of name and value.
     *
     * @return {Element} - A created element.
     */

    function create(tag, attrs) {
        var elm = document.createElement(tag);
        each(attrs, function (value, key) {
            return setAttribute(elm, key, value);
        });
        return elm;
    }
    /**
     * Convert HTML string to DOM node.
     *
     * @param {string} html - HTML string.
     *
     * @return {Node} - A created node.
     */

    function domify(html) {
        var div = create('div', {});
        div.innerHTML = html;
        return div.firstChild;
    }
    /**
     * Remove a given element from a DOM tree.
     *
     * @param {Element|Element[]} elms - Element(s) to be removed.
     */

    function dom_remove(elms) {
        toArray$$1(elms).forEach(function (elm) {
            if (elm) {
                var parent = elm.parentElement;
                parent && parent.removeChild(elm);
            }
        });
    }
    /**
     * Append a child to a given element.
     *
     * @param {Element} parent - A parent element.
     * @param {Element} child  - An element to be appended.
     */

    function append(parent, child) {
        if (parent) {
            parent.appendChild(child);
        }
    }
    /**
     * Insert an element before the reference element.
     *
     * @param {Element|Node} ref - A reference element.
     * @param {Element}      elm - An element to be inserted.
     */

    function before(elm, ref) {
        if (elm && ref) {
            var parent = ref.parentElement;
            parent && parent.insertBefore(elm, ref);
        }
    }
    /**
     * Apply styles to the given element.
     *
     * @param {Element} elm     - An element where styles are applied.
     * @param {Object}  styles  - Object containing styles.
     */

    function applyStyle(elm, styles) {
        if (elm) {
            each(styles, function (value, prop) {
                if (value !== null) {
                    elm.style[prop] = value;
                }
            });
        }
    }
    /**
     * Add or remove classes to/from the element.
     * This function is for internal usage.
     *
     * @param {Element}         elm     - An element where classes are added.
     * @param {string|string[]} classes - Class names being added.
     * @param {boolean}         remove  - Whether to remove or add classes.
     */

    function addOrRemoveClasses(elm, classes, remove) {
        if (elm) {
            toArray$$1(classes).forEach(function (name) {
                if (name) {
                    elm.classList[remove ? 'remove' : 'add'](name);
                }
            });
        }
    }
    /**
     * Add classes to the element.
     *
     * @param {Element}          elm     - An element where classes are added.
     * @param {string|string[]}  classes - Class names being added.
     */

    function addClass(elm, classes) {
        addOrRemoveClasses(elm, classes, false);
    }
    /**
     * Remove a class from the element.
     *
     * @param {Element}         elm     - An element where classes are removed.
     * @param {string|string[]} classes - A class name being removed.
     */

    function removeClass(elm, classes) {
        addOrRemoveClasses(elm, classes, true);
    }
    /**
     * Verify if the provided element has the class or not.
     *
     * @param {Element} elm       - An element.
     * @param {string}  className - A class name.
     *
     * @return {boolean} - True if the element has the class or false if not.
     */

    function hasClass(elm, className) {
        return !!elm && elm.classList.contains(className);
    }
    /**
     * Set attribute to the given element.
     *
     * @param {Element}                 elm   - An element where an attribute is assigned.
     * @param {string}                  name  - Attribute name.
     * @param {string|number|boolean}   value - Attribute value.
     */

    function setAttribute(elm, name, value) {
        if (elm) {
            elm.setAttribute(name, value);
        }
    }
    /**
     * Get attribute from the given element.
     *
     * @param {Element} elm  - An element where an attribute is assigned.
     * @param {string}  name - Attribute name.
     *
     * @return {string} - The value of the given attribute if available. An empty string if not.
     */

    function getAttribute(elm, name) {
        return elm ? elm.getAttribute(name) : '';
    }
    /**
     * Remove attribute from the given element.
     *
     * @param {Element|Element[]} elms  - An element where an attribute is removed.
     * @param {string|string[]}      names - Attribute name.
     */

    function removeAttribute(elms, names) {
        toArray$$1(names).forEach(function (name) {
            toArray$$1(elms).forEach(function (elm) {
                return elm && elm.removeAttribute(name);
            });
        });
    }
    /**
     * Return the Rect object of the provided object.
     *
     * @param {Element} elm - An element.
     *
     * @return {ClientRect|DOMRect} - A rect object.
     */

    function getRect(elm) {
        return elm.getBoundingClientRect();
    }
    /**
     * Trigger the given callback after all images contained by the element are loaded.
     *
     * @param {Element}  elm      - Element that may contain images.
     * @param {Function} callback - Callback function fired right after all images are loaded.
     */

    function loaded(elm, callback) {
        var images = elm.querySelectorAll('img');
        var length = images.length;

        if (length) {
            var count = 0;
            each(images, function (img) {
                img.onload = img.onerror = function () {
                    if (++count === length) {
                        callback();
                    }
                };
            });
        } else {
            // Trigger the callback immediately if there is no image.
            callback();
        }
    }
     // CONCATENATED MODULE: ./src/js/constants/types.js
    /**
     * Export slider types.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Normal slider.
     *
     * @type {string}
     */
    var SLIDE = 'slide';
    /**
     * Loop after the last slide and before the first one.
     *
     * @type {string}
     */

    var LOOP = 'loop';
    /**
     * The track doesn't move.
     *
     * @type {string}
     */

    var FADE = 'fade';
     // CONCATENATED MODULE: ./src/js/transitions/slide/index.js
    /**
     * The component for general slide effect transition.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for general slide effect transition.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var slide = function slide(Splide, Components) {
        /**
         * Hold the list element.
         *
         * @type {Element}
         */
        var list;
        /**
         * Hold the onEnd callback function.
         *
         * @type {function}
         */

        var endCallback;
        return {
            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                list = Components.Elements.list;
                Splide.on('transitionend', function (e) {
                    if (e.target === list && endCallback) {
                        endCallback();
                    }
                }, list);
            },

            /**
             * Start transition.
             *
             * @param {number}   destIndex - Destination slide index that might be clone's.
             * @param {number}   newIndex  - New index.
             * @param {number}   prevIndex - Previous index.
             * @param {Object}   coord     - Destination coordinates.
             * @param {function} done      - Callback function must be invoked when transition is completed.
             */
            start: function start(destIndex, newIndex, prevIndex, coord, done) {
                var options = Splide.options;
                var edgeIndex = Components.Controller.edgeIndex;
                var speed = options.speed;
                endCallback = done;

                if (Splide.is(SLIDE)) {
                    if (prevIndex === 0 && newIndex >= edgeIndex || prevIndex >= edgeIndex && newIndex === 0) {
                        speed = options.rewindSpeed || speed;
                    }
                }

                applyStyle(list, {
                    transition: "transform " + speed + "ms " + options.easing,
                    transform: "translate(" + coord.x + "px," + coord.y + "px)"
                });
            }
        };
    };
     // CONCATENATED MODULE: ./src/js/transitions/fade/index.js
    /**
     * The component for fade transition.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for fade transition.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var fade = function fade(Splide, Components) {
        var Fade = {
            /**
             * Called when the component is mounted.
             * Apply transition style to the first slide.
             */
            mount: function mount() {
                apply(Splide.index);
            },

            /**
             * Start transition.
             *
             * @param {number}    destIndex - Destination slide index that might be clone's.
             * @param {number}    newIndex  - New index.
             * @param {number}    prevIndex - Previous index.
             * @param {Object}    coord     - Destination coordinates.
             * @param {function}  done      - Callback function must be invoked when transition is completed.
             */
            start: function start(destIndex, newIndex, prevIndex, coord, done) {
                var track = Components.Elements.track;
                applyStyle(track, {
                    height: unit(track.clientHeight)
                });
                apply(newIndex);
                setTimeout(function () {
                    done();
                    applyStyle(track, {
                        height: ''
                    });
                });
            }
        };
        /**
         * Apply transition style to the slide specified by the given index.
         *
         * @param {number} index - A slide index.
         */

        function apply(index) {
            var options = Splide.options;
            applyStyle(Components.Elements.slides[index], {
                transition: "opacity " + options.speed + "ms " + options.easing
            });
        }

        return Fade;
    };
     // CONCATENATED MODULE: ./src/js/transitions/index.js
    /**
     * Export transition components.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

     // CONCATENATED MODULE: ./src/js/core/composer.js
    /**
     * Provide a function for composing components.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Compose components.
     *
     * @param {Splide}   Splide     - Splide instance.
     * @param {Object}   Components - Additional components.
     * @param {function} Transition - Change component for transition.
     *
     * @return {Object} - An object containing all components.
     */

    function compose(Splide, Components, Transition) {
        var components = {};
        each(Components, function (Component, name) {
            components[name] = Component(Splide, components, name.toLowerCase());
        });

        if (!Transition) {
            Transition = Splide.is(FADE) ? fade : slide;
        }

        components.Transition = Transition(Splide, components);
        return components;
    }
     // CONCATENATED MODULE: ./src/js/utils/error.js
    /**
     * Utility functions for outputting logs.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Prefix of an error massage.
     *
     * @type {string}
     */
    var MESSAGE_PREFIX = '[SPLIDE]';
    /**
     * Display an error message on the browser console.
     *
     * @param {string} message - An error message.
     */

    function error(message) {
        console.error(MESSAGE_PREFIX + " " + message);
    }
    /**
     * Check existence of the given object and throw an error if it doesn't.
     *
     * @throws {Error}
     *
     * @param {*}      subject - A subject to be confirmed.
     * @param {string} message - An error message.
     */

    function exist(subject, message) {
        if (!subject) {
            throw new Error(message);
        }
    }
     // CONCATENATED MODULE: ./src/js/constants/classes.js
    /**
     * Export class names.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * A root class name.
     *
     * @type {string}
     */
    var ROOT = 'splide';
    /**
     * The definition table of all classes for elements.
     * They might be modified by options.
     *
     * @type {Object}
     */

    var ELEMENT_CLASSES = {
        root: ROOT,
        slider: ROOT + "__slider",
        track: ROOT + "__track",
        list: ROOT + "__list",
        slide: ROOT + "__slide",
        container: ROOT + "__slide__container",
        arrows: ROOT + "__arrows",
        arrow: ROOT + "__arrow",
        prev: ROOT + "__arrow--prev",
        next: ROOT + "__arrow--next",
        pagination: ROOT + "__pagination",
        page: ROOT + "__pagination__page",
        clone: ROOT + "__slide--clone",
        progress: ROOT + "__progress",
        bar: ROOT + "__progress__bar",
        autoplay: ROOT + "__autoplay",
        play: ROOT + "__play",
        pause: ROOT + "__pause",
        spinner: ROOT + "__spinner",
        sr: ROOT + "__sr"
    };
    /**
     * Definitions of status classes.
     *
     * @type {Object}
     */

    var STATUS_CLASSES = {
        active: 'is-active',
        visible: 'is-visible',
        loading: 'is-loading'
    };
     // CONCATENATED MODULE: ./src/js/constants/i18n.js
    /**
     * Export i18n texts as object.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Texts for i18n.
     *
     * @type {Object}
     */
    var I18N = {
        prev: 'Previous slide',
        next: 'Next slide',
        first: 'Go to first slide',
        last: 'Go to last slide',
        slideX: 'Go to slide %s',
        pageX: 'Go to page %s',
        play: 'Start autoplay',
        pause: 'Pause autoplay'
    };
     // CONCATENATED MODULE: ./src/js/constants/defaults.js
    /**
     * Export default options.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    var DEFAULTS = {
        /**
         * Determine a slider type.
         * - 'slide': Regular slider.
         * - 'loop' : Carousel slider.
         * - 'fade' : Change slides with fade transition. perPage, drag options are ignored.
         *
         * @type {string}
         */
        type: 'slide',

        /**
         * Whether to rewind a slider before the first slide or after the last one.
         * In "loop" mode, this option is ignored.
         *
         * @type {boolean}
         */
        rewind: false,

        /**
         * Transition speed in milliseconds.
         *
         * @type {number}
         */
        speed: 400,

        /**
         * Transition speed on rewind in milliseconds.
         *
         * @type {number}
         */
        rewindSpeed: 0,

        /**
         * Whether to prevent any actions while a slider is transitioning.
         * If false, navigation, drag and swipe work while the slider is running.
         * Even so, it will be forced to wait for transition in some cases in the loop mode to shift a slider.
         *
         * @type {boolean}
         */
        waitForTransition: true,

        /**
         * Define slider max width.
         *
         * @type {number}
         */
        width: 0,

        /**
         * Define slider height.
         *
         * @type {number}
         */
        height: 0,

        /**
         * Fix width of slides. CSS format is allowed such as 10em, 80% or 80vw.
         * perPage number will be ignored when this option is falsy.
         *
         * @type {number|string}
         */
        fixedWidth: 0,

        /**
         * Fix height of slides. CSS format is allowed such as 10em, 80vh but % unit is not accepted.
         * heightRatio option will be ignored when this option is falsy.
         *
         * @type {number|string}
         */
        fixedHeight: 0,

        /**
         * Determine height of slides by ratio to a slider width.
         * This will be ignored when the fixedHeight is provided.
         *
         * @type {number}
         */
        heightRatio: 0,

        /**
         * If true, slide width will be determined by the element width itself.
         * - perPage/perMove should be 1.
         *
         * @type {boolean}
         */
        autoWidth: false,

        /**
         * If true, slide height will be determined by the element width itself.
         * - perPage/perMove should be 1.
         *
         * @type {boolean}
         */
        autoHeight: false,

        /**
         * Determine how many slides should be displayed per page.
         *
         * @type {number}
         */
        perPage: 1,

        /**
         * Determine how many slides should be moved when a slider goes to next or perv.
         *
         * @type {number}
         */
        perMove: 0,

        /**
         * Determine manually how many clones should be generated on the left and right side.
         * The total number of clones will be twice of this number.
         *
         * @type {number}
         */
        clones: 0,

        /**
         * Start index.
         *
         * @type {number}
         */
        start: 0,

        /**
         * Determine which slide should be focused if there are multiple slides in a page.
         * A string "center" is acceptable for centering slides.
         *
         * @type {boolean|number|string}
         */
        focus: false,

        /**
         * Gap between slides. CSS format is allowed such as 1em.
         *
         * @type {number|string}
         */
        gap: 0,

        /**
         * Set padding-left/right in horizontal mode or padding-top/bottom in vertical one.
         * Give a single value to set a same size for both sides or
         * do an object for different sizes.
         * Also, CSS format is allowed such as 1em.
         *
         * @example
         * - 10: Number
         * - '1em': CSS format.
         * - { left: 0, right: 20 }: Object for different sizes in horizontal mode.
         * - { top: 0, bottom: 20 }: Object for different sizes in vertical mode.
         *
         * @type {number|string|Object}
         */
        padding: 0,

        /**
         * Whether to append arrows.
         *
         * @type {boolean}
         */
        arrows: true,

        /**
         * Change the arrow SVG path like 'm7.61 0.807-2.12...'.
         *
         * @type {string}
         */
        arrowPath: '',

        /**
         * Whether to append pagination(indicator dots) or not.
         *
         * @type {boolean}
         */
        pagination: true,

        /**
         * Activate autoplay.
         *
         * @type {boolean}
         */
        autoplay: false,

        /**
         * Autoplay interval in milliseconds.
         *
         * @type {number}
         */
        interval: 5000,

        /**
         * Whether to stop autoplay when a slider is hovered.
         *
         * @type {boolean}
         */
        pauseOnHover: true,

        /**
         * Whether to stop autoplay when a slider elements are focused.
         * True is recommended for accessibility.
         *
         * @type {boolean}
         */
        pauseOnFocus: true,

        /**
         * Whether to reset progress of the autoplay timer when resumed.
         *
         * @type {boolean}
         */
        resetProgress: true,

        /**
         * Loading images lazily.
         * Image src must be provided by a data-splide-lazy attribute.
         *
         * - false: Do nothing.
         * - 'nearby': Only images around an active slide will be loaded.
         * - 'sequential': All images will be sequentially loaded.
         *
         * @type {boolean|string}
         */
        lazyLoad: false,

        /**
         * This option works only when a lazyLoad option is "nearby".
         * Determine how many pages(not slides) around an active slide should be loaded beforehand.
         *
         * @type {number}
         */
        preloadPages: 1,

        /**
         * Easing for CSS transition. For example, linear, ease or cubic-bezier().
         *
         * @type {string}
         */
        easing: 'cubic-bezier(.42,.65,.27,.99)',

        /**
         * Whether to enable keyboard shortcuts
         * - true or 'global': Listen to keydown event of the document.
         * - 'focused': Listen to the keydown event of the slider root element. tabindex="0" will be added to the element.
         * - false: Disable keyboard shortcuts.
         *
         * @type {boolean|string}
         */
        keyboard: 'global',

        /**
         * Whether to allow mouse drag and touch swipe.
         *
         * @type {boolean}
         */
        drag: true,

        /**
         * The angle threshold for drag.
         * The slider starts moving only when the drag angle is less than this threshold.
         *
         * @type {number}
         */
        dragAngleThreshold: 30,

        /**
         * Distance threshold for determining if the action is "flick" or "swipe".
         * When a drag distance is over this value, the action will be treated as "swipe", not "flick".
         *
         * @type {number}
         */
        swipeDistanceThreshold: 150,

        /**
         * Velocity threshold for determining if the action is "flick" or "swipe".
         * Around 0.5 is recommended.
         *
         * @type {number}
         */
        flickVelocityThreshold: .6,

        /**
         * Determine power of flick. The larger number this is, the farther a slider runs by flick.
         * Around 500 is recommended.
         *
         * @type {number}
         */
        flickPower: 600,

        /**
         * Limit a number of pages to move by flick.
         *
         * @type {number}
         */
        flickMaxPages: 1,

        /**
         * Slider direction.
         * - 'ltr': Left to right.
         * - 'rtl': Right to left.
         * - 'ttb': Top to bottom.
         *
         * @type {string}
         */
        direction: 'ltr',

        /**
         * Set img src to background-image of its parent element.
         * Images with various sizes can be displayed as same dimension without cropping work.
         * fixedHeight or heightRatio is required.
         *
         * @type {boolean}
         */
        cover: false,

        /**
         * Whether to enable accessibility(aria and screen reader texts) or not.
         *
         * @type {boolean}
         */
        accessibility: true,

        /**
         * Whether to add tabindex="0" to visible slides or not.
         *
         * @type {boolean}
         */
        slideFocus: true,

        /**
         * Determine if a slider is navigation for another.
         * Use "sync" API to synchronize two sliders.
         *
         * @type {boolean}
         */
        isNavigation: false,

        /**
         * Whether to trim spaces before the fist slide or after the last one when "focus" is not 0.
         *
         * @type {boolean}
         */
        trimSpace: true,

        /**
         * The "is-active" class is added after transition as default.
         * If true, it will be added before move.
         *
         * @type {boolean}
         */
        updateOnMove: false,

        /**
         * Throttle duration in milliseconds for the resize event.
         *
         * @type {number}
         */
        throttle: 100,

        /**
         * Whether to destroy a slider or not.
         *
         * @type {boolean}
         */
        destroy: false,

        /**
         * Options for specific breakpoints.
         *
         * @example
         * {
         *   1000: {
         *     perPage: 3,
         *     gap: 20
         *   },
         *   600: {
         *     perPage: 1,
         *     gap: 5,
         *   }
         * }
         *
         * @type {boolean|Object}
         */
        breakpoints: false,

        /**
         * Collection of class names.
         *
         * @see ./classes.js
         *
         * @type {Object}
         */
        classes: ELEMENT_CLASSES,

        /**
         * Collection of i18n texts.
         *
         * @see ./i18n.js
         *
         * @type {Object}
         */
        i18n: I18N
    };
     // CONCATENATED MODULE: ./src/js/constants/states.js
    /**
     * Export state constants.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Splide has been just created.
     *
     * @type {number}
     */
    var _CREATED = 1;
    /**
     * All components have been mounted and initialized.
     *
     * @type {number}
     */

    var _MOUNTED = 2;
    /**
     * Splide is ready for transition.
     *
     * @type {number}
     */

    var _IDLE = 3;
    /**
     * Splide is moving.
     *
     * @type {number}
     */

    var _MOVING = 4;
    /**
     * Splide is moving.
     *
     * @type {number}
     */

    var _DESTROYED = 5;
     // CONCATENATED MODULE: ./src/js/splide-slider-core.js
    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
    }

    /**
     * The main class for applying Splide to an element.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The main class for applying Splide to an element,
     * providing some APIs to control the behavior.
     */

    var Splide = /*#__PURE__*/function () {
        /**
         * Splide constructor.
         *
         * @throws {Error} When the given root element or selector is invalid.
         *
         * @param {Element|string}  root       - A selector for a root element or an element itself.
         * @param {Object}          options    - Optional. Options to change default behaviour.
         * @param {Object}          Components - Optional. Components.
         */
        function Splide(root, options, Components) {
            if (options === void 0) {
                options = {};
            }

            if (Components === void 0) {
                Components = {};
            }

            this.root = root instanceof Element ? root : document.querySelector(root);
            exist(this.root, 'An invalid element/selector was given.');
            this.Components = null;
            this.Event = core_event();
            this.State = state(_CREATED);
            this.STATES = states_namespaceObject;
            this._o = merge(DEFAULTS, options);
            this._i = 0;
            this._c = Components;
            this._e = {}; // Extensions

            this._t = null; // Transition
        }
        /**
         * Compose and mount components.
         *
         * @param {Object}   Extensions - Optional. Additional components.
         * @param {function} Transition - Optional. Set a custom transition component.
         *
         * @return {Splide|undefined} - This instance or undefined if an exception occurred.
         */

        var _proto = Splide.prototype;

        _proto.mount = function mount(Extensions, Transition) {
            var _this = this;

            if (Extensions === void 0) {
                Extensions = this._e;
            }

            if (Transition === void 0) {
                Transition = this._t;
            }

            // Reset the state.
            this.State.set(_CREATED);
            this._e = Extensions;
            this._t = Transition;
            this.Components = compose(this, merge(this._c, Extensions), Transition);

            try {
                each(this.Components, function (component, key) {
                    var required = component.required;

                    if (required === undefined || required) {
                        component.mount && component.mount();
                    } else {
                        delete _this.Components[key];
                    }
                });
            } catch (e) {
                error(e.message);
                return;
            }

            var State = this.State;
            State.set(_MOUNTED);
            each(this.Components, function (component) {
                component.mounted && component.mounted();
            });
            this.emit('mounted');
            State.set(_IDLE);
            this.emit('ready');
            applyStyle(this.root, {
                visibility: 'visible'
            });
            this.on('move drag', function () {
                return State.set(_MOVING);
            }).on('moved dragged', function () {
                return State.set(_IDLE);
            });
            return this;
        }
        /**
         * Set sync target.
         *
         * @param {Splide} splide - A Splide instance.
         *
         * @return {Splide} - This instance.
         */
        ;

        _proto.sync = function sync(splide) {
            this.sibling = splide;
            return this;
        }
        /**
         * Register callback fired on the given event(s).
         *
         * @param {string}   events  - An event name. Use space to separate multiple events.
         *                             Also, namespace is accepted by dot, such as 'resize.{namespace}'.
         * @param {function} handler - A callback function.
         * @param {Element}  elm     - Optional. Native event will be listened to when this arg is provided.
         * @param {Object}   options - Optional. Options for addEventListener.
         *
         * @return {Splide} - This instance.
         */
        ;

        _proto.on = function on(events, handler, elm, options) {
            if (elm === void 0) {
                elm = null;
            }

            if (options === void 0) {
                options = {};
            }

            this.Event.on(events, handler, elm, options);
            return this;
        }
        /**
         * Unsubscribe the given event.
         *
         * @param {string}  events - A event name.
         * @param {Element} elm    - Optional. removeEventListener() will be called when this arg is provided.
         *
         * @return {Splide} - This instance.
         */
        ;

        _proto.off = function off(events, elm) {
            if (elm === void 0) {
                elm = null;
            }

            this.Event.off(events, elm);
            return this;
        }
        /**
         * Emit an event.
         *
         * @param {string} event - An event name.
         * @param {*}      args  - Any number of arguments passed to handlers.
         */
        ;

        _proto.emit = function emit(event) {
            var _this$Event;

            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            (_this$Event = this.Event).emit.apply(_this$Event, [event].concat(args));

            return this;
        }
        /**
         * Go to the slide specified by the given control.
         *
         * @param {string|number} control - A control pattern.
         * @param {boolean}       wait    - Optional. Whether to wait for transition.
         */
        ;

        _proto.go = function go(control, wait) {
            if (wait === void 0) {
                wait = this.options.waitForTransition;
            }

            if (this.State.is(_IDLE) || this.State.is(_MOVING) && !wait) {
                this.Components.Controller.go(control, false);
            }

            return this;
        }
        /**
         * Verify whether the slider type is the given one or not.
         *
         * @param {string} type - A slider type.
         *
         * @return {boolean} - True if the slider type is the provided type or false if not.
         */
        ;

        _proto.is = function is(type) {
            return type === this._o.type;
        }
        /**
         * Insert a slide.
         *
         * @param {Element|string} slide - A slide element to be added.
         * @param {number}         index - A slide will be added at the position.
         */
        ;

        _proto.add = function add(slide, index) {
            if (index === void 0) {
                index = -1;
            }

            this.Components.Elements.add(slide, index, this.refresh.bind(this));
            return this;
        }
        /**
         * Remove the slide designated by the index.
         *
         * @param {number} index - A slide index.
         */
        ;

        _proto.remove = function remove(index) {
            this.Components.Elements.remove(index);
            this.refresh();
            return this;
        }
        /**
         * Destroy all Slide objects and clones and recreate them again.
         */
        ;

        _proto.refresh = function refresh() {
            this.emit('refresh:before').emit('refresh').emit('resize');
            return this;
        }
        /**
         * Destroy the Splide.
         * "Completely" boolean is mainly for breakpoints.
         *
         * @param {boolean} completely - Destroy completely.
         */
        ;

        _proto.destroy = function destroy(completely) {
            var _this2 = this;

            if (completely === void 0) {
                completely = true;
            }

            // Postpone destroy because it should be done after mount.
            if (this.State.is(_CREATED)) {
                this.on('ready', function () {
                    return _this2.destroy(completely);
                });
                return;
            }

            values(this.Components).reverse().forEach(function (component) {
                component.destroy && component.destroy(completely);
            });
            this.emit('destroy', completely); // Destroy all event handlers, including ones for native events.

            this.Event.destroy();
            this.State.set(_DESTROYED);
            return this;
        }
        /**
         * Return the current slide index.
         *
         * @return {number} - The current slide index.
         // */
        ;

        _createClass(Splide, [{
            key: "index",
            get: function get$$1() {
                return this._i;
            }
            /**
             * Set the current slide index.
             *
             * @param {number|string} index - A new index.
             */

            , set: function set$$1(index) {
                this._i = parseInt(index);
            }
            /**
             * Return length of slides.
             * This is an alias of Elements.length.
             *
             * @return {number} - A number of slides.
             */

        }, {
            key: "length",
            get: function get$$1() {
                return this.Components.Elements.length;
            }
            /**
             * Return options.
             *
             * @return {Object} - Options object.
             */

        }, {
            key: "options",
            get: function get$$1() {
                return this._o;
            }
            /**
             * Set options with merging the given object to the current one.
             *
             * @param {Object} options - New options.
             */

            , set: function set$$1(options) {
                var created = this.State.is(_CREATED);

                if (!created) {
                    this.emit('update');
                }

                this._o = merge(this._o, options);

                if (!created) {
                    this.emit('updated', this._o);
                }
            }
            /**
             * Return the class list.
             * This is an alias of Splide.options.classList.
             *
             * @return {Object} - An object containing all class list.
             */

        }, {
            key: "classes",
            get: function get$$1() {
                return this._o.classes;
            }
            /**
             * Return the i18n strings.
             * This is an alias of Splide.options.i18n.
             *
             * @return {Object} - An object containing all i18n strings.
             */

        }, {
            key: "i18n",
            get: function get$$1() {
                return this._o.i18n;
            }
        }]);

        return Splide;
    }();

     // CONCATENATED MODULE: ./src/js/components/options/index.js
    /**
     * The component for initializing options.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for initializing options.
     *
     * @param {Splide} Splide - A Splide instance.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var options = function options(Splide) {
        /**
         * Retrieve options from the data attribute.
         * Note that IE10 doesn't support dataset property.
         *
         * @type {string}
         */
        var options = getAttribute(Splide.root, 'data-splide');

        if (options) {
            try {
                Splide.options = JSON.parse(options);
            } catch (e) {
                error(e.message);
            }
        }

        return {
            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                if (Splide.State.is(_CREATED)) {
                    Splide.index = Splide.options.start;
                }
            }
        };
    };
     // CONCATENATED MODULE: ./src/js/constants/directions.js
    /**
     * Export layout modes.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Enumerate slides from left to right.
     *
     * @type {string}
     */
    var RTL = 'rtl';
    /**
     * Enumerate slides in a col.
     *
     * @type {string}
     */

    var TTB = 'ttb';
     // CONCATENATED MODULE: ./src/js/components/elements/slide.js
    /**
     * The sub component for handling each slide.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Events for restoring original styles.
     *
     * @type {string}
     */

    var STYLE_RESTORE_EVENTS = 'update.slide';
    /**
     * The sub component for handling each slide.
     *
     * @param {Splide}  Splide    - A Splide instance.
     * @param {number}  index     - An unique slide index.
     * @param {number}  realIndex - Clones should pass a real slide index.
     * @param {Element} slide     - A slide element.
     *
     * @return {Object} - The sub component object.
     */

    /* harmony default export */var elements_slide = function elements_slide(Splide, index, realIndex, slide) {
        /**
         * Whether to update "is-active" class before or after transition.
         *
         * @type {boolean}
         */
        var updateOnMove = Splide.options.updateOnMove;
        /**
         * Events when the slide status is updated.
         * Append a namespace to remove listeners later.
         *
         * @type {string}
         */

        var STATUS_UPDATE_EVENTS = 'ready.slide updated.slide resized.slide moved.slide' + (updateOnMove ? ' move.slide' : '');
        /**
         * Slide sub component object.
         *
         * @type {Object}
         */

        var Slide = {
            /**
             * Slide element.
             *
             * @type {Element}
             */
            slide: slide,

            /**
             * Slide index.
             *
             * @type {number}
             */
            index: index,

            /**
             * Real index for clones.
             *
             * @type {number}
             */
            realIndex: realIndex,

            /**
             * Container element if available.
             *
             * @type {Element|undefined}
             */
            container: child(slide, Splide.classes.container),

            /**
             * Whether this is a cloned slide or not.
             *
             * @type {boolean}
             */
            isClone: realIndex > -1,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                var _this = this;

                if (!this.isClone) {
                    slide.id = Splide.root.id + "-slide" + pad(index + 1);
                }

                Splide.on(STATUS_UPDATE_EVENTS, function () {
                    return _this.update();
                }).on(STYLE_RESTORE_EVENTS, restoreStyles).on('click', function () {
                    return Splide.emit('click', _this);
                }, slide);
                /*
                * Add "is-active" class to a clone element temporarily
                * and it will be removed on "moved" event.
                */

                if (updateOnMove) {
                    Splide.on('move.slide', function (newIndex) {
                        if (newIndex === realIndex) {
                            _update(true, false);
                        }
                    });
                } // Make sure the slide is shown.


                applyStyle(slide, {
                    display: ''
                }); // Hold the original styles.

                this.styles = getAttribute(slide, 'style') || '';
            },

            /**
             * Destroy.
             */
            destroy: function destroy() {
                Splide.off(STATUS_UPDATE_EVENTS).off(STYLE_RESTORE_EVENTS).off('click', slide);
                removeClass(slide, values(STATUS_CLASSES));
                restoreStyles();
                removeAttribute(this.container, 'style');
            },

            /**
             * Update active and visible status.
             */
            update: function update() {
                _update(this.isActive(), false);

                _update(this.isVisible(), true);
            },

            /**
             * Check whether this slide is active or not.
             *
             * @return {boolean} - True if the slide is active or false if not.
             */
            isActive: function isActive() {
                return Splide.index === index;
            },

            /**
             * Check whether this slide is visible in the viewport or not.
             *
             * @return {boolean} - True if the slide is visible or false if not.
             */
            isVisible: function isVisible() {
                var active = this.isActive();

                if (Splide.is(FADE) || active) {
                    return active;
                }

                var ceil = Math.ceil;
                var trackRect = getRect(Splide.Components.Elements.track);
                var slideRect = getRect(slide);

                if (Splide.options.direction === TTB) {
                    return trackRect.top <= slideRect.top && slideRect.bottom <= ceil(trackRect.bottom);
                }

                return trackRect.left <= slideRect.left && slideRect.right <= ceil(trackRect.right);
            },

            /**
             * Calculate how far this slide is from another slide and
             * return true if the distance is within the given number.
             *
             * @param {number} from   - Index of a target slide.
             * @param {number} within - True if the slide is within this number.
             *
             * @return {boolean} - True if the slide is within the number or false otherwise.
             */
            isWithin: function isWithin(from, within) {
                var diff = Math.abs(from - index);

                if (!Splide.is(SLIDE) && !this.isClone) {
                    diff = Math.min(diff, Splide.length - diff);
                }

                return diff < within;
            }
        };
        /**
         * Update classes for activity or visibility.
         *
         * @param {boolean} active        - Is active/visible or not.
         * @param {boolean} forVisibility - Toggle classes for activity or visibility.
         */

        function _update(active, forVisibility) {
            var type = forVisibility ? 'visible' : 'active';
            var className = STATUS_CLASSES[type];

            if (active) {
                addClass(slide, className);
                Splide.emit("" + type, Slide);
            } else {
                if (hasClass(slide, className)) {
                    removeClass(slide, className);
                    Splide.emit("" + (forVisibility ? 'hidden' : 'inactive'), Slide);
                }
            }
        }
        /**
         * Restore the original styles.
         */

        function restoreStyles() {
            setAttribute(slide, 'style', Slide.styles);
        }

        return Slide;
    };
     // CONCATENATED MODULE: ./src/js/components/elements/index.js
    /**
     * The component for main elements.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The property name for UID stored in a window object.
     *
     * @type {string}
     */

    var UID_NAME = 'uid';
    /**
     * The component for main elements.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var components_elements = function components_elements(Splide, Components) {
        /**
         * Hold the root element.
         *
         * @type {Element}
         */
        var root = Splide.root;
        /**
         * Hold the class list.
         *
         * @type {Object}
         */

        var classes = Splide.classes;
        /**
         * Store Slide objects.
         *
         * @type {Array}
         */

        var Slides = [];
        /*
        * Assign unique ID to the root element if it doesn't have the one.
        * Note that IE doesn't support padStart() to fill the uid by 0.
        */

        if (!root.id) {
            window.splide = window.splide || {};
            var uid = window.splide[UID_NAME] || 0;
            window.splide[UID_NAME] = ++uid;
            root.id = "splide" + pad(uid);
        }
        /**
         * Elements component object.
         *
         * @type {Object}
         */

        var Elements = {
            /**
             * Called when the component is mounted.
             * Collect main elements and store them as member properties.
             */
            mount: function mount() {
                var _this = this;

                this.init();
                Splide.on('refresh', function () {
                    _this.destroy();

                    _this.init();
                }).on('updated', function () {
                    removeClass(root, getClasses());
                    addClass(root, getClasses());
                });
            },

            /**
             * Destroy.
             */
            destroy: function destroy() {
                Slides.forEach(function (Slide) {
                    Slide.destroy();
                });
                Slides = [];
                removeClass(root, getClasses());
            },

            /**
             * Initialization.
             */
            init: function init() {
                var _this2 = this;

                collect();
                addClass(root, getClasses());
                this.slides.forEach(function (slide, index) {
                    _this2.register(slide, index, -1);
                });
            },

            /**
             * Register a slide to create a Slide object and handle its behavior.
             *
             * @param {Element} slide     - A slide element.
             * @param {number}  index     - A unique index. This can be negative.
             * @param {number}  realIndex - A real index for clones. Set -1 for real slides.
             */
            register: function register(slide, index, realIndex) {
                var SlideObject = elements_slide(Splide, index, realIndex, slide);
                SlideObject.mount();
                Slides.push(SlideObject);
            },

            /**
             * Return the Slide object designated by the index.
             * Note that "find" is not supported by IE.
             *
             * @return {Object|undefined} - A Slide object if available. Undefined if not.
             */
            getSlide: function getSlide(index) {
                return Slides.filter(function (Slide) {
                    return Slide.index === index;
                })[0];
            },

            /**
             * Return all Slide objects.
             *
             * @param {boolean} includeClones - Whether to include cloned slides or not.
             *
             * @return {Object[]} - Slide objects.
             */
            getSlides: function getSlides(includeClones) {
                return includeClones ? Slides : Slides.filter(function (Slide) {
                    return !Slide.isClone;
                });
            },

            /**
             * Return Slide objects belonging to the given page.
             *
             * @param {number} page - A page number.
             *
             * @return {Object[]} - An array containing Slide objects.
             */
            getSlidesByPage: function getSlidesByPage(page) {
                var idx = Components.Controller.toIndex(page);
                var options = Splide.options;
                var max = options.focus !== false ? 1 : options.perPage;
                return Slides.filter(function (_ref) {
                    var index = _ref.index;
                    return idx <= index && index < idx + max;
                });
            },

            /**
             * Insert a slide to a slider.
             * Need to refresh Splide after adding a slide.
             *
             * @param {Node|string} slide    - A slide element to be added.
             * @param {number}      index    - A slide will be added at the position.
             * @param {Function}    callback - Called right after the slide is added to the DOM tree.
             */
            add: function add(slide, index, callback) {
                if (typeof slide === 'string') {
                    slide = domify(slide);
                }

                if (slide instanceof Element) {
                    var ref = this.slides[index]; // This will be removed in mount() of a Slide component.

                    applyStyle(slide, {
                        display: 'none'
                    });

                    if (ref) {
                        before(slide, ref);
                        this.slides.splice(index, 0, slide);
                    } else {
                        append(this.list, slide);
                        this.slides.push(slide);
                    }

                    loaded(slide, function () {
                        callback && callback(slide);
                    });
                }
            },

            /**
             * Remove a slide from a slider.
             * Need to refresh Splide after removing a slide.
             *
             * @param index - Slide index.
             */
            remove: function remove(index) {
                dom_remove(this.slides.splice(index, 1)[0]);
            },

            /**
             * Trigger the provided callback for each Slide object.
             *
             * @param {Function} callback - A callback function. The first argument will be the Slide object.
             */
            each: function each(callback) {
                Slides.forEach(callback);
            },

            /**
             * Return slides length without clones.
             *
             * @return {number} - Slide length.
             */
            get length() {
                return this.slides.length;
            },

            /**
             * Return "SlideObjects" length including clones.
             *
             * @return {number} - Slide length including clones.
             */
            get total() {
                return Slides.length;
            }

        };
        /**
         * Collect elements.
         */

        function collect() {
            Elements.slider = child(root, classes.slider);
            Elements.track = find(root, "." + classes.track);
            Elements.list = child(Elements.track, classes.list);
            exist(Elements.track && Elements.list, 'Track or list was not found.');
            Elements.slides = children(Elements.list, classes.slide);
            var arrows = findParts(classes.arrows);
            Elements.arrows = {
                prev: find(arrows, "." + classes.prev),
                next: find(arrows, "." + classes.next)
            };
            var autoplay = findParts(classes.autoplay);
            Elements.bar = find(findParts(classes.progress), "." + classes.bar);
            Elements.play = find(autoplay, "." + classes.play);
            Elements.pause = find(autoplay, "." + classes.pause);
            Elements.track.id = Elements.track.id || root.id + "-track";
            Elements.list.id = Elements.list.id || root.id + "-list";
        }
        /**
         * Return class names for the root element.
         */

        function getClasses() {
            var rootClass = classes.root;
            var options = Splide.options;
            return [rootClass + "--" + options.type, rootClass + "--" + options.direction, options.drag ? rootClass + "--draggable" : '', options.isNavigation ? rootClass + "--nav" : '', STATUS_CLASSES.active];
        }
        /**
         * Find parts only from children of the root or track.
         *
         * @return {Element} - A found element or undefined.
         */

        function findParts(className) {
            return child(root, className) || child(Elements.slider, className);
        }

        return Elements;
    };
     // CONCATENATED MODULE: ./src/js/components/controller/index.js
    /**
     * The component for controlling the track.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    var floor = Math.floor;
    /**
     * The component for controlling the track.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var controller = function controller(Splide, Components) {
        /**
         * Store current options.
         *
         * @type {Object}
         */
        var options;
        /**
         * True if the slide is LOOP mode.
         *
         * @type {boolean}
         */

        var isLoop;
        /**
         * Controller component object.
         *
         * @type {Object}
         */

        var Controller = {
            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                options = Splide.options;
                isLoop = Splide.is(LOOP);
                bind();
            },

            /**
             * Make track run by the given control.
             * - "+{i}" : Increment the slide index by i.
             * - "-{i}" : Decrement the slide index by i.
             * - "{i}"  : Go to the slide whose index is i.
             * - ">"    : Go to next page.
             * - "<"    : Go to prev page.
             * - ">{i}" : Go to page i.
             *
             * @param {string|number} control  - A control pattern.
             * @param {boolean}       silently - Go to the destination without event emission.
             */
            go: function go(control, silently) {
                var destIndex = this.trim(this.parse(control));
                Components.Track.go(destIndex, this.rewind(destIndex), silently);
            },

            /**
             * Parse the given control and return the destination index for the track.
             *
             * @param {string} control - A control target pattern.
             *
             * @return {number} - A parsed target.
             */
            parse: function parse(control) {
                var index = Splide.index;
                var matches = String(control).match(/([+\-<>]+)(\d+)?/);
                var indicator = matches ? matches[1] : '';
                var number = matches ? parseInt(matches[2]) : 0;

                switch (indicator) {
                    case '+':
                        index += number || 1;
                        break;

                    case '-':
                        index -= number || 1;
                        break;

                    case '>':
                    case '<':
                        index = parsePage(number, index, indicator === '<');
                        break;

                    default:
                        index = parseInt(control);
                }

                return index;
            },

            /**
             * Compute index from the given page number.
             *
             * @param {number} page - Page number.
             *
             * @return {number} - A computed page number.
             */
            toIndex: function toIndex(page) {
                if (hasFocus()) {
                    return page;
                }

                var length = Splide.length;
                var perPage = options.perPage;
                var index = page * perPage;
                index = index - (this.pageLength * perPage - length) * floor(index / length); // Adjustment for the last page.

                if (length - perPage <= index && index < length) {
                    index = length - perPage;
                }

                return index;
            },

            /**
             * Compute page number from the given slide index.
             *
             * @param {number} index - Slide index.
             *
             * @return {number} - A computed page number.
             */
            toPage: function toPage(index) {
                if (hasFocus()) {
                    return index;
                }

                var length = Splide.length;
                var perPage = options.perPage; // Make the last "perPage" number of slides belong to the last page.

                if (length - perPage <= index && index < length) {
                    return floor((length - 1) / perPage);
                }

                return floor(index / perPage);
            },

            /**
             * Trim the given index according to the current mode.
             * Index being returned could be less than 0 or greater than the length in Loop mode.
             *
             * @param {number} index - An index being trimmed.
             *
             * @return {number} - A trimmed index.
             */
            trim: function trim(index) {
                if (!isLoop) {
                    index = options.rewind ? this.rewind(index) : between(index, 0, this.edgeIndex);
                }

                return index;
            },

            /**
             * Rewind the given index if it's out of range.
             *
             * @param {number} index - An index.
             *
             * @return {number} - A rewound index.
             */
            rewind: function rewind(index) {
                var edge = this.edgeIndex;

                if (isLoop) {
                    while (index > edge) {
                        index -= edge + 1;
                    }

                    while (index < 0) {
                        index += edge + 1;
                    }
                } else {
                    if (index > edge) {
                        index = 0;
                    } else if (index < 0) {
                        index = edge;
                    }
                }

                return index;
            },

            /**
             * Check if the direction is "rtl" or not.
             *
             * @return {boolean} - True if "rtl" or false if not.
             */
            isRtl: function isRtl() {
                return options.direction === RTL;
            },

            /**
             * Return the page length.
             *
             * @return {number} - Max page number.
             */
            get pageLength() {
                var length = Splide.length;
                return hasFocus() ? length : Math.ceil(length / options.perPage);
            },

            /**
             * Return the edge index.
             *
             * @return {number} - Edge index.
             */
            get edgeIndex() {
                var length = Splide.length;

                if (!length) {
                    return 0;
                }

                if (hasFocus() || options.isNavigation || isLoop) {
                    return length - 1;
                }

                return length - options.perPage;
            },

            /**
             * Return the index of the previous slide.
             *
             * @return {number} - The index of the previous slide if available. -1 otherwise.
             */
            get prevIndex() {
                var prev = Splide.index - 1;

                if (isLoop || options.rewind) {
                    prev = this.rewind(prev);
                }

                return prev > -1 ? prev : -1;
            },

            /**
             * Return the index of the next slide.
             *
             * @return {number} - The index of the next slide if available. -1 otherwise.
             */
            get nextIndex() {
                var next = Splide.index + 1;

                if (isLoop || options.rewind) {
                    next = this.rewind(next);
                }

                return Splide.index < next && next <= this.edgeIndex || next === 0 ? next : -1;
            }

        };
        /**
         * Listen to some events.
         */

        function bind() {
            Splide.on('move', function (newIndex) {
                Splide.index = newIndex;
            }).on('updated refresh', function (newOptions) {
                options = newOptions || options;
                Splide.index = between(Splide.index, 0, Controller.edgeIndex);
            });
        }
        /**
         * Verify if the focus option is available or not.
         *
         * @return {boolean} - True if a slider has the focus option.
         */

        function hasFocus() {
            return options.focus !== false;
        }
        /**
         * Return the next or previous page index computed by the page number and current index.
         *
         * @param {number}  number - Specify the page number.
         * @param {number}  index  - Current index.
         * @param {boolean} prev   - Prev or next.
         *
         * @return {number} - Slide index.
         */

        function parsePage(number, index, prev) {
            if (number > -1) {
                return Controller.toIndex(number);
            }

            var perMove = options.perMove;
            var sign = prev ? -1 : 1;

            if (perMove) {
                return index + perMove * sign;
            }

            return Controller.toIndex(Controller.toPage(index) + sign);
        }

        return Controller;
    };
     // CONCATENATED MODULE: ./src/js/components/track/index.js
    /**
     * The component for moving list in the track.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    var abs = Math.abs;
    /**
     * The component for moving list in the track.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var track = function track(Splide, Components) {
        /**
         * Hold the Layout component.
         *
         * @type {Object}
         */
        var Layout;
        /**
         * Hold the Layout component.
         *
         * @type {Object}
         */

        var Elements;
        /**
         * Store the list element.
         *
         * @type {Element}
         */

        var list;
        /**
         * Whether the current direction is vertical or not.
         *
         * @type {boolean}
         */

        var isVertical = Splide.options.direction === TTB;
        /**
         * Whether the slider type is FADE or not.
         *
         * @type {boolean}
         */

        var isFade = Splide.is(FADE);
        /**
         * Whether the slider direction is RTL or not.
         *
         * @type {boolean}
         */

        var isRTL = Splide.options.direction === RTL;
        /**
         * This will be true while transitioning from the last index to the first one.
         *
         * @type {boolean}
         */

        var isLoopPending = false;
        /**
         * Sign for the direction. Only RTL mode uses the positive sign.
         *
         * @type {number}
         */

        var sign = isRTL ? 1 : -1;
        /**
         * Track component object.
         *
         * @type {Object}
         */

        var Track = {
            /**
             * Make public the sign defined locally.
             *
             * @type {number}
             */
            sign: sign,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                Elements = Components.Elements;
                Layout = Components.Layout;
                list = Elements.list;
            },

            /**
             * Called after the component is mounted.
             * The resize event must be registered after the Layout's one is done.
             */
            mounted: function mounted() {
                var _this = this;

                if (!isFade) {
                    this.jump(0);
                    Splide.on('mounted resize updated', function () {
                        _this.jump(Splide.index);
                    });
                }
            },

            /**
             * Go to the given destination index.
             * After arriving there, the track is jump to the new index without animation, mainly for loop mode.
             *
             * @param {number}  destIndex - A destination index.
             *                              This can be negative or greater than slides length for reaching clones.
             * @param {number}  newIndex  - An actual new index. They are always same in Slide and Rewind mode.
             * @param {boolean} silently  - If true, suppress emitting events.
             */
            go: function go(destIndex, newIndex, silently) {
                var newPosition = getTrimmedPosition(destIndex);
                var prevIndex = Splide.index; // Prevent any actions while transitioning from the last index to the first one for jump.

                if (Splide.State.is(_MOVING) && isLoopPending) {
                    return;
                }

                isLoopPending = destIndex !== newIndex;

                if (!silently) {
                    Splide.emit('move', newIndex, prevIndex, destIndex);
                }

                if (Math.abs(newPosition - this.position) >= 1 || isFade) {
                    Components.Transition.start(destIndex, newIndex, prevIndex, this.toCoord(newPosition), function () {
                        onTransitionEnd(destIndex, newIndex, prevIndex, silently);
                    });
                } else {
                    if (destIndex !== prevIndex && Splide.options.trimSpace === 'move') {
                        Components.Controller.go(destIndex + destIndex - prevIndex, silently);
                    } else {
                        onTransitionEnd(destIndex, newIndex, prevIndex, silently);
                    }
                }
            },

            /**
             * Move the track to the specified index.
             *
             * @param {number} index - A destination index where the track jumps.
             */
            jump: function jump(index) {
                this.translate(getTrimmedPosition(index));
            },

            /**
             * Set the list position by CSS translate property.
             *
             * @param {number} position - A new position value.
             */
            translate: function translate(position) {
                applyStyle(list, {
                    transform: "translate" + (isVertical ? 'Y' : 'X') + "(" + position + "px)"
                });
            },

            /**
             * Cancel the transition and set the list position.
             * Also, loop the slider if necessary.
             */
            cancel: function cancel() {
                if (Splide.is(LOOP)) {
                    this.shift();
                } else {
                    // Ensure the current position.
                    this.translate(this.position);
                }

                applyStyle(list, {
                    transition: ''
                });
            },

            /**
             * Shift the slider if it exceeds borders on the edge.
             */
            shift: function shift() {
                var position = abs(this.position);
                var left = abs(this.toPosition(0));
                var right = abs(this.toPosition(Splide.length));
                var innerSize = right - left;

                if (position < left) {
                    position += innerSize;
                } else if (position > right) {
                    position -= innerSize;
                }

                this.translate(sign * position);
            },

            /**
             * Trim redundant spaces on the left or right edge if necessary.
             *
             * @param {number} position - Position value to be trimmed.
             *
             * @return {number} - Trimmed position.
             */
            trim: function trim(position) {
                if (!Splide.options.trimSpace || Splide.is(LOOP)) {
                    return position;
                }

                var edge = sign * (Layout.totalSize() - Layout.size - Layout.gap);
                return between(position, edge, 0);
            },

            /**
             * Calculate the closest slide index from the given position.
             *
             * @param {number} position - A position converted to an slide index.
             *
             * @return {number} - The closest slide index.
             */
            toIndex: function toIndex(position) {
                var _this2 = this;

                var index = 0;
                var minDistance = Infinity;
                Elements.getSlides(true).forEach(function (Slide) {
                    var slideIndex = Slide.index;
                    var distance = abs(_this2.toPosition(slideIndex) - position);

                    if (distance < minDistance) {
                        minDistance = distance;
                        index = slideIndex;
                    }
                });
                return index;
            },

            /**
             * Return coordinates object by the given position.
             *
             * @param {number} position - A position value.
             *
             * @return {Object} - A coordinates object.
             */
            toCoord: function toCoord(position) {
                return {
                    x: isVertical ? 0 : position,
                    y: isVertical ? position : 0
                };
            },

            /**
             * Calculate the track position by a slide index.
             *
             * @param {number} index - Slide index.
             *
             * @return {Object} - Calculated position.
             */
            toPosition: function toPosition(index) {
                var position = Layout.totalSize(index) - Layout.slideSize(index) - Layout.gap;
                return sign * (position + this.offset(index));
            },

            /**
             * Return the current offset value, considering direction.
             *
             * @return {number} - Offset amount.
             */
            offset: function offset(index) {
                var focus = Splide.options.focus;
                var slideSize = Layout.slideSize(index);

                if (focus === 'center') {
                    return -(Layout.size - slideSize) / 2;
                }

                return -(parseInt(focus) || 0) * (slideSize + Layout.gap);
            },

            /**
             * Return the current position.
             * This returns the correct position even while transitioning by CSS.
             *
             * @return {number} - Current position.
             */
            get position() {
                var prop = isVertical ? 'top' : isRTL ? 'right' : 'left';
                return getRect(list)[prop] - (getRect(Elements.track)[prop] - Layout.padding[prop] * sign);
            }

        };
        /**
         * Called whenever slides arrive at a destination.
         *
         * @param {number}  destIndex - A destination index.
         * @param {number}  newIndex  - A new index.
         * @param {number}  prevIndex - A previous index.
         * @param {boolean} silently  - If true, suppress emitting events.
         */

        function onTransitionEnd(destIndex, newIndex, prevIndex, silently) {
            applyStyle(list, {
                transition: ''
            });
            isLoopPending = false;

            if (!isFade) {
                Track.jump(newIndex);
            }

            if (!silently) {
                Splide.emit('moved', newIndex, prevIndex, destIndex);
            }
        }
        /**
         * Convert index to the trimmed position.
         *
         * @return {number} - Trimmed position.
         */

        function getTrimmedPosition(index) {
            return Track.trim(Track.toPosition(index));
        }

        return Track;
    };
     // CONCATENATED MODULE: ./src/js/components/clones/index.js
    /**
     * The component for cloning some slides for "loop" mode of the track.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for cloning some slides for "loop" mode of the track.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var clones = function clones(Splide, Components) {
        /**
         * Store information of all clones.
         *
         * @type {Array}
         */
        var clones = [];
        /**
         * Store the current clone count on one side.
         *
         * @type {number}
         */

        var cloneCount = 0;
        /**
         * Keep Elements component.
         *
         * @type {Object}
         */

        var Elements = Components.Elements;
        /**
         * Clones component object.
         *
         * @type {Object}
         */

        var Clones = {
            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                var _this = this;

                if (Splide.is(LOOP)) {
                    init();
                    Splide.on('refresh:before', function () {
                        _this.destroy();
                    }).on('refresh', init).on('resize', function () {
                        if (cloneCount !== getCloneCount()) {
                            // Destroy before refresh not to collect clones by the Elements component.
                            _this.destroy();

                            Splide.refresh();
                        }
                    });
                }
            },

            /**
             * Destroy.
             */
            destroy: function destroy() {
                dom_remove(clones);
                clones = [];
            },

            /**
             * Return all clones.
             *
             * @return {Element[]} - Cloned elements.
             */
            get clones() {
                return clones;
            },

            /**
             * Return clone length.
             *
             * @return {number} - A length of clones.
             */
            get length() {
                return clones.length;
            }

        };
        /**
         * Initialization.
         */

        function init() {
            Clones.destroy();
            cloneCount = getCloneCount();
            generateClones(cloneCount);
        }
        /**
         * Generate and append/prepend clones.
         *
         * @param {number} count - The half number of clones.
         */

        function generateClones(count) {
            var length = Elements.length,
                register = Elements.register;

            if (length) {
                var slides = Elements.slides;

                while (slides.length < count) {
                    slides = slides.concat(slides);
                } // Clones after the last element.


                slides.slice(0, count).forEach(function (elm, index) {
                    var clone = cloneDeeply(elm);
                    append(Elements.list, clone);
                    clones.push(clone);
                    register(clone, index + length, index % length);
                }); // Clones before the first element.

                slides.slice(-count).forEach(function (elm, index) {
                    var clone = cloneDeeply(elm);
                    before(clone, slides[0]);
                    clones.push(clone);
                    register(clone, index - count, (length + index - count % length) % length);
                });
            }
        }
        /**
         * Return half count of clones to be generated.
         * Clone count is determined by:
         * - "clones" value in the options.
         * - Number of slides that can be placed in a view in "fixed" mode.
         * - Max pages a flick action can move.
         * - Whether the slide length is enough for perPage.
         *
         * @return {number} - Count for clones.
         */

        function getCloneCount() {
            var options = Splide.options;

            if (options.clones) {
                return options.clones;
            } // Use the slide length in autoWidth mode because the number cannot be calculated.


            var baseCount = options.autoWidth || options.autoHeight ? Elements.length : options.perPage;
            var dimension = options.direction === TTB ? 'Height' : 'Width';
            var fixedSize = toPixel(Splide.root, options["fixed" + dimension]);

            if (fixedSize) {
                // Roughly calculate the count. This needs not to be strict.
                baseCount = Math.ceil(Elements.track["client" + dimension] / fixedSize);
            }

            return baseCount * (options.drag ? options.flickMaxPages + 1 : 1);
        }
        /**
         * Clone deeply the given element.
         *
         * @param {Element} elm - An element being duplicated.
         *
         * @return {Node} - A cloned node(element).
         */

        function cloneDeeply(elm) {
            var clone = elm.cloneNode(true);
            addClass(clone, Splide.classes.clone); // ID should not be duplicated.

            removeAttribute(clone, 'id');
            return clone;
        }

        return Clones;
    };
     // CONCATENATED MODULE: ./src/js/components/layout/directions/horizontal.js
    /**
     * The resolver component for horizontal layout.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The resolver component for horizontal layout.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The resolver object.
     */

    /* harmony default export */var horizontal = function horizontal(Splide, Components) {
        /**
         * Keep the Elements component.
         *
         * @type {string}
         */
        var Elements = Components.Elements;
        /**
         * Keep the root element.
         *
         * @type {Element}
         */

        var root = Splide.root;
        /**
         * Keep the track element.
         *
         * @type {Element}
         */

        var track;
        /**
         * Keep the latest options.
         *
         * @type {Element}
         */

        var options = Splide.options;
        return {
            /**
             * Margin property name.
             *
             * @type {string}
             */
            margin: 'margin' + (options.direction === RTL ? 'Left' : 'Right'),

            /**
             * Always 0 because the height will be determined by inner contents.
             *
             * @type {number}
             */
            height: 0,

            /**
             * Initialization.
             */
            init: function init() {
                this.resize();
            },

            /**
             * Resize gap and padding.
             * This must be called on init.
             */
            resize: function resize() {
                options = Splide.options;
                track = Elements.track;
                this.gap = toPixel(root, options.gap);
                var padding = options.padding;
                var left = toPixel(root, padding.left || padding);
                var right = toPixel(root, padding.right || padding);
                this.padding = {
                    left: left,
                    right: right
                };
                applyStyle(track, {
                    paddingLeft: unit(left),
                    paddingRight: unit(right)
                });
            },

            /**
             * Return total width from the left of the list to the right of the slide specified by the provided index.
             *
             * @param {number} index - Optional. A slide index. If undefined, total width of the slider will be returned.
             *
             * @return {number} - Total width to the right side of the specified slide, or 0 for an invalid index.
             */
            totalWidth: function totalWidth(index) {
                if (index === void 0) {
                    index = Splide.length - 1;
                }

                var Slide = Elements.getSlide(index);
                var width = 0;

                if (Slide) {
                    var slideRect = getRect(Slide.slide);
                    var listRect = getRect(Elements.list);

                    if (options.direction === RTL) {
                        width = listRect.right - slideRect.left;
                    } else {
                        width = slideRect.right - listRect.left;
                    }

                    width += this.gap;
                }

                return width;
            },

            /**
             * Return the slide width in px.
             *
             * @param {number} index - Slide index.
             *
             * @return {number} - The slide width.
             */
            slideWidth: function slideWidth(index) {
                if (options.autoWidth) {
                    var Slide = Elements.getSlide(index);
                    return Slide ? Slide.slide.offsetWidth : 0;
                }

                var width = options.fixedWidth || (this.width + this.gap) / options.perPage - this.gap;
                return toPixel(root, width);
            },

            /**
             * Return the slide height in px.
             *
             * @return {number} - The slide height.
             */
            slideHeight: function slideHeight() {
                var height = options.height || options.fixedHeight || this.width * options.heightRatio;
                return toPixel(root, height);
            },

            /**
             * Return slider width without padding.
             *
             * @return {number} - Current slider width.
             */
            get width() {
                return track.clientWidth - this.padding.left - this.padding.right;
            }

        };
    };
     // CONCATENATED MODULE: ./src/js/components/layout/directions/vertical.js
    /**
     * The resolver component for vertical layout.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The resolver component for vertical layout.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The resolver object.
     */

    /* harmony default export */var vertical = function vertical(Splide, Components) {
        /**
         * Keep the Elements component.
         *
         * @type {string}
         */
        var Elements = Components.Elements;
        /**
         * Keep the root element.
         *
         * @type {Element}
         */

        var root = Splide.root;
        /**
         * Keep the track element.
         *
         * @type {Element}
         */

        var track;
        /**
         * Keep the latest options.
         *
         * @type {Element}
         */

        var options;
        return {
            /**
             * Margin property name.
             *
             * @type {string}
             */
            margin: 'marginBottom',

            /**
             * Initialization.
             */
            init: function init() {
                this.resize();
            },

            /**
             * Resize gap and padding.
             * This must be called on init.
             */
            resize: function resize() {
                options = Splide.options;
                track = Elements.track;
                this.gap = toPixel(root, options.gap);
                var padding = options.padding;
                var top = toPixel(root, padding.top || padding);
                var bottom = toPixel(root, padding.bottom || padding);
                this.padding = {
                    top: top,
                    bottom: bottom
                };
                applyStyle(track, {
                    paddingTop: unit(top),
                    paddingBottom: unit(bottom)
                });
            },

            /**
             * Return total height from the top of the list to the bottom of the slide specified by the provided index.
             *
             * @param {number} index - Optional. A slide index. If undefined, total height of the slider will be returned.
             *
             * @return {number} - Total height to the bottom of the specified slide, or 0 for an invalid index.
             */
            totalHeight: function totalHeight(index) {
                if (index === void 0) {
                    index = Splide.length - 1;
                }

                var Slide = Elements.getSlide(index);

                if (Slide) {
                    return getRect(Slide.slide).bottom - getRect(Elements.list).top + this.gap;
                }

                return 0;
            },

            /**
             * Return the slide width in px.
             *
             * @return {number} - The slide width.
             */
            slideWidth: function slideWidth() {
                return toPixel(root, options.fixedWidth || this.width);
            },

            /**
             * Return the slide height in px.
             *
             * @param {number} index - Slide index.
             *
             * @return {number} - The slide height.
             */
            slideHeight: function slideHeight(index) {
                if (options.autoHeight) {
                    var Slide = Elements.getSlide(index);
                    return Slide ? Slide.slide.offsetHeight : 0;
                }

                var height = options.fixedHeight || (this.height + this.gap) / options.perPage - this.gap;
                return toPixel(root, height);
            },

            /**
             * Return slider width without padding.
             *
             * @return {number} - Current slider width.
             */
            get width() {
                return track.clientWidth;
            },

            /**
             * Return slide height without padding.
             *
             * @return {number} - Slider height.
             */
            get height() {
                var height = options.height || this.width * options.heightRatio;
                exist(height, '"height" or "heightRatio" is missing.');
                return toPixel(root, height) - this.padding.top - this.padding.bottom;
            }

        };
    };
     // CONCATENATED MODULE: ./src/js/utils/time.js
    /**
     * A package of utility functions related with time.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Simple throttle function that controls how often the given function is executed.
     *
     * @param {function} func - A function to be throttled.
     * @param {number}   wait - Time in millisecond for interval of execution.
     *
     * @return {Function} - A debounced function.
     */
    function throttle(func, wait) {
        var timeout; // Declare function by the "function" keyword to prevent "this" from being inherited.

        return function () {
            if (!timeout) {
                timeout = setTimeout(function () {
                    func();
                    timeout = null;
                }, wait);
            }
        };
    }
    /**
     * Custom setInterval function that provides progress rate as callback.
     *
     * @param {function} callback - A callback function fired every time the interval time passes.
     * @param {number}   interval - Interval duration in milliseconds.
     * @param {function} progress - A callback function fired whenever the progress goes.
     *
     * @return {Object} - An object containing play() and pause() functions.
     */

    function createInterval(callback, interval, progress) {
        var _window = window,
            requestAnimationFrame = _window.requestAnimationFrame;
        var start,
            elapse,
            rate,
            _pause = true;

        var step = function step(timestamp) {
            if (!_pause) {
                if (!start) {
                    start = timestamp;

                    if (rate && rate < 1) {
                        start -= rate * interval;
                    }
                }

                elapse = timestamp - start;
                rate = elapse / interval;

                if (elapse >= interval) {
                    start = 0;
                    rate = 1;
                    callback();
                }

                if (progress) {
                    progress(rate);
                }

                requestAnimationFrame(step);
            }
        };

        return {
            pause: function pause() {
                _pause = true;
                start = 0;
            },
            play: function play(reset) {
                start = 0;

                if (reset) {
                    rate = 0;
                }

                if (_pause) {
                    _pause = false;
                    requestAnimationFrame(step);
                }
            }
        };
    }
     // CONCATENATED MODULE: ./src/js/components/layout/index.js
    /**
     * The component for handing slide layouts and their sizes.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for handing slide layouts and their sizes.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var layout = function layout(Splide, Components) {
        /**
         * Keep the Elements component.
         *
         * @type {string}
         */
        var Elements = Components.Elements;
        /**
         * Whether the slider is vertical or not.
         *
         * @type {boolean}
         */

        var isVertical = Splide.options.direction === TTB;
        /**
         * Layout component object.
         *
         * @type {Object}
         */

        var Layout = object_assign({
            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                bind();
                init(); // The word "size" means width for a horizontal slider and height for a vertical slider.

                this.totalSize = isVertical ? this.totalHeight : this.totalWidth;
                this.slideSize = isVertical ? this.slideHeight : this.slideWidth;
            },

            /**
             * Destroy the component.
             */
            destroy: function destroy() {
                removeAttribute([Elements.list, Elements.track], 'style');
            },

            /**
             * Return the slider height on the vertical mode or width on the horizontal mode.
             *
             * @return {number}
             */
            get size() {
                return isVertical ? this.height : this.width;
            }

        }, isVertical ? vertical(Splide, Components) : horizontal(Splide, Components));
        /**
         * Init slider styles according to options.
         */

        function init() {
            Layout.init();
            applyStyle(Splide.root, {
                maxWidth: unit(Splide.options.width)
            });
            Elements.each(function (Slide) {
                Slide.slide.style[Layout.margin] = unit(Layout.gap);
            });
            resize();
        }
        /**
         * Listen the resize native event with throttle.
         * Initialize when the component is mounted or options are updated.
         */

        function bind() {
            Splide.on('resize load', throttle(function () {
                Splide.emit('resize');
            }, Splide.options.throttle), window).on('resize', resize).on('updated refresh', init);
        }
        /**
         * Resize the track and slide elements.
         */

        function resize() {
            var options = Splide.options;
            Layout.resize();
            applyStyle(Elements.track, {
                height: unit(Layout.height)
            });
            var slideHeight = options.autoHeight ? null : unit(Layout.slideHeight());
            Elements.each(function (Slide) {
                applyStyle(Slide.container, {
                    height: slideHeight
                });
                applyStyle(Slide.slide, {
                    width: options.autoWidth ? null : unit(Layout.slideWidth(Slide.index)),
                    height: Slide.container ? null : slideHeight
                });
            });
            Splide.emit('resized');
        }

        return Layout;
    };
     // CONCATENATED MODULE: ./src/js/components/drag/index.js
    /**
     * The component for supporting mouse drag and swipe.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    var drag_abs = Math.abs;
    /**
     * If the absolute velocity is greater thant this value,
     * a slider always goes to a different slide after drag, not allowed to stay on a current slide.
     */

    var MIN_VELOCITY = 0.1;
    /**
     * Adjust how much the track can be pulled on the first or last page.
     * The larger number this is, the farther the track moves.
     * This should be around 5 - 9.
     *
     * @type {number}
     */

    var FRICTION_REDUCER = 7;
    /**
     * The component supporting mouse drag and swipe.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var drag = function drag(Splide, Components) {
        /**
         * Store the Move component.
         *
         * @type {Object}
         */
        var Track = Components.Track;
        /**
         * Store the Controller component.
         *
         * @type {Object}
         */

        var Controller = Components.Controller;
        /**
         * Coordinate of the track on starting drag.
         *
         * @type {Object}
         */

        var startCoord;
        /**
         * Analyzed info on starting drag.
         *
         * @type {Object|null}
         */

        var startInfo;
        /**
         * Analyzed info being updated while dragging/swiping.
         *
         * @type {Object}
         */

        var currentInfo;
        /**
         * Determine whether slides are being dragged or not.
         *
         * @type {boolean}
         */

        var isDragging;
        /**
         * Whether the slider direction is vertical or not.
         *
         * @type {boolean}
         */

        var isVertical = Splide.options.direction === TTB;
        /**
         * Axis for the direction.
         *
         * @type {string}
         */

        var axis = isVertical ? 'y' : 'x';
        /**
         * Drag component object.
         *
         * @type {Object}
         */

        var Drag = {
            /**
             * Whether dragging is disabled or not.
             *
             * @type {boolean}
             */
            disabled: false,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                var _this = this;

                var Elements = Components.Elements;
                var track = Elements.track;
                Splide.on('touchstart mousedown', start, track).on('touchmove mousemove', move, track, {
                    passive: false
                }).on('touchend touchcancel mouseleave mouseup dragend', end, track).on('mounted refresh', function () {
                    // Prevent dragging an image or anchor itself.
                    each(Elements.list.querySelectorAll('img, a'), function (elm) {
                        Splide.off('dragstart', elm).on('dragstart', function (e) {
                            e.preventDefault();
                        }, elm, {
                            passive: false
                        });
                    });
                }).on('mounted updated', function () {
                    _this.disabled = !Splide.options.drag;
                });
            }
        };
        /**
         * Called when the track starts to be dragged.
         *
         * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
         */

        function start(e) {
            if (!Drag.disabled && !isDragging) {
                // These prams are used to evaluate whether the slider should start moving.
                init(e);
            }
        }
        /**
         * Initialize parameters.
         *
         * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
         */

        function init(e) {
            startCoord = Track.toCoord(Track.position);
            startInfo = analyze(e, {});
            currentInfo = startInfo;
        }
        /**
         * Called while the track being dragged.
         *
         * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
         */

        function move(e) {
            if (startInfo) {
                currentInfo = analyze(e, startInfo);

                if (isDragging) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }

                    if (!Splide.is(FADE)) {
                        var position = startCoord[axis] + currentInfo.offset[axis];
                        Track.translate(resist(position));
                    }
                } else {
                    if (shouldMove(currentInfo)) {
                        Splide.emit('drag', startInfo);
                        isDragging = true;
                        Track.cancel(); // These params are actual drag data.

                        init(e);
                    }
                }
            }
        }
        /**
         * Determine whether to start moving the track or not by drag angle.
         *
         * @param {Object} info - An information object.
         *
         * @return {boolean} - True if the track should be moved or false if not.
         */

        function shouldMove(_ref) {
            var offset = _ref.offset;

            if (Splide.State.is(_MOVING) && Splide.options.waitForTransition) {
                return false;
            }

            var angle = Math.atan(drag_abs(offset.y) / drag_abs(offset.x)) * 180 / Math.PI;

            if (isVertical) {
                angle = 90 - angle;
            }

            return angle < Splide.options.dragAngleThreshold;
        }
        /**
         * Resist dragging the track on the first/last page because there is no more.
         *
         * @param {number} position - A position being applied to the track.
         *
         * @return {Object} - Adjusted position.
         */

        function resist(position) {
            if (Splide.is(SLIDE)) {
                var sign = Track.sign;

                var _start = sign * Track.trim(Track.toPosition(0));

                var _end = sign * Track.trim(Track.toPosition(Controller.edgeIndex));

                position *= sign;

                if (position < _start) {
                    position = _start - FRICTION_REDUCER * Math.log(_start - position);
                } else if (position > _end) {
                    position = _end + FRICTION_REDUCER * Math.log(position - _end);
                }

                position *= sign;
            }

            return position;
        }
        /**
         * Called when dragging ends.
         */

        function end() {
            startInfo = null;

            if (isDragging) {
                Splide.emit('dragged', currentInfo);
                go(currentInfo);
                isDragging = false;
            }
        }
        /**
         * Go to the slide determined by the analyzed data.
         *
         * @param {Object} info - An info object.
         */

        function go(info) {
            var velocity = info.velocity[axis];
            var absV = drag_abs(velocity);

            if (absV > 0) {
                var options = Splide.options;
                var index = Splide.index;
                var sign = velocity < 0 ? -1 : 1;
                var destIndex = index;

                if (!Splide.is(FADE)) {
                    var destination = Track.position;

                    if (absV > options.flickVelocityThreshold && drag_abs(info.offset[axis]) < options.swipeDistanceThreshold) {
                        destination += sign * Math.min(absV * options.flickPower, Components.Layout.size * (options.flickMaxPages || 1));
                    }

                    destIndex = Track.toIndex(destination);
                }
                /*
                * Do not allow the track to go to a previous position if there is enough velocity.
                * Always use the adjacent index for the fade mode.
                */

                if (destIndex === index && absV > MIN_VELOCITY) {
                    destIndex = index + sign * Track.sign;
                }

                if (Splide.is(SLIDE)) {
                    destIndex = between(destIndex, 0, Controller.edgeIndex);
                }

                Controller.go(destIndex, options.isNavigation);
            }
        }
        /**
         * Analyze the given event object and return important information for handling swipe behavior.
         *
         * @param {Event}   e          - Touch or Mouse event object.
         * @param {Object}  startInfo  - Information analyzed on start for calculating difference from the current one.
         *
         * @return {Object} - An object containing analyzed information, such as offset, velocity, etc.
         */

        function analyze(e, startInfo) {
            var timeStamp = e.timeStamp,
                touches = e.touches;

            var _ref2 = touches ? touches[0] : e,
                clientX = _ref2.clientX,
                clientY = _ref2.clientY;

            var _ref3 = startInfo.to || {},
                _ref3$x = _ref3.x,
                fromX = _ref3$x === void 0 ? clientX : _ref3$x,
                _ref3$y = _ref3.y,
                fromY = _ref3$y === void 0 ? clientY : _ref3$y;

            var startTime = startInfo.time || 0;
            var offset = {
                x: clientX - fromX,
                y: clientY - fromY
            };
            var duration = timeStamp - startTime;
            var velocity = {
                x: offset.x / duration,
                y: offset.y / duration
            };
            return {
                to: {
                    x: clientX,
                    y: clientY
                },
                offset: offset,
                time: timeStamp,
                velocity: velocity
            };
        }

        return Drag;
    };
     // CONCATENATED MODULE: ./src/js/components/click/index.js
    /**
     * The component for handling a click event.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for handling a click event.
     * Click should be disabled during drag/swipe.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */
    /* harmony default export */var click = function click(Splide, Components) {
        /**
         * Whether click is disabled or not.
         *
         * @type {boolean}
         */
        var disabled = false;
        /**
         * Click component object.
         *
         * @type {Object}
         */

        var Click = {
            /**
             * Mount only when the drag is activated and the slide type is not "fade".
             *
             * @type {boolean}
             */
            required: Splide.options.drag,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                Splide.on('click', onClick, Components.Elements.track, {
                    capture: true
                }).on('drag', function () {
                    disabled = true;
                }).on('dragged', function () {
                    // Make sure the flag is released after the click event is fired.
                    setTimeout(function () {
                        disabled = false;
                    });
                });
            }
        };
        /**
         * Called when a track element is clicked.
         *
         * @param {Event} e - A click event.
         */

        function onClick(e) {
            if (disabled) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
        }

        return Click;
    };
     // CONCATENATED MODULE: ./src/js/components/autoplay/index.js
    /**
     * The component for playing slides automatically.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Set of pause flags.
     */

    var PAUSE_FLAGS = {
        HOVER: 1,
        FOCUS: 2,
        MANUAL: 3
    };
    /**
     * The component for playing slides automatically.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     * @param {string} name       - A component name as a lowercase string.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var autoplay = function autoplay(Splide, Components, name) {
        /**
         * Store pause flags.
         *
         * @type {Array}
         */
        var flags = [];
        /**
         * Store an interval object.
         *
         * @type {Object};
         */

        var interval;
        /**
         * Keep the Elements component.
         *
         * @type {string}
         */

        var Elements = Components.Elements;
        /**
         * Autoplay component object.
         *
         * @type {Object}
         */

        var Autoplay = {
            /**
             * Required only when the autoplay option is true.
             *
             * @type {boolean}
             */
            required: Splide.options.autoplay,

            /**
             * Called when the component is mounted.
             * Note that autoplay starts only if there are slides over perPage number.
             */
            mount: function mount() {
                var options = Splide.options;

                if (Elements.slides.length > options.perPage) {
                    interval = createInterval(function () {
                        Splide.go('>');
                    }, options.interval, function (rate) {
                        Splide.emit(name + ":playing", rate);

                        if (Elements.bar) {
                            applyStyle(Elements.bar, {
                                width: rate * 100 + "%"
                            });
                        }
                    });
                    bind();
                    this.play();
                }
            },

            /**
             * Start autoplay.
             *
             * @param {number} flag - A pause flag to be removed.
             */
            play: function play(flag) {
                if (flag === void 0) {
                    flag = 0;
                }

                flags = flags.filter(function (f) {
                    return f !== flag;
                });

                if (!flags.length) {
                    Splide.emit(name + ":play");
                    interval.play(Splide.options.resetProgress);
                }
            },

            /**
             * Pause autoplay.
             * Note that Array.includes is not supported by IE.
             *
             * @param {number} flag - A pause flag to be added.
             */
            pause: function pause(flag) {
                if (flag === void 0) {
                    flag = 0;
                }

                interval.pause();

                if (flags.indexOf(flag) === -1) {
                    flags.push(flag);
                }

                if (flags.length === 1) {
                    Splide.emit(name + ":pause");
                }
            }
        };
        /**
         * Listen some events.
         */

        function bind() {
            var options = Splide.options;
            var sibling = Splide.sibling;
            var elms = [Splide.root, sibling ? sibling.root : null];

            if (options.pauseOnHover) {
                switchOn(elms, 'mouseleave', PAUSE_FLAGS.HOVER, true);
                switchOn(elms, 'mouseenter', PAUSE_FLAGS.HOVER, false);
            }

            if (options.pauseOnFocus) {
                switchOn(elms, 'focusout', PAUSE_FLAGS.FOCUS, true);
                switchOn(elms, 'focusin', PAUSE_FLAGS.FOCUS, false);
            }

            if (Elements.play) {
                Splide.on('click', function () {
                    // Need to be removed a focus flag at first.
                    Autoplay.play(PAUSE_FLAGS.FOCUS);
                    Autoplay.play(PAUSE_FLAGS.MANUAL);
                }, Elements.play);
            }

            if (Elements.pause) {
                switchOn([Elements.pause], 'click', PAUSE_FLAGS.MANUAL, false);
            }

            Splide.on('move refresh', function () {
                Autoplay.play();
            }) // Rewind the timer.
            .on('destroy', function () {
                Autoplay.pause();
            });
        }
        /**
         * Play or pause on the given event.
         *
         * @param {Element[]} elms  - Elements.
         * @param {string}    event - An event name or names.
         * @param {number}    flag  - A pause flag defined on the top.
         * @param {boolean}   play  - Determine whether to play or pause.
         */

        function switchOn(elms, event, flag, play) {
            elms.forEach(function (elm) {
                Splide.on(event, function () {
                    Autoplay[play ? 'play' : 'pause'](flag);
                }, elm);
            });
        }

        return Autoplay;
    };
     // CONCATENATED MODULE: ./src/js/components/cover/index.js
    /**
     * The component for change an img element to background image of its wrapper.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for change an img element to background image of its wrapper.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var cover = function cover(Splide, Components) {
        /**
         * Hold options.
         *
         * @type {Object}
         */
        var options = Splide.options;
        /**
         * Cover component object.
         *
         * @type {Object}
         */

        var Cover = {
            /**
             * Required only when "cover" option is true.
             *
             * @type {boolean}
             */
            required: options.cover,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                Splide.on('lazyload:loaded', function (img) {
                    cover(img, false);
                });
                Splide.on('mounted updated refresh', function () {
                    return apply(false);
                });
            },

            /**
             * Destroy.
             */
            destroy: function destroy() {
                apply(true);
            }
        };
        /**
         * Apply "cover" to all slides.
         *
         * @param {boolean} uncover - If true, "cover" will be clear.
         */

        function apply(uncover) {
            Components.Elements.each(function (Slide) {
                var img = child(Slide.slide, 'IMG') || child(Slide.container, 'IMG');

                if (img && img.src) {
                    cover(img, uncover);
                }
            });
        }
        /**
         * Set background image of the parent element, using source of the given image element.
         *
         * @param {Element} img     - An image element.
         * @param {boolean} uncover - Reset "cover".
         */

        function cover(img, uncover) {
            applyStyle(img.parentElement, {
                background: uncover ? '' : "center/cover no-repeat url(\"" + img.src + "\")"
            });
            applyStyle(img, {
                display: uncover ? '' : 'none'
            });
        }

        return Cover;
    };
     // CONCATENATED MODULE: ./src/js/components/arrows/path.js
    /**
     * Export vector path for an arrow.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Namespace definition for SVG element.
     *
     * @type {string}
     */
    var XML_NAME_SPACE = 'http://www.w3.org/2000/svg';
    /**
     * The arrow vector path.
     *
     * @type {number}
     */

    var PATH = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';
    /**
     * SVG width and height.
     *
     * @type {number}
     */

    var SIZE = 40;
     // CONCATENATED MODULE: ./src/js/components/arrows/index.js
    /**
     * The component for appending prev/next arrows.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for appending prev/next arrows.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     * @param {string} name       - A component name as a lowercase string.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var arrows = function arrows(Splide, Components, name) {
        /**
         * Previous arrow element.
         *
         * @type {Element|undefined}
         */
        var prev;
        /**
         * Next arrow element.
         *
         * @type {Element|undefined}
         */

        var next;
        /**
         * Store the class list.
         *
         * @type {Object}
         */

        var classes = Splide.classes;
        /**
         * Hold the root element.
         *
         * @type {Element}
         */

        var root = Splide.root;
        /**
         * Whether arrows are created programmatically or not.
         *
         * @type {boolean}
         */

        var created;
        /**
         * Hold the Elements component.
         *
         * @type {Object}
         */

        var Elements = Components.Elements;
        /**
         * Arrows component object.
         *
         * @type {Object}
         */

        var Arrows = {
            /**
             * Required when the arrows option is true.
             *
             * @type {boolean}
             */
            required: Splide.options.arrows,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                // Attempt to get arrows from HTML source.
                prev = Elements.arrows.prev;
                next = Elements.arrows.next; // If arrows were not found in HTML, let's generate them.

                if ((!prev || !next) && Splide.options.arrows) {
                    prev = createArrow(true);
                    next = createArrow(false);
                    created = true;
                    appendArrows();
                }

                if (prev && next) {
                    bind();
                }

                this.arrows = {
                    prev: prev,
                    next: next
                };
            },

            /**
             * Called after all components are mounted.
             */
            mounted: function mounted() {
                Splide.emit(name + ":mounted", prev, next);
            },

            /**
             * Destroy.
             */
            destroy: function destroy() {
                removeAttribute([prev, next], 'disabled');

                if (created) {
                    dom_remove(prev.parentElement);
                }
            }
        };
        /**
         * Listen to native and custom events.
         */

        function bind() {
            Splide.on('click', function () {
                Splide.go('<');
            }, prev).on('click', function () {
                Splide.go('>');
            }, next).on('mounted move updated refresh', updateDisabled);
        }
        /**
         * Update a disabled attribute.
         */

        function updateDisabled() {
            var _Components$Controlle = Components.Controller,
                prevIndex = _Components$Controlle.prevIndex,
                nextIndex = _Components$Controlle.nextIndex;
            var isEnough = Splide.length > Splide.options.perPage || Splide.is(LOOP);
            prev.disabled = prevIndex < 0 || !isEnough;
            next.disabled = nextIndex < 0 || !isEnough;
            Splide.emit(name + ":updated", prev, next, prevIndex, nextIndex);
        }
        /**
         * Create a wrapper element and append arrows.
         */

        function appendArrows() {
            var wrapper = create('div', {
                "class": classes.arrows
            });
            append(wrapper, prev);
            append(wrapper, next);
            var slider = Elements.slider;
            var parent = Splide.options.arrows === 'slider' && slider ? slider : root;
            before(wrapper, parent.firstElementChild);
        }
        /**
         * Create an arrow element.
         *
         * @param {boolean} prev - Determine to create a prev arrow or next arrow.
         *
         * @return {Element} - A created arrow element.
         */

        function createArrow(prev) {
            var arrow = "<button class=\"" + classes.arrow + " " + (prev ? classes.prev : classes.next) + "\" type=\"button\">" + ("<svg xmlns=\"" + XML_NAME_SPACE + "\"\tviewBox=\"0 0 " + SIZE + " " + SIZE + "\"\twidth=\"" + SIZE + "\"\theight=\"" + SIZE + "\">") + ("<path d=\"" + (Splide.options.arrowPath || PATH) + "\" />");
            return domify(arrow);
        }

        return Arrows;
    };
     // CONCATENATED MODULE: ./src/js/components/pagination/index.js
    /**
     * The component for handling pagination
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The event name for updating some attributes of pagination nodes.
     *
     * @type {string}
     */

    var ATTRIBUTES_UPDATE_EVENT = 'move.page';
    /**
     * The event name for recreating pagination.
     *
     * @type {string}
     */

    var UPDATE_EVENT = 'updated.page refresh.page';
    /**
     * The component for handling pagination
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     * @param {string} name       - A component name as a lowercase string.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var pagination = function pagination(Splide, Components, name) {
        /**
         * Store all data for pagination.
         * - list: A list element.
         * - items: An array that contains objects(li, button, index, page).
         *
         * @type {Object}
         */
        var data = {};
        /**
         * Hold the Elements component.
         *
         * @type {Object}
         */

        var Elements = Components.Elements;
        /**
         * Pagination component object.
         *
         * @type {Object}
         */

        var Pagination = {
            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                var pagination = Splide.options.pagination;

                if (pagination) {
                    data = createPagination();
                    var slider = Elements.slider;
                    var parent = pagination === 'slider' && slider ? slider : Splide.root;
                    append(parent, data.list);
                    Splide.on(ATTRIBUTES_UPDATE_EVENT, updateAttributes);
                }

                Splide.off(UPDATE_EVENT).on(UPDATE_EVENT, function () {
                    Pagination.destroy();

                    if (Splide.options.pagination) {
                        Pagination.mount();
                        Pagination.mounted();
                    }
                });
            },

            /**
             * Called after all components are mounted.
             */
            mounted: function mounted() {
                if (Splide.options.pagination) {
                    var index = Splide.index;
                    Splide.emit(name + ":mounted", data, this.getItem(index));
                    updateAttributes(index, -1);
                }
            },

            /**
             * Destroy the pagination.
             * Be aware that node.remove() is not supported by IE.
             */
            destroy: function destroy() {
                dom_remove(data.list);

                if (data.items) {
                    data.items.forEach(function (item) {
                        Splide.off('click', item.button);
                    });
                } // Do not remove UPDATE_EVENT to recreate pagination if needed.


                Splide.off(ATTRIBUTES_UPDATE_EVENT);
                data = {};
            },

            /**
             * Return an item by index.
             *
             * @param {number} index - A slide index.
             *
             * @return {Object|undefined} - An item object on success or undefined on failure.
             */
            getItem: function getItem(index) {
                return data.items[Components.Controller.toPage(index)];
            },

            /**
             * Return object containing pagination data.
             *
             * @return {Object} - Pagination data including list and items.
             */
            get data() {
                return data;
            }

        };
        /**
         * Update attributes.
         *
         * @param {number} index     - Active index.
         * @param {number} prevIndex - Prev index.
         */

        function updateAttributes(index, prevIndex) {
            var prev = Pagination.getItem(prevIndex);
            var curr = Pagination.getItem(index);
            var active = STATUS_CLASSES.active;

            if (prev) {
                removeClass(prev.button, active);
            }

            if (curr) {
                addClass(curr.button, active);
            }

            Splide.emit(name + ":updated", data, prev, curr);
        }
        /**
         * Create a wrapper and button elements.
         *
         * @return {Object} - An object contains all data.
         */

        function createPagination() {
            var options = Splide.options;
            var classes = Splide.classes;
            var list = create('ul', {
                "class": classes.pagination
            });
            var items = Elements.getSlides(false).filter(function (Slide) {
                return options.focus !== false || Slide.index % options.perPage === 0;
            }).map(function (Slide, page) {
                var li = create('li', {});
                var button = create('button', {
                    "class": classes.page,
                    type: 'button'
                });
                append(li, button);
                append(list, li);
                Splide.on('click', function () {
                    Splide.go(">" + page);
                }, button);
                return {
                    li: li,
                    button: button,
                    page: page,
                    Slides: Elements.getSlidesByPage(page)
                };
            });
            return {
                list: list,
                items: items
            };
        }

        return Pagination;
    };
     // CONCATENATED MODULE: ./src/js/components/lazyload/index.js
    /**
     * The component for loading slider images lazily.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The name for a data attribute of src.
     *
     * @type {string}
     */

    var SRC_DATA_NAME = 'data-splide-lazy';
    /**
     * The name for a data attribute of srcset.
     *
     * @type {string}
     */

    var SRCSET_DATA_NAME = 'data-splide-lazy-srcset';
    /**
     * The component for loading slider images lazily.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     * @param {string} name       - A component name as a lowercase string.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var lazyload = function lazyload(Splide, Components, name) {
        /**
         * Next index for sequential loading.
         *
         * @type {number}
         */
        var nextIndex;
        /**
         * Store objects containing an img element and a Slide object.
         *
         * @type {Object[]}
         */

        var images;
        /**
         * Store the options.
         *
         * @type {Object}
         */

        var options = Splide.options;
        /**
         * Whether to load images sequentially or not.
         *
         * @type {boolean}
         */

        var isSequential = options.lazyLoad === 'sequential';
        /**
         * Lazyload component object.
         *
         * @type {Object}
         */

        var Lazyload = {
            /**
             * Mount only when the lazyload option is provided.
             *
             * @type {boolean}
             */
            required: options.lazyLoad,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                Splide.on('mounted refresh', function () {
                    init();
                    Components.Elements.each(function (Slide) {
                        each(Slide.slide.querySelectorAll("[" + SRC_DATA_NAME + "], [" + SRCSET_DATA_NAME + "]"), function (img) {
                            if (!img.src && !img.srcset) {
                                images.push({
                                    img: img,
                                    Slide: Slide
                                });
                                applyStyle(img, {
                                    display: 'none'
                                });
                            }
                        });
                    });

                    if (isSequential) {
                        loadNext();
                    }
                });

                if (!isSequential) {
                    Splide.on("mounted refresh moved." + name, check);
                }
            },

            /**
             * Destroy.
             */
            destroy: init
        };
        /**
         * Initialize parameters.
         */

        function init() {
            images = [];
            nextIndex = 0;
        }
        /**
         * Check how close each image is from the active slide and
         * determine whether to start loading or not, according to the distance.
         *
         * @param {number} index - Current index.
         */

        function check(index) {
            index = isNaN(index) ? Splide.index : index;
            images = images.filter(function (image) {
                if (image.Slide.isWithin(index, options.perPage * (options.preloadPages + 1))) {
                    load(image.img, image.Slide);
                    return false;
                }

                return true;
            }); // Unbind if all images are loaded.

            if (!images[0]) {
                Splide.off("moved." + name);
            }
        }
        /**
         * Start loading an image.
         * Creating a clone of the image element since setting src attribute directly to it
         * often occurs 'hitch', blocking some other processes of a browser.
         *
         * @param {Element} img   - An image element.
         * @param {Object}  Slide - A Slide object.
         */

        function load(img, Slide) {
            addClass(Slide.slide, STATUS_CLASSES.loading);
            var spinner = create('span', {
                "class": Splide.classes.spinner
            });
            append(img.parentElement, spinner);

            img.onload = function () {
                loaded(img, spinner, Slide, false);
            };

            img.onerror = function () {
                loaded(img, spinner, Slide, true);
            };

            setAttribute(img, 'srcset', getAttribute(img, SRCSET_DATA_NAME) || '');
            setAttribute(img, 'src', getAttribute(img, SRC_DATA_NAME) || '');
        }
        /**
         * Start loading a next image in images array.
         */

        function loadNext() {
            if (nextIndex < images.length) {
                var image = images[nextIndex];
                load(image.img, image.Slide);
            }

            nextIndex++;
        }
        /**
         * Called just after the image was loaded or loading was aborted by some error.
         *
         * @param {Element} img     - An image element.
         * @param {Element} spinner - A spinner element.
         * @param {Object}  Slide   - A Slide object.
         * @param {boolean} error   - True if the image was loaded successfully or false on error.
         */

        function loaded(img, spinner, Slide, error) {
            removeClass(Slide.slide, STATUS_CLASSES.loading);

            if (!error) {
                dom_remove(spinner);
                applyStyle(img, {
                    display: ''
                });
                Splide.emit(name + ":loaded", img).emit('resize');
            }

            if (isSequential) {
                loadNext();
            }
        }

        return Lazyload;
    };
     // CONCATENATED MODULE: ./src/js/constants/a11y.js
    /**
     * Export aria attribute names.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Attribute name for aria-current.
     *
     * @type {string}
     */
    var ARIA_CURRENRT = 'aria-current';
    /**
     * Attribute name for aria-control.
     *
     * @type {string}
     */

    var ARIA_CONTROLS = 'aria-controls';
    /**
     * Attribute name for aria-control.
     *
     * @type {string}
     */

    var ARIA_LABEL = 'aria-label';
    /**
     * Attribute name for aria-labelledby.
     *
     * @type {string}
     */

    var ARIA_HIDDEN = 'aria-hidden';
    /**
     * Attribute name for tab-index.
     *
     * @type {string}
     */

    var TAB_INDEX = 'tabindex';
     // CONCATENATED MODULE: ./src/js/components/keyboard/index.js
    /**
     * The component for controlling slides via keyboard.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Map a key to a slide control.
     *
     * @type {Object}
     */

    var KEY_MAP = {
        ltr: {
            ArrowLeft: '<',
            ArrowRight: '>',
            // For IE.
            Left: '<',
            Right: '>'
        },
        rtl: {
            ArrowLeft: '>',
            ArrowRight: '<',
            // For IE.
            Left: '>',
            Right: '<'
        },
        ttb: {
            ArrowUp: '<',
            ArrowDown: '>',
            // For IE.
            Up: '<',
            Down: '>'
        }
    };
    /**
     * The component for controlling slides via keyboard.
     *
     * @param {Splide} Splide - A Splide instance.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var keyboard = function keyboard(Splide) {
        /**
         * Hold the target element.
         *
         * @type {Element|Document|undefined}
         */
        var target;
        return {
            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                Splide.on('mounted updated', function () {
                    var options = Splide.options;
                    var root = Splide.root;
                    var map = KEY_MAP[options.direction];
                    var keyboard = options.keyboard;

                    if (target) {
                        Splide.off('keydown', target);
                        removeAttribute(root, TAB_INDEX);
                    }

                    if (keyboard) {
                        if (keyboard === 'focused') {
                            target = root;
                            setAttribute(root, TAB_INDEX, 0);
                        } else {
                            target = document;
                        }

                        Splide.on('keydown', function (e) {
                            if (map[e.key]) {
                                Splide.go(map[e.key]);
                            }
                        }, target);
                    }
                });
            }
        };
    };
     // CONCATENATED MODULE: ./src/js/components/a11y/index.js
    /**
     * The component for enhancing accessibility.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The component for enhancing accessibility.
     *
     * @param {Splide} Splide     - A Splide instance.
     * @param {Object} Components - An object containing components.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var a11y = function a11y(Splide, Components) {
        /**
         * Hold a i18n object.
         *
         * @type {Object}
         */
        var i18n = Splide.i18n;
        /**
         * Hold the Elements component.
         *
         * @type {Object}
         */

        var Elements = Components.Elements;
        /**
         * All attributes related with A11y.
         *
         * @type {string[]}
         */

        var allAttributes = [ARIA_HIDDEN, TAB_INDEX, ARIA_CONTROLS, ARIA_LABEL, ARIA_CURRENRT, 'role'];
        /**
         * A11y component object.
         *
         * @type {Object}
         */

        var A11y = {
            /**
             * Required only when the accessibility option is true.
             *
             * @type {boolean}
             */
            required: Splide.options.accessibility,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                Splide.on('visible', function (Slide) {
                    updateSlide(Slide.slide, true);
                }).on('hidden', function (Slide) {
                    updateSlide(Slide.slide, false);
                }).on('arrows:mounted', initArrows).on('arrows:updated', updateArrows).on('pagination:mounted', initPagination).on('pagination:updated', updatePagination).on('refresh', function () {
                    removeAttribute(Components.Clones.clones, allAttributes);
                });

                if (Splide.options.isNavigation) {
                    Splide.on('navigation:mounted navigation:updated', initNavigation).on('active', function (Slide) {
                        updateNavigation(Slide, true);
                    }).on('inactive', function (Slide) {
                        updateNavigation(Slide, false);
                    });
                }

                initAutoplay();
            },

            /**
             * Destroy.
             */
            destroy: function destroy() {
                var Arrows = Components.Arrows;
                var arrows = Arrows ? Arrows.arrows : {};
                removeAttribute(Elements.slides.concat([arrows.prev, arrows.next, Elements.play, Elements.pause]), allAttributes);
            }
        };
        /**
         * Update slide attributes when it gets visible or hidden.
         *
         * @param {Element} slide   - A slide element.
         * @param {Boolean} visible - True when the slide gets visible, or false when hidden.
         */

        function updateSlide(slide, visible) {
            setAttribute(slide, ARIA_HIDDEN, !visible);

            if (Splide.options.slideFocus) {
                setAttribute(slide, TAB_INDEX, visible ? 0 : -1);
            }
        }
        /**
         * Initialize arrows if they are available.
         * Append screen reader elements and add aria-controls attribute.
         *
         * @param {Element} prev - Previous arrow element.
         * @param {Element} next - Next arrow element.
         */

        function initArrows(prev, next) {
            var controls = Elements.track.id;
            setAttribute(prev, ARIA_CONTROLS, controls);
            setAttribute(next, ARIA_CONTROLS, controls);
        }
        /**
         * Update arrow attributes.
         *
         * @param {Element} prev      - Previous arrow element.
         * @param {Element} next      - Next arrow element.
         * @param {number}  prevIndex - Previous slide index or -1 when there is no precede slide.
         * @param {number}  nextIndex - Next slide index or -1 when there is no next slide.
         */

        function updateArrows(prev, next, prevIndex, nextIndex) {
            var index = Splide.index;
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            setAttribute(prev, ARIA_LABEL, prevLabel);
            setAttribute(next, ARIA_LABEL, nextLabel);
        }
        /**
         * Initialize pagination if it's available.
         * Append a screen reader element and add aria-controls/label attribute to each item.
         *
         * @param {Object} data       - Data object containing all items.
         * @param {Object} activeItem - An initial active item.
         */

        function initPagination(data, activeItem) {
            if (activeItem) {
                setAttribute(activeItem.button, ARIA_CURRENRT, true);
            }

            data.items.forEach(function (item) {
                var options = Splide.options;
                var text = options.focus === false && options.perPage > 1 ? i18n.pageX : i18n.slideX;
                var label = sprintf(text, item.page + 1);
                var button = item.button;
                var controls = item.Slides.map(function (Slide) {
                    return Slide.slide.id;
                });
                setAttribute(button, ARIA_CONTROLS, controls.join(' '));
                setAttribute(button, ARIA_LABEL, label);
            });
        }
        /**
         * Update pagination attributes.
         *
         * @param {Object}  data - Data object containing all items.
         * @param {Element} prev - A previous active element.
         * @param {Element} curr - A current active element.
         */

        function updatePagination(data, prev, curr) {
            if (prev) {
                removeAttribute(prev.button, ARIA_CURRENRT);
            }

            if (curr) {
                setAttribute(curr.button, ARIA_CURRENRT, true);
            }
        }
        /**
         * Initialize autoplay buttons.
         */

        function initAutoplay() {
            ['play', 'pause'].forEach(function (name) {
                var elm = Elements[name];

                if (elm) {
                    if (!isButton(elm)) {
                        setAttribute(elm, 'role', 'button');
                    }

                    setAttribute(elm, ARIA_CONTROLS, Elements.track.id);
                    setAttribute(elm, ARIA_LABEL, i18n[name]);
                }
            });
        }
        /**
         * Initialize navigation slider.
         * Add button role, aria-label, aria-controls to slide elements and append screen reader text to them.
         *
         * @param {Splide} main - A main Splide instance.
         */

        function initNavigation(main) {
            Elements.each(function (Slide) {
                var slide = Slide.slide;
                var realIndex = Slide.realIndex;

                if (!isButton(slide)) {
                    setAttribute(slide, 'role', 'button');
                }

                var slideIndex = realIndex > -1 ? realIndex : Slide.index;
                var label = sprintf(i18n.slideX, slideIndex + 1);
                var mainSlide = main.Components.Elements.getSlide(slideIndex);
                setAttribute(slide, ARIA_LABEL, label);

                if (mainSlide) {
                    setAttribute(slide, ARIA_CONTROLS, mainSlide.slide.id);
                }
            });
        }
        /**
         * Update navigation attributes.
         *
         * @param {Object}  Slide  - A target Slide object.
         * @param {boolean} active - True if the slide is active or false if inactive.
         */

        function updateNavigation(_ref, active) {
            var slide = _ref.slide;

            if (active) {
                setAttribute(slide, ARIA_CURRENRT, true);
            } else {
                removeAttribute(slide, ARIA_CURRENRT);
            }
        }
        /**
         * Check if the given element is button or not.
         *
         * @param {Element} elm - An element to be checked.
         *
         * @return {boolean} - True if the given element is button.
         */

        function isButton(elm) {
            return elm.tagName === 'BUTTON';
        }

        return A11y;
    };
     // CONCATENATED MODULE: ./src/js/components/sync/index.js
    /**
     * The component for synchronizing a slider with another.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * The event name for sync.
     *
     * @type {string}
     */

    var SYNC_EVENT = 'move.sync';
    /**
     * The event names for click navigation.
     * @type {string}
     */

    var CLICK_EVENTS = 'mouseup touchend';
    /**
     * The keys for triggering the navigation button.
     *
     * @type {String[]}
     */

    var TRIGGER_KEYS = [' ', 'Enter', 'Spacebar'];
    /**
     * The component for synchronizing a slider with another.
     *
     * @param {Splide} Splide - A Splide instance.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var sync = function sync(Splide) {
        /**
         * Keep the sibling Splide instance.
         *
         * @type {Splide}
         */
        var sibling = Splide.sibling;
        /**
         * Whether the sibling slider is navigation or not.
         *
         * @type {Splide|boolean}
         */

        var isNavigation = sibling && sibling.options.isNavigation;
        /**
         * Layout component object.
         *
         * @type {Object}
         */

        var Sync = {
            /**
             * Required only when the sub slider is available.
             *
             * @type {boolean}
             */
            required: !!sibling,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                syncMain();
                syncSibling();

                if (isNavigation) {
                    bind();
                    Splide.on('refresh', function () {
                        setTimeout(function () {
                            bind();
                            sibling.emit('navigation:updated', Splide);
                        });
                    });
                }
            },

            /**
             * Called after all components are mounted.
             */
            mounted: function mounted() {
                if (isNavigation) {
                    sibling.emit('navigation:mounted', Splide);
                }
            }
        };
        /**
         * Listen the primary slider event to move secondary one.
         * Must unbind a handler at first to avoid infinite loop.
         */

        function syncMain() {
            Splide.on(SYNC_EVENT, function (newIndex, prevIndex, destIndex) {
                sibling.off(SYNC_EVENT).go(sibling.is(LOOP) ? destIndex : newIndex, false);
                syncSibling();
            });
        }
        /**
         * Listen the secondary slider event to move primary one.
         * Must unbind a handler at first to avoid infinite loop.
         */

        function syncSibling() {
            sibling.on(SYNC_EVENT, function (newIndex, prevIndex, destIndex) {
                Splide.off(SYNC_EVENT).go(Splide.is(LOOP) ? destIndex : newIndex, false);
                syncMain();
            });
        }
        /**
         * Listen some events on each slide.
         */

        function bind() {
            sibling.Components.Elements.each(function (_ref) {
                var slide = _ref.slide,
                    index = _ref.index;

                /*
                * Listen mouseup and touchend events to handle click.
                */
                Splide.off(CLICK_EVENTS, slide).on(CLICK_EVENTS, function (e) {
                    // Ignore a middle or right click.
                    if (!e.button || e.button === 0) {
                        moveSibling(index);
                    }
                }, slide);
                /*
                * Subscribe keyup to handle Enter and Space key.
                * Note that Array.includes is not supported by IE.
                */

                Splide.off('keyup', slide).on('keyup', function (e) {
                    if (TRIGGER_KEYS.indexOf(e.key) > -1) {
                        e.preventDefault();
                        moveSibling(index);
                    }
                }, slide, {
                    passive: false
                });
            });
        }
        /**
         * Move the sibling to the given index.
         * Need to check "IDLE" status because slides can be moving by Drag component.
         *
         * @param {number} index - Target index.
         */

        function moveSibling(index) {
            if (Splide.State.is(_IDLE)) {
                sibling.go(index);
            }
        }

        return Sync;
    };
     // CONCATENATED MODULE: ./src/js/components/breakpoints/index.js
    /**
     * The component for updating options according to a current window width.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Interval time for throttle.
     *
     * @type {number}
     */

    var THROTTLE = 50;
    /**
     * The component for updating options according to a current window width.
     *
     * @param {Splide} Splide - A Splide instance.
     *
     * @return {Object} - The component object.
     */

    /* harmony default export */var breakpoints = function breakpoints(Splide) {
        /**
         * Store breakpoints.
         *
         * @type {Object|boolean}
         */
        var breakpoints = Splide.options.breakpoints;
        /**
         * The check function whose frequency of call is reduced.
         *
         * @type {Function}
         */

        var throttledCheck = throttle(check, THROTTLE);
        /**
         * Keep initial options.
         *
         * @type {Object}
         */

        var initialOptions;
        /**
         * An array containing objects of point and MediaQueryList.
         *
         * @type {Object[]}
         */

        var map = [];
        /**
         * Hold the previous breakpoint.
         *
         * @type {number|undefined}
         */

        var prevPoint;
        /**
         * Breakpoints component object.
         *
         * @type {Object}
         */

        var Breakpoints = {
            /**
             * Required only when the breakpoints definition is provided and browser supports matchMedia.
             *
             * @type {boolean}
             */
            required: breakpoints && matchMedia,

            /**
             * Called when the component is mounted.
             */
            mount: function mount() {
                map = Object.keys(breakpoints).sort(function (n, m) {
                    return +n - +m;
                }).map(function (point) {
                    return {
                        point: point,
                        mql: matchMedia("(max-width:" + point + "px)")
                    };
                });
                /*
                * To keep monitoring resize event after destruction without "completely",
                * use native addEventListener instead of Splide.on.
                */

                this.destroy(true);
                addEventListener('resize', throttledCheck); // Keep initial options to apply them when no breakpoint matches.

                initialOptions = Splide.options;
                check();
            },

            /**
             * Destroy.
             *
             * @param {boolean} completely - Whether to destroy Splide completely.
             */
            destroy: function destroy(completely) {
                if (completely) {
                    removeEventListener('resize', throttledCheck);
                }
            }
        };
        /**
         * Check the breakpoint.
         */

        function check() {
            var point = getPoint();

            if (point !== prevPoint) {
                prevPoint = point;
                var State = Splide.State;
                var options = breakpoints[point] || initialOptions;
                var destroy = options.destroy;

                if (destroy) {
                    Splide.options = initialOptions;
                    Splide.destroy(destroy === 'completely');
                } else {
                    if (State.is(_DESTROYED)) {
                        Splide.mount();
                    }

                    Splide.options = options;
                }
            }
        }
        /**
         * Return the breakpoint matching current window width.
         * Note that Array.prototype.find is not supported by IE.
         *
         * @return {number|string} - A breakpoint as number or string. -1 if no point matches.
         */

        function getPoint() {
            var item = map.filter(function (item) {
                return item.mql.matches;
            })[0];
            return item ? item.point : -1;
        }

        return Breakpoints;
    };
     // CONCATENATED MODULE: ./src/js/components/index.js
    /**
     * Export components.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    var COMPLETE = {
        Options: options,
        Breakpoints: breakpoints,
        Controller: controller,
        Elements: components_elements,
        Track: track,
        Clones: clones,
        Layout: layout,
        Drag: drag,
        Click: click,
        Autoplay: autoplay,
        Cover: cover,
        Arrows: arrows,
        Pagination: pagination,
        LazyLoad: lazyload,
        Keyboard: keyboard,
        Sync: sync,
        A11y: a11y
    };
     // CONCATENATED MODULE: ./build/complete/complete.js
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
    }

    /**
     * Export "Splide" class for frontend with full components.
     *
     * @author    Naotoshi Fujita
     * @copyright Naotoshi Fujita. All rights reserved.
     */

    /**
     * Export Splide with all components.
     */

    var complete_Splide = /*#__PURE__*/function (_Core) {
        _inheritsLoose(Splide, _Core);

        function Splide(root, options) {
            return _Core.call(this, root, options, COMPLETE) || this;
        }

        return Splide;
    }(Splide); // Register the class as a global variable for non-ES6 environment.

    window.Splide = complete_Splide;
    /******/
})();

var runningOnBrowser = typeof window !== "undefined";

var isBot = runningOnBrowser && !("onscroll" in window) || typeof navigator !== "undefined" && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent);

var supportsIntersectionObserver = runningOnBrowser && "IntersectionObserver" in window;

var supportsClassList = runningOnBrowser && "classList" in document.createElement("p");

var defaultSettings = {
    elements_selector: "img",
    container: isBot || runningOnBrowser ? document : null,
    threshold: 300,
    thresholds: null,
    data_src: "src",
    data_srcset: "srcset",
    data_sizes: "sizes",
    data_bg: "bg",
    data_poster: "poster",
    class_loading: "loading",
    class_loaded: "loaded",
    class_error: "error",
    load_delay: 0,
    auto_unobserve: true,
    callback_enter: null,
    callback_exit: null,
    callback_reveal: null,
    callback_loaded: null,
    callback_error: null,
    callback_finish: null,
    use_native: false
};

var getInstanceSettings = function getInstanceSettings(customSettings) {
    return Object.assign({}, defaultSettings, customSettings);
};

/* Creates instance and notifies it through the window element */
var createInstance = function createInstance(classObj, options) {
    var event;
    var eventString = "LazyLoad::Initialized";
    var instance = new classObj(options);
    try {
        // Works in modern browsers
        event = new CustomEvent(eventString, { detail: { instance: instance } });
    } catch (err) {
        // Works in Internet Explorer (all versions)
        event = document.createEvent("CustomEvent");
        event.initCustomEvent(eventString, false, false, { instance: instance });
    }
    window.dispatchEvent(event);
};

/* Auto initialization of one or more instances of lazyload, depending on the 
    options passed in (plain object or an array) */
var autoInitialize = function autoInitialize(classObj, options) {
    if (!options) {
        return;
    }
    if (!options.length) {
        // Plain object
        createInstance(classObj, options);
    } else {
        // Array of objects
        for (var i = 0, optionsItem; optionsItem = options[i]; i += 1) {
            createInstance(classObj, optionsItem);
        }
    }
};

var dataPrefix = "data-";
var processedDataName = "was-processed";
var timeoutDataName = "ll-timeout";
var trueString = "true";

var getData = function getData(element, attribute) {
    return element.getAttribute(dataPrefix + attribute);
};

var setData = function setData(element, attribute, value) {
    var attrName = dataPrefix + attribute;
    if (value === null) {
        element.removeAttribute(attrName);
        return;
    }
    element.setAttribute(attrName, value);
};

var resetWasProcessedData = function resetWasProcessedData(element) {
    return setData(element, processedDataName, null);
};

var setWasProcessedData = function setWasProcessedData(element) {
    return setData(element, processedDataName, trueString);
};

var getWasProcessedData = function getWasProcessedData(element) {
    return getData(element, processedDataName) === trueString;
};

var setTimeoutData = function setTimeoutData(element, value) {
    return setData(element, timeoutDataName, value);
};

var getTimeoutData = function getTimeoutData(element) {
    return getData(element, timeoutDataName);
};

var purgeProcessedElements = function purgeProcessedElements(elements) {
    return elements.filter(function (element) {
        return !getWasProcessedData(element);
    });
};

var purgeOneElement = function purgeOneElement(elements, elementToPurge) {
    return elements.filter(function (element) {
        return element !== elementToPurge;
    });
};

var getSourceTags = function getSourceTags(parentTag) {
    var sourceTags = [];
    for (var i = 0, childTag; childTag = parentTag.children[i]; i += 1) {
        if (childTag.tagName === "SOURCE") {
            sourceTags.push(childTag);
        }
    }
    return sourceTags;
};

var setAttributeIfValue = function setAttributeIfValue(element, attrName, value) {
    if (!value) {
        return;
    }
    element.setAttribute(attrName, value);
};

var setImageAttributes = function setImageAttributes(element, settings) {
    setAttributeIfValue(element, "sizes", getData(element, settings.data_sizes));
    setAttributeIfValue(element, "srcset", getData(element, settings.data_srcset));
    setAttributeIfValue(element, "src", getData(element, settings.data_src));
};

var setSourcesImg = function setSourcesImg(element, settings) {
    var parent = element.parentNode;

    if (parent && parent.tagName === "PICTURE") {
        var sourceTags = getSourceTags(parent);
        sourceTags.forEach(function (sourceTag) {
            setImageAttributes(sourceTag, settings);
        });
    }

    setImageAttributes(element, settings);
};

var setSourcesIframe = function setSourcesIframe(element, settings) {
    setAttributeIfValue(element, "src", getData(element, settings.data_src));
};

var setSourcesVideo = function setSourcesVideo(element, settings) {
    var sourceTags = getSourceTags(element);
    sourceTags.forEach(function (sourceTag) {
        setAttributeIfValue(sourceTag, "src", getData(sourceTag, settings.data_src));
    });
    setAttributeIfValue(element, "poster", getData(element, settings.data_poster));
    setAttributeIfValue(element, "src", getData(element, settings.data_src));
    element.load();
};

var setSourcesBgImage = function setSourcesBgImage(element, settings) {
    var srcDataValue = getData(element, settings.data_src);
    var bgDataValue = getData(element, settings.data_bg);

    if (srcDataValue) {
        element.style.backgroundImage = "url(\"" + srcDataValue + "\")";
    }

    if (bgDataValue) {
        element.style.backgroundImage = bgDataValue;
    }
};

var setSourcesFunctions = {
    IMG: setSourcesImg,
    IFRAME: setSourcesIframe,
    VIDEO: setSourcesVideo
};

var setSources = function setSources(element, instance) {
    var settings = instance._settings;
    var tagName = element.tagName;
    var setSourcesFunction = setSourcesFunctions[tagName];
    if (setSourcesFunction) {
        setSourcesFunction(element, settings);
        instance.loadingCount += 1;
        instance._elements = purgeOneElement(instance._elements, element);
        return;
    }
    setSourcesBgImage(element, settings);
};

var addClass = function addClass(element, className) {
    if (supportsClassList) {
        element.classList.add(className);
        return;
    }
    element.className += (element.className ? " " : "") + className;
};

var removeClass = function removeClass(element, className) {
    if (supportsClassList) {
        element.classList.remove(className);
        return;
    }
    element.className = element.className.replace(new RegExp("(^|\\s+)" + className + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "");
};

var safeCallback = function safeCallback(callback, arg1, arg2, arg3) {
    if (!callback) {
        return;
    }

    if (arg3 !== undefined) {
        callback(arg1, arg2, arg3);
        return;
    }
    if (arg2 !== undefined) {
        callback(arg1, arg2);
        return;
    }
    callback(arg1);
};

var genericLoadEventName = "load";
var mediaLoadEventName = "loadeddata";
var errorEventName = "error";

var addEventListener$1 = function addEventListener(element, eventName, handler) {
    element.addEventListener(eventName, handler);
};

var removeEventListener$1 = function removeEventListener(element, eventName, handler) {
    element.removeEventListener(eventName, handler);
};

var addEventListeners = function addEventListeners(element, loadHandler, errorHandler) {
    addEventListener$1(element, genericLoadEventName, loadHandler);
    addEventListener$1(element, mediaLoadEventName, loadHandler);
    addEventListener$1(element, errorEventName, errorHandler);
};

var removeEventListeners = function removeEventListeners(element, loadHandler, errorHandler) {
    removeEventListener$1(element, genericLoadEventName, loadHandler);
    removeEventListener$1(element, mediaLoadEventName, loadHandler);
    removeEventListener$1(element, errorEventName, errorHandler);
};

var eventHandler = function eventHandler(event, success, instance) {
    var settings = instance._settings;
    var className = success ? settings.class_loaded : settings.class_error;
    var callback = success ? settings.callback_loaded : settings.callback_error;
    var element = event.target;

    removeClass(element, settings.class_loading);
    addClass(element, className);
    safeCallback(callback, element, instance);

    instance.loadingCount -= 1;

    if (instance._elements.length === 0 && instance.loadingCount === 0) {
        safeCallback(settings.callback_finish, instance);
    }
};

var addOneShotEventListeners = function addOneShotEventListeners(element, instance) {
    var loadHandler = function loadHandler(event) {
        eventHandler(event, true, instance);
        removeEventListeners(element, loadHandler, errorHandler);
    };
    var errorHandler = function errorHandler(event) {
        eventHandler(event, false, instance);
        removeEventListeners(element, loadHandler, errorHandler);
    };
    addEventListeners(element, loadHandler, errorHandler);
};

var managedTags = ["IMG", "IFRAME", "VIDEO"];

var revealAndUnobserve = function revealAndUnobserve(element, instance) {
    var observer = instance._observer;
    revealElement(element, instance);
    if (observer && instance._settings.auto_unobserve) {
        observer.unobserve(element);
    }
};

var revealElement = function revealElement(element, instance, force) {
    var settings = instance._settings;
    if (!force && getWasProcessedData(element)) {
        return; // element has already been processed and force wasn't true
    }
    if (managedTags.indexOf(element.tagName) > -1) {
        addOneShotEventListeners(element, instance);
        addClass(element, settings.class_loading);
    }
    setSources(element, instance);
    setWasProcessedData(element);
    safeCallback(settings.callback_reveal, element, instance);
};

var cancelDelayLoad = function cancelDelayLoad(element) {
    var timeoutId = getTimeoutData(element);
    if (!timeoutId) {
        return; // do nothing if timeout doesn't exist
    }
    clearTimeout(timeoutId);
    setTimeoutData(element, null);
};

var delayLoad = function delayLoad(element, instance) {
    var loadDelay = instance._settings.load_delay;
    var timeoutId = getTimeoutData(element);
    if (timeoutId) {
        return; // do nothing if timeout already set
    }
    timeoutId = setTimeout(function () {
        revealAndUnobserve(element, instance);
        cancelDelayLoad(element);
    }, loadDelay);
    setTimeoutData(element, timeoutId);
};

var onEnter = function onEnter(element, entry, instance) {
    var settings = instance._settings;
    safeCallback(settings.callback_enter, element, entry, instance);
    if (!settings.load_delay) {
        revealAndUnobserve(element, instance);
        return;
    }
    delayLoad(element, instance);
};

var onExit = function onExit(element, entry, instance) {
    var settings = instance._settings;
    safeCallback(settings.callback_exit, element, entry, instance);
    if (!settings.load_delay) {
        return;
    }
    cancelDelayLoad(element);
};

var isIntersecting = function isIntersecting(entry) {
    return entry.isIntersecting || entry.intersectionRatio > 0;
};

var getObserverSettings = function getObserverSettings(settings) {
    return {
        root: settings.container === document ? null : settings.container,
        rootMargin: settings.thresholds || settings.threshold + "px"
    };
};

var setObserver = function setObserver(instance) {
    if (!supportsIntersectionObserver) {
        return false;
    }
    instance._observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            return isIntersecting(entry) ? onEnter(entry.target, entry, instance) : onExit(entry.target, entry, instance);
        });
    }, getObserverSettings(instance._settings));
    return true;
};

var nativeLazyTags = ["IMG", "IFRAME"];

var shouldUseNative = function shouldUseNative(settings) {
    return settings.use_native && "loading" in HTMLImageElement.prototype;
};

var loadAllNative = function loadAllNative(instance) {
    instance._elements.forEach(function (element) {
        if (nativeLazyTags.indexOf(element.tagName) === -1) {
            return;
        }
        element.setAttribute("loading", "lazy");
        revealElement(element, instance);
    });
};

var queryElements = function queryElements(settings) {
    return settings.container.querySelectorAll(settings.elements_selector);
};

var nodeSetToArray = function nodeSetToArray(nodeSet) {
    return Array.prototype.slice.call(nodeSet);
};

var getElements = function getElements(elements, settings) {
    return purgeProcessedElements(nodeSetToArray(elements || queryElements(settings)));
};

var retryLazyLoad = function retryLazyLoad(instance) {
    var settings = instance._settings;
    var errorElements = settings.container.querySelectorAll("." + settings.class_error);
    nodeSetToArray(errorElements).forEach(function (element) {
        removeClass(element, settings.class_error);
        resetWasProcessedData(element);
    });
    instance.update();
};

var setOnlineCheck = function setOnlineCheck(instance) {
    if (!runningOnBrowser) {
        return;
    }
    window.addEventListener("online", function (event) {
        retryLazyLoad(instance);
    });
};

var LazyLoad = function LazyLoad(customSettings, elements) {
    this._settings = getInstanceSettings(customSettings);
    this.loadingCount = 0;
    setObserver(this);
    this.update(elements);
    setOnlineCheck(this);
};

LazyLoad.prototype = {
    update: function update(elements) {
        var _this = this;

        var settings = this._settings;
        this._elements = getElements(elements, settings);
        if (isBot || !this._observer) {
            this.loadAll();
            return;
        }
        if (shouldUseNative(settings)) {
            loadAllNative(this);
            this._elements = getElements(elements, settings);
        }
        this._elements.forEach(function (element) {
            _this._observer.observe(element);
        });
    },

    destroy: function destroy() {
        var _this2 = this;

        if (this._observer) {
            this._elements.forEach(function (element) {
                _this2._observer.unobserve(element);
            });
            this._observer = null;
        }
        this._elements = null;
        this._settings = null;
    },

    load: function load(element, force) {
        revealElement(element, this, force);
    },

    loadAll: function loadAll() {
        var _this3 = this;

        this._elements.forEach(function (element) {
            revealAndUnobserve(element, _this3);
        });
    }
};

/* Automatic instances creation if required (useful for async script loading) */
if (runningOnBrowser) {
    autoInitialize(LazyLoad, window.lazyLoadOptions);
}

function lazyload() {
    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".js-lazy"
    });
}

lazyload();

document.addEventListener('LokiRequestEnd', function () {
    lazyload();
});

var homePageHeaderSlider = {
    _slider: null,
    timeout: false,
    delay: 250,

    init: function init() {
        var self = this;

        self._sliderCreate();
    },

    _sliderCreate: function _sliderCreate() {
        var self = this;
        self._slider = new Splide('.splide', {
            type: 'loop',
            speed: 800,
            accessibility: true,
            arrows: false,
            keyboard: true,
            autoplay: true,
            pagination: false,
            gap: "1rem",
            perPage: 3,
            fixedHeight: window.innerWidth / 3 / 3 * 2,
            breakpoints: {
                768: {
                    perPage: 2,
                    fixedHeight: window.innerWidth / 2 / 3 * 2
                },
                576: {
                    perPage: 1,
                    fixedHeight: window.innerWidth / 3 * 2,
                    start: 2
                }
            }
        }).mount();
        self._update();
        self._initClickEvent();
    },
    _destroy: function _destroy() {
        var self = this;
        self._destroyButtonsEvent();
        self._slider.destroy(true);
        self._slider = null;
    },
    _initClickEvent: function _initClickEvent() {
        var self = this;

        var nextButton = document.querySelector('.c-slider__nav-next');
        var prevButton = document.querySelector('.c-slider__nav-prev');

        var fakePrevButton = document.querySelector('.c-slider__fake-nav--left');
        var fakeNextButton = document.querySelector('.c-slider__fake-nav--right');

        if (nextButton) {
            nextButton.addEventListener('click', self._nextSlide, false);
        }

        if (prevButton) {
            prevButton.addEventListener('click', self._prevSlide, false);
        }

        if (fakePrevButton) {
            fakePrevButton.addEventListener('click', self._prevSlide, false);
        }

        if (fakeNextButton) {
            fakeNextButton.addEventListener('click', self._nextSlide, false);
        }
    },
    _nextSlide: function _nextSlide() {
        homePageHeaderSlider._slider.go('>');
    },
    _prevSlide: function _prevSlide() {
        homePageHeaderSlider._slider.go('<');
    },
    _destroyButtonsEvent: function _destroyButtonsEvent() {
        var self = this;

        var nextButton = document.querySelector('.c-slider__nav-next');
        var prevButton = document.querySelector('.c-slider__nav-prev');

        var fakePrevButton = document.querySelector('.c-slider__fake-nav--left');
        var fakeNextButton = document.querySelector('.c-slider__fake-nav--right');

        if (nextButton && prevButton) {
            nextButton.removeEventListener('click', self._nextSlide, false);
            prevButton.removeEventListener('click', self._prevSlide, false);
        }

        if (fakeNextButton && fakePrevButton) {
            fakePrevButton.removeEventListener('click', self._nextSlide, false);
            fakeNextButton.removeEventListener('click', self._prevSlide, false);
        }
    },
    reInit: function reInit() {
        var self = this;
        var node = document.querySelector('.js-slider');

        if (!node) {
            if (self._slider) {
                self._destroy();
            }

            return;
        }

        if (self._slider && self._slider.root === node) {
            return;
        }

        if (self._slider) {
            self._destroy();
        }

        self.init();
    },
    _update: function _update() {
        window.lazyLoadInstance.update();
    }
};

window.homePageHeaderSlider = homePageHeaderSlider;

var slider = document.querySelector('.js-slider');
if (slider) {
    window.homePageHeaderSlider.init();
}

document.addEventListener('LokiRequestEnd', function () {
    window.homePageHeaderSlider.reInit();
});

window.addEventListener('resize', function () {
    // clear the timeout
    clearTimeout(homePageHeaderSlider.timeout);
    // start timing for event "completion"
    window.homePageHeaderSlider.timeout = setTimeout(window.homePageHeaderSlider._update(), window.homePageHeaderSlider.delay);
});

var dropdownMenu = {
    tl: [],
    delay: 250,
    progress: [],
    navbarItems: null,

    init: function init() {
        var self = this;
        self.navbarItems = "";

        if (window.innerWidth < 1200) {
            return;
        }

        self.navbarItems = Array.prototype.slice.call(document.querySelectorAll('.c-navbar .c-navbar__nav-item-dropdown'));
        if (!self.navbarItems.length) {
            return;
        }

        self._dropDownBehaviour(self.navbarItems);
        self._outerClickHandler();
    },

    _dropDownBehaviour: function _dropDownBehaviour(navbarItems) {
        var self = this;
        var lastItem = null;

        navbarItems.forEach(function (navbarItem, i) {
            self._timeline(i);
            navbarItem.parentElement.querySelector('.c-navbar-dropdown-menu__content').dataset.index = i;
            navbarItem.addEventListener('click', function () {

                var dropDown = this.parentElement.querySelector('.c-navbar-dropdown-menu__content');
                var openedDropdowns = document.querySelectorAll('.c-navbar-dropdown-menu__content--opened');

                if (openedDropdowns.length > 0 && lastItem !== this) {
                    openedDropdowns.forEach(function (item) {

                        self.tl[parseFloat(item.dataset.index)].progress(0);
                        self._closeDropDown(item, parseFloat(item.dataset.index));
                    });

                    self._openDropDown(dropDown, i);
                } else {

                    if (dropDown.classList.contains('c-navbar-dropdown-menu__content--closed')) {
                        self._openDropDown(dropDown, i);
                    } else {
                        self._closeDropDown(dropDown, i);
                    }
                }

                lastItem = this;
            });
        });
    },
    _outerClickHandler: function _outerClickHandler() {
        var self = this;

        var node = null;

        document.removeEventListener('click', documentListener, false);
        document.addEventListener('click', documentListener, false);

        function documentListener(event) {
            node = document.querySelector('.c-navbar-dropdown-menu__content--opened');
            if (!node) {
                return;
            }

            if (!event.target.closest('.c-navbar__nav-col > nav > ul')) {

                self._closeDropDown(node, node.dataset.index);
            }
        }
    },


    _openDropDown: function _openDropDown(dropDown, index) {
        var self = this;

        if (dropDown.classList.contains('c-navbar-dropdown-menu__content--closed')) {
            dropDown.classList.add('c-navbar-dropdown-menu__content--opened');
            dropDown.querySelector('a').focus();
            dropDown.parentElement.classList.add('c-navbar-dropdown-menu__arrow--opened');

            if (dropDown.parentElement.querySelector('a').getAttribute('aria-expanded') === 'false') {
                dropDown.parentElement.querySelector('a').setAttribute('aria-expanded', 'true');
            }
            dropDown.classList.remove('c-navbar-dropdown-menu__content--closed');

            self.tl[index].play();
        }
    },

    _closeDropDown: function _closeDropDown(dropDown, index) {
        var self = this;

        self.tl[index].reverse();
        dropDown.parentElement.classList.remove('c-navbar-dropdown-menu__arrow--opened');

        if (dropDown.parentElement.querySelector('a').getAttribute('aria-expanded') === 'true') {
            dropDown.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
        }
    },

    _timeline: function _timeline(index) {
        var reverseComplete = false;
        var self = this;
        var dropDowns = Array.prototype.slice.call(document.querySelectorAll('.c-navbar .c-navbar-dropdown-menu__content'));
        self.progress[index] = 0;

        self.tl[index] = gsapWithCSS.timeline({ paused: true, reversed: true, onReverseComplete: function onReverseComplete() {
                reverseComplete = true;

                if (reverseComplete && dropDowns[index]) {
                    dropDowns[index].classList.remove('c-navbar-dropdown-menu__content--opened');
                    dropDowns[index].classList.add('c-navbar-dropdown-menu__content--closed');
                    self.tl[index].progress(0);
                    //self.progress[index] = 0;
                    self.tl[index].kill();
                }
            } });

        self.tl[index].fromTo(dropDowns, 0.25, { autoAlpha: 0, delay: .1, ease: 'Power2.inOut' }, { autoAlpha: 1 });
        //self.tl[index].progress(self.progress[index]);
    },

    reInit: function reInit() {
        var self = this;
        self.progress = [];
        self.tl.forEach(function (i) {
            i.kill();
        });

        self.tl = [];
        self.init();
    }
};

dropdownMenu.init();

document.addEventListener('LokiRequestEnd', function () {
    dropdownMenu.reInit();
});

/**!
 * lightgallery.js | 1.1.3 | February 11th 2019
 * http://sachinchoolur.github.io/lightgallery.js/
 * Copyright (c) 2016 Sachin N;
 * @license GPLv3
 */(function (f) {
    if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
        module.exports = f();
    } else if (typeof define === "function" && define.amd) {
        define([], f);
    } else {
        var g;if (typeof window !== "undefined") {
            g = window;
        } else if (typeof global !== "undefined") {
            g = global;
        } else if (typeof self !== "undefined") {
            g = self;
        } else {
            g = this;
        }g.Lightgallery = f();
    }
})(function () {
    var define;return function () {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                    }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                        var n = e[i][1][r];return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }return n[i].exports;
            }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
                o(t[i]);
            }return o;
        }return r;
    }()({ 1: [function (require, module, exports) {
            (function (global, factory) {
                if (typeof define === "function" && define.amd) {
                    
                } else if (typeof exports !== "undefined") {
                    factory(exports);
                } else {
                    var mod = {
                        exports: {}
                    };
                    factory(mod.exports);
                    global.lgUtils = mod.exports;
                }
            })(this, function (exports) {
                'use strict';

                Object.defineProperty(exports, "__esModule", {
                    value: true
                });

                var utils = {
                    getAttribute: function getAttribute(el, label) {
                        return el[label];
                    },

                    setAttribute: function setAttribute(el, label, value) {
                        el[label] = value;
                    },
                    wrap: function wrap(el, className) {
                        if (!el) {
                            return;
                        }

                        var wrapper = document.createElement('div');
                        wrapper.className = className;
                        el.parentNode.insertBefore(wrapper, el);
                        el.parentNode.removeChild(el);
                        wrapper.appendChild(el);
                    },

                    addClass: function addClass(el, className) {
                        if (!el) {
                            return;
                        }

                        if (el.classList) {
                            el.classList.add(className);
                        } else {
                            el.className += ' ' + className;
                        }
                    },

                    removeClass: function removeClass(el, className) {
                        if (!el) {
                            return;
                        }

                        if (el.classList) {
                            el.classList.remove(className);
                        } else {
                            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                        }
                    },

                    hasClass: function hasClass(el, className) {
                        if (el.classList) {
                            return el.classList.contains(className);
                        } else {
                            return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
                        }
                    },

                    // ex Transform
                    // ex TransitionTimingFunction
                    setVendor: function setVendor(el, property, value) {
                        if (!el) {
                            return;
                        }

                        el.style[property.charAt(0).toLowerCase() + property.slice(1)] = value;
                        el.style['webkit' + property] = value;
                        el.style['moz' + property] = value;
                        el.style['ms' + property] = value;
                        el.style['o' + property] = value;
                    },

                    trigger: function trigger(el, event) {
                        var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                        if (!el) {
                            return;
                        }

                        var customEvent = new CustomEvent(event, {
                            detail: detail
                        });
                        el.dispatchEvent(customEvent);
                    },

                    Listener: {
                        uid: 0
                    },
                    on: function on(el, events, fn) {
                        var _this = this;

                        if (!el) {
                            return;
                        }

                        events.split(' ').forEach(function (event) {
                            var _id = _this.getAttribute(el, 'lg-event-uid') || '';
                            utils.Listener.uid++;
                            _id += '&' + utils.Listener.uid;
                            _this.setAttribute(el, 'lg-event-uid', _id);
                            utils.Listener[event + utils.Listener.uid] = fn;
                            el.addEventListener(event.split('.')[0], fn, false);
                        });
                    },

                    off: function off(el, event) {
                        if (!el) {
                            return;
                        }

                        var _id = this.getAttribute(el, 'lg-event-uid');
                        if (_id) {
                            _id = _id.split('&');
                            for (var i = 0; i < _id.length; i++) {
                                if (_id[i]) {
                                    var _event = event + _id[i];
                                    if (_event.substring(0, 1) === '.') {
                                        for (var key in utils.Listener) {
                                            if (utils.Listener.hasOwnProperty(key)) {
                                                if (key.split('.').indexOf(_event.split('.')[1]) > -1) {
                                                    el.removeEventListener(key.split('.')[0], utils.Listener[key]);
                                                    this.setAttribute(el, 'lg-event-uid', this.getAttribute(el, 'lg-event-uid').replace('&' + _id[i], ''));
                                                    delete utils.Listener[key];
                                                }
                                            }
                                        }
                                    } else {
                                        el.removeEventListener(_event.split('.')[0], utils.Listener[_event]);
                                        this.setAttribute(el, 'lg-event-uid', this.getAttribute(el, 'lg-event-uid').replace('&' + _id[i], ''));
                                        delete utils.Listener[_event];
                                    }
                                }
                            }
                        }
                    },

                    param: function param(obj) {
                        return Object.keys(obj).map(function (k) {
                            return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
                        }).join('&');
                    }
                };

                exports.default = utils;
            });
        }, {}], 2: [function (require, module, exports) {
            (function (global, factory) {
                if (typeof define === "function" && define.amd) {
                    
                } else if (typeof exports !== "undefined") {
                    factory(require('./lg-utils'));
                } else {
                    var mod = {
                        exports: {}
                    };
                    factory(global.lgUtils);
                    global.lightgallery = mod.exports;
                }
            })(this, function (_lgUtils) {
                'use strict';

                var _lgUtils2 = _interopRequireDefault(_lgUtils);

                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }

                var _extends$$1 = Object.assign || function (target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];

                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }

                    return target;
                };

                /** Polyfill the CustomEvent() constructor functionality in Internet Explorer 9 and higher */
                (function () {

                    if (typeof window.CustomEvent === 'function') {
                        return false;
                    }

                    function CustomEvent(event, params) {
                        params = params || {
                            bubbles: false,
                            cancelable: false,
                            detail: undefined
                        };
                        var evt = document.createEvent('CustomEvent');
                        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                        return evt;
                    }

                    CustomEvent.prototype = window.Event.prototype;

                    window.CustomEvent = CustomEvent;
                })();

                window.utils = _lgUtils2.default;
                window.lgData = {
                    uid: 0
                };

                window.lgModules = {};
                var defaults$$1 = {

                    mode: 'lg-slide',

                    // Ex : 'ease'
                    cssEasing: 'ease',

                    //'for jquery animation'
                    easing: 'linear',
                    speed: 600,
                    height: '100%',
                    width: '100%',
                    addClass: '',
                    startClass: 'lg-start-zoom',
                    backdropDuration: 150,
                    hideBarsDelay: 6000,

                    useLeft: false,

                    closable: true,
                    loop: true,
                    escKey: true,
                    keyPress: true,
                    controls: true,
                    slideEndAnimatoin: true,
                    hideControlOnEnd: false,
                    mousewheel: false,

                    getCaptionFromTitleOrAlt: true,

                    // .lg-item || '.lg-sub-html'
                    appendSubHtmlTo: '.lg-sub-html',

                    subHtmlSelectorRelative: false,

                    /**
                     * @desc number of preload slides
                     * will exicute only after the current slide is fully loaded.
                     *
                     * @ex you clicked on 4th image and if preload = 1 then 3rd slide and 5th
                     * slide will be loaded in the background after the 4th slide is fully loaded..
                     * if preload is 2 then 2nd 3rd 5th 6th slides will be preloaded.. ... ...
                     *
                     */
                    preload: 1,
                    showAfterLoad: true,
                    selector: '',
                    selectWithin: '',
                    nextHtml: '',
                    prevHtml: '',

                    // 0, 1
                    index: false,

                    iframeMaxWidth: '100%',

                    download: true,
                    counter: true,
                    appendCounterTo: '.lg-toolbar',

                    swipeThreshold: 50,
                    enableSwipe: true,
                    enableDrag: true,

                    dynamic: false,
                    dynamicEl: [],
                    galleryId: 1
                };

                function Plugin(element, options) {

                    // Current lightGallery element
                    this.el = element;

                    // lightGallery settings
                    this.s = _extends$$1({}, defaults$$1, options);

                    // When using dynamic mode, ensure dynamicEl is an array
                    if (this.s.dynamic && this.s.dynamicEl !== 'undefined' && this.s.dynamicEl.constructor === Array && !this.s.dynamicEl.length) {
                        throw 'When using dynamic mode, you must also define dynamicEl as an Array.';
                    }

                    // lightGallery modules
                    this.modules = {};

                    // false when lightgallery complete first slide;
                    this.lGalleryOn = false;

                    this.lgBusy = false;

                    // Timeout function for hiding controls;
                    this.hideBartimeout = false;

                    // To determine browser supports for touch events;
                    this.isTouch = 'ontouchstart' in document.documentElement;

                    // Disable hideControlOnEnd if sildeEndAnimation is true
                    if (this.s.slideEndAnimatoin) {
                        this.s.hideControlOnEnd = false;
                    }

                    this.items = [];

                    // Gallery items
                    if (this.s.dynamic) {
                        this.items = this.s.dynamicEl;
                    } else {
                        if (this.s.selector === 'this') {
                            this.items.push(this.el);
                        } else if (this.s.selector !== '') {
                            if (this.s.selectWithin) {
                                this.items = document.querySelector(this.s.selectWithin).querySelectorAll(this.s.selector);
                            } else {
                                this.items = this.el.querySelectorAll(this.s.selector);
                            }
                        } else {
                            this.items = this.el.children;
                        }
                    }

                    // .lg-item

                    this.___slide = '';

                    // .lg-outer
                    this.outer = '';

                    this.init();

                    return this;
                }

                Plugin.prototype.init = function () {

                    var _this = this;

                    // s.preload should not be more than $item.length
                    if (_this.s.preload > _this.items.length) {
                        _this.s.preload = _this.items.length;
                    }

                    // if dynamic option is enabled execute immediately
                    var _hash = window.location.hash;
                    if (_hash.indexOf('lg=' + this.s.galleryId) > 0) {

                        _this.index = parseInt(_hash.split('&slide=')[1], 10);

                        _lgUtils2.default.addClass(document.body, 'lg-from-hash');
                        if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
                            _lgUtils2.default.addClass(document.body, 'lg-on');
                            setTimeout(function () {
                                _this.build(_this.index);
                            });
                        }
                    }

                    if (_this.s.dynamic) {

                        _lgUtils2.default.trigger(this.el, 'onBeforeOpen');

                        _this.index = _this.s.index || 0;

                        // prevent accidental double execution
                        if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
                            _lgUtils2.default.addClass(document.body, 'lg-on');
                            setTimeout(function () {
                                _this.build(_this.index);
                            });
                        }
                    } else {

                        for (var i = 0; i < _this.items.length; i++) {

                            /*jshint loopfunc: true */
                            (function (index) {

                                // Using different namespace for click because click event should not unbind if selector is same object('this')
                                _lgUtils2.default.on(_this.items[index], 'click.lgcustom', function (e) {

                                    e.preventDefault();

                                    _lgUtils2.default.trigger(_this.el, 'onBeforeOpen');

                                    _this.index = _this.s.index || index;

                                    if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
                                        _this.build(_this.index);
                                        _lgUtils2.default.addClass(document.body, 'lg-on');
                                    }
                                });
                            })(i);
                        }
                    }
                };

                Plugin.prototype.build = function (index) {

                    var _this = this;

                    _this.structure();

                    for (var key in window.lgModules) {
                        _this.modules[key] = new window.lgModules[key](_this.el);
                    }

                    // initiate slide function
                    _this.slide(index, false, false);

                    if (_this.s.keyPress) {
                        _this.keyPress();
                    }

                    if (_this.items.length > 1) {

                        _this.arrow();

                        setTimeout(function () {
                            _this.enableDrag();
                            _this.enableSwipe();
                        }, 50);

                        if (_this.s.mousewheel) {
                            _this.mousewheel();
                        }
                    }

                    _this.counter();

                    _this.closeGallery();

                    _lgUtils2.default.trigger(_this.el, 'onAfterOpen');

                    // Hide controllers if mouse doesn't move for some period
                    _lgUtils2.default.on(_this.outer, 'mousemove.lg click.lg touchstart.lg', function () {

                        _lgUtils2.default.removeClass(_this.outer, 'lg-hide-items');

                        clearTimeout(_this.hideBartimeout);

                        // Timeout will be cleared on each slide movement also
                        _this.hideBartimeout = setTimeout(function () {
                            _lgUtils2.default.addClass(_this.outer, 'lg-hide-items');
                        }, _this.s.hideBarsDelay);
                    });
                };

                Plugin.prototype.structure = function () {
                    var list = '';
                    var controls = '';
                    var i = 0;
                    var subHtmlCont = '';
                    var template;
                    var _this = this;

                    document.body.insertAdjacentHTML('beforeend', '<div class="lg-backdrop"></div>');
                    _lgUtils2.default.setVendor(document.querySelector('.lg-backdrop'), 'TransitionDuration', this.s.backdropDuration + 'ms');

                    // Create gallery items
                    for (i = 0; i < this.items.length; i++) {
                        list += '<div class="lg-item"></div>';
                    }

                    // Create controlls
                    if (this.s.controls && this.items.length > 1) {
                        controls = '<div class="lg-actions">' + '<div class="lg-prev lg-icon">' + this.s.prevHtml + '</div>' + '<div class="lg-next lg-icon">' + this.s.nextHtml + '</div>' + '</div>';
                    }

                    if (this.s.appendSubHtmlTo === '.lg-sub-html') {
                        subHtmlCont = '<div class="lg-sub-html"></div>';
                    }

                    template = '<div class="lg-outer ' + this.s.addClass + ' ' + this.s.startClass + '">' + '<div class="lg" style="width:' + this.s.width + '; height:' + this.s.height + '">' + '<div class="lg-inner">' + list + '</div>' + '<div class="lg-toolbar group">' + '<span class="lg-close lg-icon"></span>' + '</div>' + controls + subHtmlCont + '</div>' + '</div>';

                    document.body.insertAdjacentHTML('beforeend', template);
                    this.outer = document.querySelector('.lg-outer');
                    this.___slide = this.outer.querySelectorAll('.lg-item');

                    if (this.s.useLeft) {
                        _lgUtils2.default.addClass(this.outer, 'lg-use-left');

                        // Set mode lg-slide if use left is true;
                        this.s.mode = 'lg-slide';
                    } else {
                        _lgUtils2.default.addClass(this.outer, 'lg-use-css3');
                    }

                    // For fixed height gallery
                    _this.setTop();
                    _lgUtils2.default.on(window, 'resize.lg orientationchange.lg', function () {
                        setTimeout(function () {
                            _this.setTop();
                        }, 100);
                    });

                    // add class lg-current to remove initial transition
                    _lgUtils2.default.addClass(this.___slide[this.index], 'lg-current');

                    // add Class for css support and transition mode
                    if (this.doCss()) {
                        _lgUtils2.default.addClass(this.outer, 'lg-css3');
                    } else {
                        _lgUtils2.default.addClass(this.outer, 'lg-css');

                        // Set speed 0 because no animation will happen if browser doesn't support css3
                        this.s.speed = 0;
                    }

                    _lgUtils2.default.addClass(this.outer, this.s.mode);

                    if (this.s.enableDrag && this.items.length > 1) {
                        _lgUtils2.default.addClass(this.outer, 'lg-grab');
                    }

                    if (this.s.showAfterLoad) {
                        _lgUtils2.default.addClass(this.outer, 'lg-show-after-load');
                    }

                    if (this.doCss()) {
                        var inner = this.outer.querySelector('.lg-inner');
                        _lgUtils2.default.setVendor(inner, 'TransitionTimingFunction', this.s.cssEasing);
                        _lgUtils2.default.setVendor(inner, 'TransitionDuration', this.s.speed + 'ms');
                    }

                    setTimeout(function () {
                        _lgUtils2.default.addClass(document.querySelector('.lg-backdrop'), 'in');
                    });

                    setTimeout(function () {
                        _lgUtils2.default.addClass(_this.outer, 'lg-visible');
                    }, this.s.backdropDuration);

                    if (this.s.download) {
                        this.outer.querySelector('.lg-toolbar').insertAdjacentHTML('beforeend', '<a id="lg-download" target="_blank" download class="lg-download lg-icon"></a>');
                    }

                    // Store the current scroll top value to scroll back after closing the gallery..
                    this.prevScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                };

                // For fixed height gallery
                Plugin.prototype.setTop = function () {
                    if (this.s.height !== '100%') {
                        var wH = window.innerHeight;
                        var top = (wH - parseInt(this.s.height, 10)) / 2;
                        var lGallery = this.outer.querySelector('.lg');
                        if (wH >= parseInt(this.s.height, 10)) {
                            lGallery.style.top = top + 'px';
                        } else {
                            lGallery.style.top = '0px';
                        }
                    }
                };

                // Find css3 support
                Plugin.prototype.doCss = function () {
                    // check for css animation support
                    var support = function support() {
                        var transition = ['transition', 'MozTransition', 'WebkitTransition', 'OTransition', 'msTransition', 'KhtmlTransition'];
                        var root = document.documentElement;
                        var i = 0;
                        for (i = 0; i < transition.length; i++) {
                            if (transition[i] in root.style) {
                                return true;
                            }
                        }
                    };

                    if (support()) {
                        return true;
                    }

                    return false;
                };

                /**
                 *  @desc Check the given src is video
                 *  @param {String} src
                 *  @return {Object} video type
                 *  Ex:{ youtube  :  ["//www.youtube.com/watch?v=c0asJgSyxcY", "c0asJgSyxcY"] }
                 */
                Plugin.prototype.isVideo = function (src, index) {

                    var html;
                    if (this.s.dynamic) {
                        html = this.s.dynamicEl[index].html;
                    } else {
                        html = this.items[index].getAttribute('data-html');
                    }

                    if (!src && html) {
                        return {
                            html5: true
                        };
                    }

                    var youtube = src.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i);
                    var vimeo = src.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i);
                    var dailymotion = src.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i);
                    var vk = src.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);

                    if (youtube) {
                        return {
                            youtube: youtube
                        };
                    } else if (vimeo) {
                        return {
                            vimeo: vimeo
                        };
                    } else if (dailymotion) {
                        return {
                            dailymotion: dailymotion
                        };
                    } else if (vk) {
                        return {
                            vk: vk
                        };
                    }
                };

                /**
                 *  @desc Create image counter
                 *  Ex: 1/10
                 */
                Plugin.prototype.counter = function () {
                    if (this.s.counter) {
                        this.outer.querySelector(this.s.appendCounterTo).insertAdjacentHTML('beforeend', '<div id="lg-counter"><span id="lg-counter-current">' + (parseInt(this.index, 10) + 1) + '</span> / <span id="lg-counter-all">' + this.items.length + '</span></div>');
                    }
                };

                /**
                 *  @desc add sub-html into the slide
                 *  @param {Number} index - index of the slide
                 */
                Plugin.prototype.addHtml = function (index) {
                    var subHtml = null;
                    var currentEle;
                    if (this.s.dynamic) {
                        subHtml = this.s.dynamicEl[index].subHtml;
                    } else {
                        currentEle = this.items[index];
                        subHtml = currentEle.getAttribute('data-sub-html');
                        if (this.s.getCaptionFromTitleOrAlt && !subHtml) {
                            subHtml = currentEle.getAttribute('title');
                            if (subHtml && currentEle.querySelector('img')) {
                                subHtml = currentEle.querySelector('img').getAttribute('alt');
                            }
                        }
                    }

                    if (typeof subHtml !== 'undefined' && subHtml !== null) {

                        // get first letter of subhtml
                        // if first letter starts with . or # get the html form the jQuery object
                        var fL = subHtml.substring(0, 1);
                        if (fL === '.' || fL === '#') {
                            if (this.s.subHtmlSelectorRelative && !this.s.dynamic) {
                                subHtml = currentEle.querySelector(subHtml).innerHTML;
                            } else {
                                subHtml = document.querySelector(subHtml).innerHTML;
                            }
                        }
                    } else {
                        subHtml = '';
                    }

                    if (this.s.appendSubHtmlTo === '.lg-sub-html') {
                        this.outer.querySelector(this.s.appendSubHtmlTo).innerHTML = subHtml;
                    } else {
                        this.___slide[index].insertAdjacentHTML('beforeend', subHtml);
                    }

                    // Add lg-empty-html class if title doesn't exist
                    if (typeof subHtml !== 'undefined' && subHtml !== null) {
                        if (subHtml === '') {
                            _lgUtils2.default.addClass(this.outer.querySelector(this.s.appendSubHtmlTo), 'lg-empty-html');
                        } else {
                            _lgUtils2.default.removeClass(this.outer.querySelector(this.s.appendSubHtmlTo), 'lg-empty-html');
                        }
                    }

                    _lgUtils2.default.trigger(this.el, 'onAfterAppendSubHtml', {
                        index: index
                    });
                };

                /**
                 *  @desc Preload slides
                 *  @param {Number} index - index of the slide
                 */
                Plugin.prototype.preload = function (index) {
                    var i = 1;
                    var j = 1;
                    for (i = 1; i <= this.s.preload; i++) {
                        if (i >= this.items.length - index) {
                            break;
                        }

                        this.loadContent(index + i, false, 0);
                    }

                    for (j = 1; j <= this.s.preload; j++) {
                        if (index - j < 0) {
                            break;
                        }

                        this.loadContent(index - j, false, 0);
                    }
                };

                /**
                 *  @desc Load slide content into slide.
                 *  @param {Number} index - index of the slide.
                 *  @param {Boolean} rec - if true call loadcontent() function again.
                 *  @param {Boolean} delay - delay for adding complete class. it is 0 except first time.
                 */
                Plugin.prototype.loadContent = function (index, rec, delay) {

                    var _this = this;
                    var _hasPoster = false;
                    var _img;
                    var _src;
                    var _poster;
                    var _srcset;
                    var _sizes;
                    var _html;
                    var getResponsiveSrc = function getResponsiveSrc(srcItms) {
                        var rsWidth = [];
                        var rsSrc = [];
                        for (var i = 0; i < srcItms.length; i++) {
                            var __src = srcItms[i].split(' ');

                            // Manage empty space
                            if (__src[0] === '') {
                                __src.splice(0, 1);
                            }

                            rsSrc.push(__src[0]);
                            rsWidth.push(__src[1]);
                        }

                        var wWidth = window.innerWidth;
                        for (var j = 0; j < rsWidth.length; j++) {
                            if (parseInt(rsWidth[j], 10) > wWidth) {
                                _src = rsSrc[j];
                                break;
                            }
                        }
                    };

                    if (_this.s.dynamic) {

                        if (_this.s.dynamicEl[index].poster) {
                            _hasPoster = true;
                            _poster = _this.s.dynamicEl[index].poster;
                        }

                        _html = _this.s.dynamicEl[index].html;
                        _src = _this.s.dynamicEl[index].src;

                        if (_this.s.dynamicEl[index].responsive) {
                            var srcDyItms = _this.s.dynamicEl[index].responsive.split(',');
                            getResponsiveSrc(srcDyItms);
                        }

                        _srcset = _this.s.dynamicEl[index].srcset;
                        _sizes = _this.s.dynamicEl[index].sizes;
                    } else {

                        if (_this.items[index].getAttribute('data-poster')) {
                            _hasPoster = true;
                            _poster = _this.items[index].getAttribute('data-poster');
                        }

                        _html = _this.items[index].getAttribute('data-html');
                        _src = _this.items[index].getAttribute('href') || _this.items[index].getAttribute('data-src');

                        if (_this.items[index].getAttribute('data-responsive')) {
                            var srcItms = _this.items[index].getAttribute('data-responsive').split(',');
                            getResponsiveSrc(srcItms);
                        }

                        _srcset = _this.items[index].getAttribute('data-srcset');
                        _sizes = _this.items[index].getAttribute('data-sizes');
                    }

                    //if (_src || _srcset || _sizes || _poster) {

                    var iframe = false;
                    if (_this.s.dynamic) {
                        if (_this.s.dynamicEl[index].iframe) {
                            iframe = true;
                        }
                    } else {
                        if (_this.items[index].getAttribute('data-iframe') === 'true') {
                            iframe = true;
                        }
                    }

                    var _isVideo = _this.isVideo(_src, index);
                    if (!_lgUtils2.default.hasClass(_this.___slide[index], 'lg-loaded')) {
                        if (iframe) {
                            _this.___slide[index].insertAdjacentHTML('afterbegin', '<div class="lg-video-cont" style="max-width:' + _this.s.iframeMaxWidth + '"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="' + _src + '"  allowfullscreen="true"></iframe></div></div>');
                        } else if (_hasPoster) {
                            var videoClass = '';
                            if (_isVideo && _isVideo.youtube) {
                                videoClass = 'lg-has-youtube';
                            } else if (_isVideo && _isVideo.vimeo) {
                                videoClass = 'lg-has-vimeo';
                            } else {
                                videoClass = 'lg-has-html5';
                            }

                            _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-video-cont ' + videoClass + ' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="' + _poster + '" /></div></div>');
                        } else if (_isVideo) {
                            _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-video-cont "><div class="lg-video"></div></div>');
                            _lgUtils2.default.trigger(_this.el, 'hasVideo', {
                                index: index,
                                src: _src,
                                html: _html
                            });
                        } else {
                            _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-img-wrap"><img class="lg-object lg-image" src="' + _src + '" /></div>');
                        }

                        _lgUtils2.default.trigger(_this.el, 'onAferAppendSlide', {
                            index: index
                        });

                        _img = _this.___slide[index].querySelector('.lg-object');
                        if (_sizes) {
                            _img.setAttribute('sizes', _sizes);
                        }

                        if (_srcset) {
                            _img.setAttribute('srcset', _srcset);
                            try {
                                picturefill({
                                    elements: [_img[0]]
                                });
                            } catch (e) {
                                console.error('Make sure you have included Picturefill version 2');
                            }
                        }

                        if (this.s.appendSubHtmlTo !== '.lg-sub-html') {
                            _this.addHtml(index);
                        }

                        _lgUtils2.default.addClass(_this.___slide[index], 'lg-loaded');
                    }

                    _lgUtils2.default.on(_this.___slide[index].querySelector('.lg-object'), 'load.lg error.lg', function () {

                        // For first time add some delay for displaying the start animation.
                        var _speed = 0;

                        // Do not change the delay value because it is required for zoom plugin.
                        // If gallery opened from direct url (hash) speed value should be 0
                        if (delay && !_lgUtils2.default.hasClass(document.body, 'lg-from-hash')) {
                            _speed = delay;
                        }

                        setTimeout(function () {
                            _lgUtils2.default.addClass(_this.___slide[index], 'lg-complete');

                            _lgUtils2.default.trigger(_this.el, 'onSlideItemLoad', {
                                index: index,
                                delay: delay || 0
                            });
                        }, _speed);
                    });

                    // @todo check load state for html5 videos
                    if (_isVideo && _isVideo.html5 && !_hasPoster) {
                        _lgUtils2.default.addClass(_this.___slide[index], 'lg-complete');
                    }

                    if (rec === true) {
                        if (!_lgUtils2.default.hasClass(_this.___slide[index], 'lg-complete')) {
                            _lgUtils2.default.on(_this.___slide[index].querySelector('.lg-object'), 'load.lg error.lg', function () {
                                _this.preload(index);
                            });
                        } else {
                            _this.preload(index);
                        }
                    }

                    //}
                };

                /**
                 *   @desc slide function for lightgallery
                 ** Slide() gets call on start
                 ** ** Set lg.on true once slide() function gets called.
                 ** Call loadContent() on slide() function inside setTimeout
                 ** ** On first slide we do not want any animation like slide of fade
                 ** ** So on first slide( if lg.on if false that is first slide) loadContent() should start loading immediately
                 ** ** Else loadContent() should wait for the transition to complete.
                 ** ** So set timeout s.speed + 50
                 <=> ** loadContent() will load slide content in to the particular slide
                 ** ** It has recursion (rec) parameter. if rec === true loadContent() will call preload() function.
                 ** ** preload will execute only when the previous slide is fully loaded (images iframe)
                 ** ** avoid simultaneous image load
                 <=> ** Preload() will check for s.preload value and call loadContent() again accoring to preload value
                 ** loadContent()  <====> Preload();
                  *   @param {Number} index - index of the slide
                 *   @param {Boolean} fromTouch - true if slide function called via touch event or mouse drag
                 *   @param {Boolean} fromThumb - true if slide function called via thumbnail click
                 */
                Plugin.prototype.slide = function (index, fromTouch, fromThumb) {

                    var _prevIndex = 0;
                    for (var i = 0; i < this.___slide.length; i++) {
                        if (_lgUtils2.default.hasClass(this.___slide[i], 'lg-current')) {
                            _prevIndex = i;
                            break;
                        }
                    }

                    var _this = this;

                    // Prevent if multiple call
                    // Required for hsh plugin
                    if (_this.lGalleryOn && _prevIndex === index) {
                        return;
                    }

                    var _length = this.___slide.length;
                    var _time = _this.lGalleryOn ? this.s.speed : 0;
                    var _next = false;
                    var _prev = false;

                    if (!_this.lgBusy) {

                        if (this.s.download) {
                            var _src;
                            if (_this.s.dynamic) {
                                _src = _this.s.dynamicEl[index].downloadUrl !== false && (_this.s.dynamicEl[index].downloadUrl || _this.s.dynamicEl[index].src);
                            } else {
                                _src = _this.items[index].getAttribute('data-download-url') !== 'false' && (_this.items[index].getAttribute('data-download-url') || _this.items[index].getAttribute('href') || _this.items[index].getAttribute('data-src'));
                            }

                            if (_src) {
                                document.getElementById('lg-download').setAttribute('href', _src);
                                _lgUtils2.default.removeClass(_this.outer, 'lg-hide-download');
                            } else {
                                _lgUtils2.default.addClass(_this.outer, 'lg-hide-download');
                            }
                        }

                        _lgUtils2.default.trigger(_this.el, 'onBeforeSlide', {
                            prevIndex: _prevIndex,
                            index: index,
                            fromTouch: fromTouch,
                            fromThumb: fromThumb
                        });

                        _this.lgBusy = true;

                        clearTimeout(_this.hideBartimeout);

                        // Add title if this.s.appendSubHtmlTo === lg-sub-html
                        if (this.s.appendSubHtmlTo === '.lg-sub-html') {

                            // wait for slide animation to complete
                            setTimeout(function () {
                                _this.addHtml(index);
                            }, _time);
                        }

                        this.arrowDisable(index);

                        if (!fromTouch) {

                            // remove all transitions
                            _lgUtils2.default.addClass(_this.outer, 'lg-no-trans');

                            for (var j = 0; j < this.___slide.length; j++) {
                                _lgUtils2.default.removeClass(this.___slide[j], 'lg-prev-slide');
                                _lgUtils2.default.removeClass(this.___slide[j], 'lg-next-slide');
                            }

                            if (index < _prevIndex) {
                                _prev = true;
                                if (index === 0 && _prevIndex === _length - 1 && !fromThumb) {
                                    _prev = false;
                                    _next = true;
                                }
                            } else if (index > _prevIndex) {
                                _next = true;
                                if (index === _length - 1 && _prevIndex === 0 && !fromThumb) {
                                    _prev = true;
                                    _next = false;
                                }
                            }

                            if (_prev) {

                                //prevslide
                                _lgUtils2.default.addClass(this.___slide[index], 'lg-prev-slide');
                                _lgUtils2.default.addClass(this.___slide[_prevIndex], 'lg-next-slide');
                            } else if (_next) {

                                // next slide
                                _lgUtils2.default.addClass(this.___slide[index], 'lg-next-slide');
                                _lgUtils2.default.addClass(this.___slide[_prevIndex], 'lg-prev-slide');
                            }

                            // give 50 ms for browser to add/remove class
                            setTimeout(function () {
                                _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-current'), 'lg-current');

                                //_this.$slide.eq(_prevIndex).removeClass('lg-current');
                                _lgUtils2.default.addClass(_this.___slide[index], 'lg-current');

                                // reset all transitions
                                _lgUtils2.default.removeClass(_this.outer, 'lg-no-trans');
                            }, 50);
                        } else {

                            var touchPrev = index - 1;
                            var touchNext = index + 1;

                            if (index === 0 && _prevIndex === _length - 1) {

                                // next slide
                                touchNext = 0;
                                touchPrev = _length - 1;
                            } else if (index === _length - 1 && _prevIndex === 0) {

                                // prev slide
                                touchNext = 0;
                                touchPrev = _length - 1;
                            }

                            _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-prev-slide'), 'lg-prev-slide');
                            _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-current'), 'lg-current');
                            _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-next-slide'), 'lg-next-slide');
                            _lgUtils2.default.addClass(_this.___slide[touchPrev], 'lg-prev-slide');
                            _lgUtils2.default.addClass(_this.___slide[touchNext], 'lg-next-slide');
                            _lgUtils2.default.addClass(_this.___slide[index], 'lg-current');
                        }

                        if (_this.lGalleryOn) {
                            setTimeout(function () {
                                _this.loadContent(index, true, 0);
                            }, this.s.speed + 50);

                            setTimeout(function () {
                                _this.lgBusy = false;
                                _lgUtils2.default.trigger(_this.el, 'onAfterSlide', {
                                    prevIndex: _prevIndex,
                                    index: index,
                                    fromTouch: fromTouch,
                                    fromThumb: fromThumb
                                });
                            }, this.s.speed);
                        } else {
                            _this.loadContent(index, true, _this.s.backdropDuration);

                            _this.lgBusy = false;
                            _lgUtils2.default.trigger(_this.el, 'onAfterSlide', {
                                prevIndex: _prevIndex,
                                index: index,
                                fromTouch: fromTouch,
                                fromThumb: fromThumb
                            });
                        }

                        _this.lGalleryOn = true;

                        if (this.s.counter) {
                            if (document.getElementById('lg-counter-current')) {
                                document.getElementById('lg-counter-current').innerHTML = index + 1;
                            }
                        }
                    }
                };

                /**
                 *  @desc Go to next slide
                 *  @param {Boolean} fromTouch - true if slide function called via touch event
                 */
                Plugin.prototype.goToNextSlide = function (fromTouch) {
                    var _this = this;
                    if (!_this.lgBusy) {
                        if (_this.index + 1 < _this.___slide.length) {
                            _this.index++;
                            _lgUtils2.default.trigger(_this.el, 'onBeforeNextSlide', {
                                index: _this.index
                            });
                            _this.slide(_this.index, fromTouch, false);
                        } else {
                            if (_this.s.loop) {
                                _this.index = 0;
                                _lgUtils2.default.trigger(_this.el, 'onBeforeNextSlide', {
                                    index: _this.index
                                });
                                _this.slide(_this.index, fromTouch, false);
                            } else if (_this.s.slideEndAnimatoin) {
                                _lgUtils2.default.addClass(_this.outer, 'lg-right-end');
                                setTimeout(function () {
                                    _lgUtils2.default.removeClass(_this.outer, 'lg-right-end');
                                }, 400);
                            }
                        }
                    }
                };

                /**
                 *  @desc Go to previous slide
                 *  @param {Boolean} fromTouch - true if slide function called via touch event
                 */
                Plugin.prototype.goToPrevSlide = function (fromTouch) {
                    var _this = this;
                    if (!_this.lgBusy) {
                        if (_this.index > 0) {
                            _this.index--;
                            _lgUtils2.default.trigger(_this.el, 'onBeforePrevSlide', {
                                index: _this.index,
                                fromTouch: fromTouch
                            });
                            _this.slide(_this.index, fromTouch, false);
                        } else {
                            if (_this.s.loop) {
                                _this.index = _this.items.length - 1;
                                _lgUtils2.default.trigger(_this.el, 'onBeforePrevSlide', {
                                    index: _this.index,
                                    fromTouch: fromTouch
                                });
                                _this.slide(_this.index, fromTouch, false);
                            } else if (_this.s.slideEndAnimatoin) {
                                _lgUtils2.default.addClass(_this.outer, 'lg-left-end');
                                setTimeout(function () {
                                    _lgUtils2.default.removeClass(_this.outer, 'lg-left-end');
                                }, 400);
                            }
                        }
                    }
                };

                Plugin.prototype.keyPress = function () {
                    var _this = this;
                    if (this.items.length > 1) {
                        _lgUtils2.default.on(window, 'keyup.lg', function (e) {
                            if (_this.items.length > 1) {
                                if (e.keyCode === 37) {
                                    e.preventDefault();
                                    _this.goToPrevSlide();
                                }

                                if (e.keyCode === 39) {
                                    e.preventDefault();
                                    _this.goToNextSlide();
                                }
                            }
                        });
                    }

                    _lgUtils2.default.on(window, 'keydown.lg', function (e) {
                        if (_this.s.escKey === true && e.keyCode === 27) {
                            e.preventDefault();
                            if (!_lgUtils2.default.hasClass(_this.outer, 'lg-thumb-open')) {
                                _this.destroy();
                            } else {
                                _lgUtils2.default.removeClass(_this.outer, 'lg-thumb-open');
                            }
                        }
                    });
                };

                Plugin.prototype.arrow = function () {
                    var _this = this;
                    _lgUtils2.default.on(this.outer.querySelector('.lg-prev'), 'click.lg', function () {
                        _this.goToPrevSlide();
                    });

                    _lgUtils2.default.on(this.outer.querySelector('.lg-next'), 'click.lg', function () {
                        _this.goToNextSlide();
                    });
                };

                Plugin.prototype.arrowDisable = function (index) {

                    // Disable arrows if s.hideControlOnEnd is true
                    if (!this.s.loop && this.s.hideControlOnEnd) {
                        var next = this.outer.querySelector('.lg-next');
                        var prev = this.outer.querySelector('.lg-prev');
                        if (index + 1 < this.___slide.length) {
                            next.removeAttribute('disabled');
                            _lgUtils2.default.removeClass(next, 'disabled');
                        } else {
                            next.setAttribute('disabled', 'disabled');
                            _lgUtils2.default.addClass(next, 'disabled');
                        }

                        if (index > 0) {
                            prev.removeAttribute('disabled');
                            _lgUtils2.default.removeClass(prev, 'disabled');
                        } else {
                            prev.setAttribute('disabled', 'disabled');
                            _lgUtils2.default.addClass(prev, 'disabled');
                        }
                    }
                };

                Plugin.prototype.setTranslate = function (el, xValue, yValue) {
                    // jQuery supports Automatic CSS prefixing since jQuery 1.8.0
                    if (this.s.useLeft) {
                        el.style.left = xValue;
                    } else {
                        _lgUtils2.default.setVendor(el, 'Transform', 'translate3d(' + xValue + 'px, ' + yValue + 'px, 0px)');
                    }
                };

                Plugin.prototype.touchMove = function (startCoords, endCoords) {

                    var distance = endCoords - startCoords;

                    if (Math.abs(distance) > 15) {
                        // reset opacity and transition duration
                        _lgUtils2.default.addClass(this.outer, 'lg-dragging');

                        // move current slide
                        this.setTranslate(this.___slide[this.index], distance, 0);

                        // move next and prev slide with current slide
                        this.setTranslate(document.querySelector('.lg-prev-slide'), -this.___slide[this.index].clientWidth + distance, 0);
                        this.setTranslate(document.querySelector('.lg-next-slide'), this.___slide[this.index].clientWidth + distance, 0);
                    }
                };

                Plugin.prototype.touchEnd = function (distance) {
                    var _this = this;

                    // keep slide animation for any mode while dragg/swipe
                    if (_this.s.mode !== 'lg-slide') {
                        _lgUtils2.default.addClass(_this.outer, 'lg-slide');
                    }

                    for (var i = 0; i < this.___slide.length; i++) {
                        if (!_lgUtils2.default.hasClass(this.___slide[i], 'lg-current') && !_lgUtils2.default.hasClass(this.___slide[i], 'lg-prev-slide') && !_lgUtils2.default.hasClass(this.___slide[i], 'lg-next-slide')) {
                            this.___slide[i].style.opacity = '0';
                        }
                    }

                    // set transition duration
                    setTimeout(function () {
                        _lgUtils2.default.removeClass(_this.outer, 'lg-dragging');
                        if (distance < 0 && Math.abs(distance) > _this.s.swipeThreshold) {
                            _this.goToNextSlide(true);
                        } else if (distance > 0 && Math.abs(distance) > _this.s.swipeThreshold) {
                            _this.goToPrevSlide(true);
                        } else if (Math.abs(distance) < 5) {

                            // Trigger click if distance is less than 5 pix
                            _lgUtils2.default.trigger(_this.el, 'onSlideClick');
                        }

                        for (var i = 0; i < _this.___slide.length; i++) {
                            _this.___slide[i].removeAttribute('style');
                        }
                    });

                    // remove slide class once drag/swipe is completed if mode is not slide
                    setTimeout(function () {
                        if (!_lgUtils2.default.hasClass(_this.outer, 'lg-dragging') && _this.s.mode !== 'lg-slide') {
                            _lgUtils2.default.removeClass(_this.outer, 'lg-slide');
                        }
                    }, _this.s.speed + 100);
                };

                Plugin.prototype.enableSwipe = function () {
                    var _this = this;
                    var startCoords = 0;
                    var endCoords = 0;
                    var isMoved = false;

                    if (_this.s.enableSwipe && _this.isTouch && _this.doCss()) {

                        for (var i = 0; i < _this.___slide.length; i++) {
                            /*jshint loopfunc: true */
                            _lgUtils2.default.on(_this.___slide[i], 'touchstart.lg', function (e) {
                                if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed') && !_this.lgBusy) {
                                    e.preventDefault();
                                    _this.manageSwipeClass();
                                    startCoords = e.targetTouches[0].pageX;
                                }
                            });
                        }

                        for (var j = 0; j < _this.___slide.length; j++) {
                            /*jshint loopfunc: true */
                            _lgUtils2.default.on(_this.___slide[j], 'touchmove.lg', function (e) {
                                if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
                                    e.preventDefault();
                                    endCoords = e.targetTouches[0].pageX;
                                    _this.touchMove(startCoords, endCoords);
                                    isMoved = true;
                                }
                            });
                        }

                        for (var k = 0; k < _this.___slide.length; k++) {
                            /*jshint loopfunc: true */
                            _lgUtils2.default.on(_this.___slide[k], 'touchend.lg', function () {
                                if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
                                    if (isMoved) {
                                        isMoved = false;
                                        _this.touchEnd(endCoords - startCoords);
                                    } else {
                                        _lgUtils2.default.trigger(_this.el, 'onSlideClick');
                                    }
                                }
                            });
                        }
                    }
                };

                Plugin.prototype.enableDrag = function () {
                    var _this = this;
                    var startCoords = 0;
                    var endCoords = 0;
                    var isDraging = false;
                    var isMoved = false;
                    if (_this.s.enableDrag && !_this.isTouch && _this.doCss()) {
                        for (var i = 0; i < _this.___slide.length; i++) {
                            /*jshint loopfunc: true */
                            _lgUtils2.default.on(_this.___slide[i], 'mousedown.lg', function (e) {
                                // execute only on .lg-object
                                if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
                                    if (_lgUtils2.default.hasClass(e.target, 'lg-object') || _lgUtils2.default.hasClass(e.target, 'lg-video-play')) {
                                        e.preventDefault();

                                        if (!_this.lgBusy) {
                                            _this.manageSwipeClass();
                                            startCoords = e.pageX;
                                            isDraging = true;

                                            // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
                                            _this.outer.scrollLeft += 1;
                                            _this.outer.scrollLeft -= 1;

                                            // *

                                            _lgUtils2.default.removeClass(_this.outer, 'lg-grab');
                                            _lgUtils2.default.addClass(_this.outer, 'lg-grabbing');

                                            _lgUtils2.default.trigger(_this.el, 'onDragstart');
                                        }
                                    }
                                }
                            });
                        }

                        _lgUtils2.default.on(window, 'mousemove.lg', function (e) {
                            if (isDraging) {
                                isMoved = true;
                                endCoords = e.pageX;
                                _this.touchMove(startCoords, endCoords);
                                _lgUtils2.default.trigger(_this.el, 'onDragmove');
                            }
                        });

                        _lgUtils2.default.on(window, 'mouseup.lg', function (e) {
                            if (isMoved) {
                                isMoved = false;
                                _this.touchEnd(endCoords - startCoords);
                                _lgUtils2.default.trigger(_this.el, 'onDragend');
                            } else if (_lgUtils2.default.hasClass(e.target, 'lg-object') || _lgUtils2.default.hasClass(e.target, 'lg-video-play')) {
                                _lgUtils2.default.trigger(_this.el, 'onSlideClick');
                            }

                            // Prevent execution on click
                            if (isDraging) {
                                isDraging = false;
                                _lgUtils2.default.removeClass(_this.outer, 'lg-grabbing');
                                _lgUtils2.default.addClass(_this.outer, 'lg-grab');
                            }
                        });
                    }
                };

                Plugin.prototype.manageSwipeClass = function () {
                    var touchNext = this.index + 1;
                    var touchPrev = this.index - 1;
                    var length = this.___slide.length;
                    if (this.s.loop) {
                        if (this.index === 0) {
                            touchPrev = length - 1;
                        } else if (this.index === length - 1) {
                            touchNext = 0;
                        }
                    }

                    for (var i = 0; i < this.___slide.length; i++) {
                        _lgUtils2.default.removeClass(this.___slide[i], 'lg-next-slide');
                        _lgUtils2.default.removeClass(this.___slide[i], 'lg-prev-slide');
                    }

                    if (touchPrev > -1) {
                        _lgUtils2.default.addClass(this.___slide[touchPrev], 'lg-prev-slide');
                    }

                    _lgUtils2.default.addClass(this.___slide[touchNext], 'lg-next-slide');
                };

                Plugin.prototype.mousewheel = function () {
                    var _this = this;
                    _lgUtils2.default.on(_this.outer, 'mousewheel.lg', function (e) {

                        if (!e.deltaY) {
                            return;
                        }

                        if (e.deltaY > 0) {
                            _this.goToPrevSlide();
                        } else {
                            _this.goToNextSlide();
                        }

                        e.preventDefault();
                    });
                };

                Plugin.prototype.closeGallery = function () {

                    var _this = this;
                    var mousedown = false;
                    _lgUtils2.default.on(this.outer.querySelector('.lg-close'), 'click.lg', function () {
                        _this.destroy();
                    });

                    if (_this.s.closable) {

                        // If you drag the slide and release outside gallery gets close on chrome
                        // for preventing this check mousedown and mouseup happened on .lg-item or lg-outer
                        _lgUtils2.default.on(_this.outer, 'mousedown.lg', function (e) {

                            if (_lgUtils2.default.hasClass(e.target, 'lg-outer') || _lgUtils2.default.hasClass(e.target, 'lg-item') || _lgUtils2.default.hasClass(e.target, 'lg-img-wrap')) {
                                mousedown = true;
                            } else {
                                mousedown = false;
                            }
                        });

                        _lgUtils2.default.on(_this.outer, 'mouseup.lg', function (e) {

                            if (_lgUtils2.default.hasClass(e.target, 'lg-outer') || _lgUtils2.default.hasClass(e.target, 'lg-item') || _lgUtils2.default.hasClass(e.target, 'lg-img-wrap') && mousedown) {
                                if (!_lgUtils2.default.hasClass(_this.outer, 'lg-dragging')) {
                                    _this.destroy();
                                }
                            }
                        });
                    }
                };

                Plugin.prototype.destroy = function (d) {

                    var _this = this;

                    if (!d) {
                        _lgUtils2.default.trigger(_this.el, 'onBeforeClose');
                    }

                    document.body.scrollTop = _this.prevScrollTop;
                    document.documentElement.scrollTop = _this.prevScrollTop;

                    /**
                     * if d is false or undefined destroy will only close the gallery
                     * plugins instance remains with the element
                     *
                     * if d is true destroy will completely remove the plugin
                     */

                    if (d) {
                        if (!_this.s.dynamic) {
                            // only when not using dynamic mode is $items a jquery collection

                            for (var i = 0; i < this.items.length; i++) {
                                _lgUtils2.default.off(this.items[i], '.lg');
                                _lgUtils2.default.off(this.items[i], '.lgcustom');
                            }
                        }

                        var lguid = _this.el.getAttribute('lg-uid');
                        delete window.lgData[lguid];
                        _this.el.removeAttribute('lg-uid');
                    }

                    // Unbind all events added by lightGallery
                    _lgUtils2.default.off(this.el, '.lgtm');

                    // Distroy all lightGallery modules
                    for (var key in window.lgModules) {
                        if (_this.modules[key]) {
                            _this.modules[key].destroy(d);
                        }
                    }

                    this.lGalleryOn = false;

                    clearTimeout(_this.hideBartimeout);
                    this.hideBartimeout = false;
                    _lgUtils2.default.off(window, '.lg');
                    _lgUtils2.default.removeClass(document.body, 'lg-on');
                    _lgUtils2.default.removeClass(document.body, 'lg-from-hash');

                    if (_this.outer) {
                        _lgUtils2.default.removeClass(_this.outer, 'lg-visible');
                    }

                    _lgUtils2.default.removeClass(document.querySelector('.lg-backdrop'), 'in');
                    setTimeout(function () {
                        try {
                            if (_this.outer) {
                                _this.outer.parentNode.removeChild(_this.outer);
                            }

                            if (document.querySelector('.lg-backdrop')) {
                                document.querySelector('.lg-backdrop').parentNode.removeChild(document.querySelector('.lg-backdrop'));
                            }

                            if (!d) {
                                _lgUtils2.default.trigger(_this.el, 'onCloseAfter');
                            }
                        } catch (err) {}
                    }, _this.s.backdropDuration + 50);
                };

                window.lightGallery = function (el, options) {
                    if (!el) {
                        return;
                    }

                    try {
                        if (!el.getAttribute('lg-uid')) {
                            var uid = 'lg' + window.lgData.uid++;
                            window.lgData[uid] = new Plugin(el, options);
                            el.setAttribute('lg-uid', uid);
                        } else {
                            try {
                                window.lgData[el.getAttribute('lg-uid')].init();
                            } catch (err) {
                                console.error('lightGallery has not initiated properly');
                            }
                        }
                    } catch (err) {
                        console.error('lightGallery has not initiated properly');
                    }
                };
            });
        }, { "./lg-utils": 1 }] }, {}, [2])(2);
});

/*! Picturefill - v2.3.1 - 2015-04-09
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT */
window.matchMedia || (window.matchMedia = function () {
    "use strict";

    var a = window.styleMedia || window.media;
    if (!a) {
        var b = document.createElement("style"),
            c = document.getElementsByTagName("script")[0],
            d = null;
        b.type = "text/css", b.id = "matchmediajs-test", c.parentNode.insertBefore(b, c), d = "getComputedStyle" in window && window.getComputedStyle(b, null) || b.currentStyle, a = {
            matchMedium: function matchMedium(a) {
                var c = "@media " + a + "{ #matchmediajs-test { width: 1px; } }";
                return b.styleSheet ? b.styleSheet.cssText = c : b.textContent = c, "1px" === d.width;
            }
        };
    }
    return function (b) {
        return { matches: a.matchMedium(b || "all"), media: b || "all" };
    };
}()), function (a, b, c) {
    "use strict";

    function d(b) {
        "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = b : "function" == typeof define && define.amd && define("picturefill", function () {
            return b;
        }), "object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) && (a.picturefill = b);
    }
    function e(a) {
        var b,
            c,
            d,
            e,
            f,
            i = a || {};
        b = i.elements || g.getAllElements();
        for (var j = 0, k = b.length; k > j; j++) {
            if (c = b[j], d = c.parentNode, e = void 0, f = void 0, "IMG" === c.nodeName.toUpperCase() && (c[g.ns] || (c[g.ns] = {}), i.reevaluate || !c[g.ns].evaluated)) {
                if (d && "PICTURE" === d.nodeName.toUpperCase()) {
                    if (g.removeVideoShim(d), e = g.getMatch(c, d), e === !1) continue;
                } else e = void 0;
                (d && "PICTURE" === d.nodeName.toUpperCase() || !g.sizesSupported && c.srcset && h.test(c.srcset)) && g.dodgeSrcset(c), e ? (f = g.processSourceSet(e), g.applyBestCandidate(f, c)) : (f = g.processSourceSet(c), (void 0 === c.srcset || c[g.ns].srcset) && g.applyBestCandidate(f, c)), c[g.ns].evaluated = !0;
            }
        }
    }
    function f() {
        function c() {
            clearTimeout(d), d = setTimeout(h, 60);
        }
        g.initTypeDetects(), e();
        var d,
            f = setInterval(function () {
            return e(), /^loaded|^i|^c/.test(b.readyState) ? void clearInterval(f) : void 0;
        }, 250),
            h = function h() {
            e({ reevaluate: !0 });
        };
        a.addEventListener ? a.addEventListener("resize", c, !1) : a.attachEvent && a.attachEvent("onresize", c);
    }
    if (a.HTMLPictureElement) return void d(function () {});
    b.createElement("picture");
    var g = a.picturefill || {},
        h = /\s+\+?\d+(e\d+)?w/;
    g.ns = "picturefill", function () {
        g.srcsetSupported = "srcset" in c, g.sizesSupported = "sizes" in c, g.curSrcSupported = "currentSrc" in c;
    }(), g.trim = function (a) {
        return a.trim ? a.trim() : a.replace(/^\s+|\s+$/g, "");
    }, g.makeUrl = function () {
        var a = b.createElement("a");
        return function (b) {
            return a.href = b, a.href;
        };
    }(), g.restrictsMixedContent = function () {
        return "https:" === a.location.protocol;
    }, g.matchesMedia = function (b) {
        return a.matchMedia && a.matchMedia(b).matches;
    }, g.getDpr = function () {
        return a.devicePixelRatio || 1;
    }, g.getWidthFromLength = function (a) {
        var c;
        if (!a || a.indexOf("%") > -1 != !1 || !(parseFloat(a) > 0 || a.indexOf("calc(") > -1)) return !1;
        a = a.replace("vw", "%"), g.lengthEl || (g.lengthEl = b.createElement("div"), g.lengthEl.style.cssText = "border:0;display:block;font-size:1em;left:0;margin:0;padding:0;position:absolute;visibility:hidden", g.lengthEl.className = "helper-from-picturefill-js"), g.lengthEl.style.width = "0px";
        try {
            g.lengthEl.style.width = a;
        } catch (d) {}
        return b.body.appendChild(g.lengthEl), c = g.lengthEl.offsetWidth, 0 >= c && (c = !1), b.body.removeChild(g.lengthEl), c;
    }, g.detectTypeSupport = function (b, c) {
        var d = new a.Image();
        return d.onerror = function () {
            g.types[b] = !1, e();
        }, d.onload = function () {
            g.types[b] = 1 === d.width, e();
        }, d.src = c, "pending";
    }, g.types = g.types || {}, g.initTypeDetects = function () {
        g.types["image/jpeg"] = !0, g.types["image/gif"] = !0, g.types["image/png"] = !0, g.types["image/svg+xml"] = b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1"), g.types["image/webp"] = g.detectTypeSupport("image/webp", "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=");
    }, g.verifyTypeSupport = function (a) {
        var b = a.getAttribute("type");
        if (null === b || "" === b) return !0;
        var c = g.types[b];
        return "string" == typeof c && "pending" !== c ? (g.types[b] = g.detectTypeSupport(b, c), "pending") : "function" == typeof c ? (c(), "pending") : c;
    }, g.parseSize = function (a) {
        var b = /(\([^)]+\))?\s*(.+)/g.exec(a);
        return { media: b && b[1], length: b && b[2] };
    }, g.findWidthFromSourceSize = function (c) {
        for (var d, e = g.trim(c).split(/\s*,\s*/), f = 0, h = e.length; h > f; f++) {
            var i = e[f],
                j = g.parseSize(i),
                k = j.length,
                l = j.media;
            if (k && (!l || g.matchesMedia(l)) && (d = g.getWidthFromLength(k))) break;
        }
        return d || Math.max(a.innerWidth || 0, b.documentElement.clientWidth);
    }, g.parseSrcset = function (a) {
        for (var b = []; "" !== a;) {
            a = a.replace(/^\s+/g, "");
            var c,
                d = a.search(/\s/g),
                e = null;
            if (-1 !== d) {
                c = a.slice(0, d);
                var f = c.slice(-1);
                if (("," === f || "" === c) && (c = c.replace(/,+$/, ""), e = ""), a = a.slice(d + 1), null === e) {
                    var g = a.indexOf(",");
                    -1 !== g ? (e = a.slice(0, g), a = a.slice(g + 1)) : (e = a, a = "");
                }
            } else c = a, a = "";
            (c || e) && b.push({ url: c, descriptor: e });
        }
        return b;
    }, g.parseDescriptor = function (a, b) {
        var c,
            d = b || "100vw",
            e = a && a.replace(/(^\s+|\s+$)/g, ""),
            f = g.findWidthFromSourceSize(d);
        if (e) for (var h = e.split(" "), i = h.length - 1; i >= 0; i--) {
            var j = h[i],
                k = j && j.slice(j.length - 1);
            if ("h" !== k && "w" !== k || g.sizesSupported) {
                if ("x" === k) {
                    var l = j && parseFloat(j, 10);
                    c = l && !isNaN(l) ? l : 1;
                }
            } else c = parseFloat(parseInt(j, 10) / f);
        }
        return c || 1;
    }, g.getCandidatesFromSourceSet = function (a, b) {
        for (var c = g.parseSrcset(a), d = [], e = 0, f = c.length; f > e; e++) {
            var h = c[e];
            d.push({
                url: h.url,
                resolution: g.parseDescriptor(h.descriptor, b)
            });
        }
        return d;
    }, g.dodgeSrcset = function (a) {
        a.srcset && (a[g.ns].srcset = a.srcset, a.srcset = "", a.setAttribute("data-pfsrcset", a[g.ns].srcset));
    }, g.processSourceSet = function (a) {
        var b = a.getAttribute("srcset"),
            c = a.getAttribute("sizes"),
            d = [];
        return "IMG" === a.nodeName.toUpperCase() && a[g.ns] && a[g.ns].srcset && (b = a[g.ns].srcset), b && (d = g.getCandidatesFromSourceSet(b, c)), d;
    }, g.backfaceVisibilityFix = function (a) {
        var b = a.style || {},
            c = "webkitBackfaceVisibility" in b,
            d = b.zoom;
        c && (b.zoom = ".999", c = a.offsetWidth, b.zoom = d);
    }, g.setIntrinsicSize = function () {
        var c = {},
            d = function d(a, b, c) {
            b && a.setAttribute("width", parseInt(b / c, 10));
        };
        return function (e, f) {
            var h;
            e[g.ns] && !a.pfStopIntrinsicSize && (void 0 === e[g.ns].dims && (e[g.ns].dims = e.getAttribute("width") || e.getAttribute("height")), e[g.ns].dims || (f.url in c ? d(e, c[f.url], f.resolution) : (h = b.createElement("img"), h.onload = function () {
                if (c[f.url] = h.width, !c[f.url]) try {
                    b.body.appendChild(h), c[f.url] = h.width || h.offsetWidth, b.body.removeChild(h);
                } catch (a) {}
                e.src === f.url && d(e, c[f.url], f.resolution), e = null, h.onload = null, h = null;
            }, h.src = f.url)));
        };
    }(), g.applyBestCandidate = function (a, b) {
        var c, d, e;
        a.sort(g.ascendingSort), d = a.length, e = a[d - 1];
        for (var f = 0; d > f; f++) {
            if (c = a[f], c.resolution >= g.getDpr()) {
                e = c;
                break;
            }
        }e && (e.url = g.makeUrl(e.url), b.src !== e.url && (g.restrictsMixedContent() && "http:" === e.url.substr(0, "http:".length).toLowerCase() ? void 0 !== window.console && console.warn("Blocked mixed content image " + e.url) : (b.src = e.url, g.curSrcSupported || (b.currentSrc = b.src), g.backfaceVisibilityFix(b))), g.setIntrinsicSize(b, e));
    }, g.ascendingSort = function (a, b) {
        return a.resolution - b.resolution;
    }, g.removeVideoShim = function (a) {
        var b = a.getElementsByTagName("video");
        if (b.length) {
            for (var c = b[0], d = c.getElementsByTagName("source"); d.length;) {
                a.insertBefore(d[0], c);
            }c.parentNode.removeChild(c);
        }
    }, g.getAllElements = function () {
        for (var a = [], c = b.getElementsByTagName("img"), d = 0, e = c.length; e > d; d++) {
            var f = c[d];
            ("PICTURE" === f.parentNode.nodeName.toUpperCase() || null !== f.getAttribute("srcset") || f[g.ns] && null !== f[g.ns].srcset) && a.push(f);
        }
        return a;
    }, g.getMatch = function (a, b) {
        for (var c, d = b.childNodes, e = 0, f = d.length; f > e; e++) {
            var h = d[e];
            if (1 === h.nodeType) {
                if (h === a) return c;
                if ("SOURCE" === h.nodeName.toUpperCase()) {
                    null !== h.getAttribute("src") && void 0 !== (typeof console === "undefined" ? "undefined" : _typeof(console)) && console.warn("The `src` attribute is invalid on `picture` `source` element; instead, use `srcset`.");
                    var i = h.getAttribute("media");
                    if (h.getAttribute("srcset") && (!i || g.matchesMedia(i))) {
                        var j = g.verifyTypeSupport(h);
                        if (j === !0) {
                            c = h;
                            break;
                        }
                        if ("pending" === j) return !1;
                    }
                }
            }
        }
        return c;
    }, f(), e._ = g, d(e);
}(window, window.document, new window.Image());

/**!
 * lg-fullscreen.js | 1.1.0 | February 23rd 2019
 * http://sachinchoolur.github.io/lg-fullscreen.js
 * Copyright (c) 2016 Sachin N;
 * @license GPLv3
 */(function (f) {
    if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
        module.exports = f();
    } else if (typeof define === "function" && define.amd) {
        define([], f);
    } else {
        var g;if (typeof window !== "undefined") {
            g = window;
        } else if (typeof global !== "undefined") {
            g = global;
        } else if (typeof self !== "undefined") {
            g = self;
        } else {
            g = this;
        }g.LgFullscreen = f();
    }
})(function () {
    var define;return function () {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                    }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                        var n = e[i][1][r];return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }return n[i].exports;
            }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
                o(t[i]);
            }return o;
        }return r;
    }()({ 1: [function (require, module, exports) {
            (function (global, factory) {
                if (typeof define === "function" && define.amd) {
                    
                } else if (typeof exports !== "undefined") {
                    factory();
                } else {
                    var mod = {
                        exports: {}
                    };
                    factory();
                    global.lgFullscreen = mod.exports;
                }
            })(this, function () {
                'use strict';

                var _extends$$1 = Object.assign || function (target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];

                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }

                    return target;
                };

                var fullscreenDefaults = {
                    fullScreen: true
                };

                function isFullScreen() {
                    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
                }

                var Fullscreen = function Fullscreen(element) {

                    this.el = element;

                    this.core = window.lgData[this.el.getAttribute('lg-uid')];
                    this.core.s = _extends$$1({}, fullscreenDefaults, this.core.s);

                    this.init();

                    return this;
                };

                Fullscreen.prototype.init = function () {
                    var fullScreen = '';
                    if (this.core.s.fullScreen) {

                        // check for fullscreen browser support
                        if (!document.fullscreenEnabled && !document.webkitFullscreenEnabled && !document.mozFullScreenEnabled && !document.msFullscreenEnabled) {
                            return;
                        } else {
                            fullScreen = '<span class="lg-fullscreen lg-icon"></span>';
                            this.core.outer.querySelector('.lg-toolbar').insertAdjacentHTML('beforeend', fullScreen);
                            this.fullScreen();
                        }
                    }
                };

                Fullscreen.prototype.requestFullscreen = function () {
                    var el = document.documentElement;
                    if (el.requestFullscreen) {
                        el.requestFullscreen();
                    } else if (el.msRequestFullscreen) {
                        el.msRequestFullscreen();
                    } else if (el.mozRequestFullScreen) {
                        el.mozRequestFullScreen();
                    } else if (el.webkitRequestFullscreen) {
                        el.webkitRequestFullscreen();
                    }
                };

                Fullscreen.prototype.exitFullscreen = function () {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }
                };

                // https://developer.mozilla.org/en-US/docs/Web/Guide/API/DOM/Using_full_screen_mode
                Fullscreen.prototype.fullScreen = function () {
                    var _this = this;

                    utils.on(document, 'fullscreenchange.lgfullscreen webkitfullscreenchange.lgfullscreen mozfullscreenchange.lgfullscreen MSFullscreenChange.lgfullscreen', function () {
                        if (utils.hasClass(_this.core.outer, 'lg-fullscreen-on')) {
                            utils.removeClass(_this.core.outer, 'lg-fullscreen-on');
                        } else {
                            utils.addClass(_this.core.outer, 'lg-fullscreen-on');
                        }
                    });

                    utils.on(this.core.outer.querySelector('.lg-fullscreen'), 'click.lg', function () {
                        if (isFullScreen()) {
                            _this.exitFullscreen();
                        } else {
                            _this.requestFullscreen();
                        }
                    });
                };

                Fullscreen.prototype.destroy = function () {

                    // exit from fullscreen if activated
                    if (isFullScreen()) {
                        this.exitFullscreen();
                    }

                    utils.off(document, '.lgfullscreen');
                };

                window.lgModules.fullscreen = Fullscreen;
            });
        }, {}] }, {}, [1])(1);
});

/**!
 * lg-pager.js | 1.0.0 | October 5th 2016
 * http://sachinchoolur.github.io/lg-pager.js
 * Copyright (c) 2016 Sachin N;
 * @license GPLv3
 */(function (f) {
    if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
        module.exports = f();
    } else if (typeof define === "function" && define.amd) {
        define([], f);
    } else {
        var g;if (typeof window !== "undefined") {
            g = window;
        } else if (typeof global !== "undefined") {
            g = global;
        } else if (typeof self !== "undefined") {
            g = self;
        } else {
            g = this;
        }g.LgPager = f();
    }
})(function () {
    var define;return function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof require == "function" && require;if (!u && a) return a(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
                }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
                    var n = t[o][1][e];return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }return n[o].exports;
        }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
            s(r[o]);
        }return s;
    }({ 1: [function (require, module, exports) {
            (function (global, factory) {
                if (typeof define === "function" && define.amd) {
                    
                } else if (typeof exports !== "undefined") {
                    factory();
                } else {
                    var mod = {
                        exports: {}
                    };
                    factory();
                    global.lgPager = mod.exports;
                }
            })(this, function () {
                'use strict';

                var _extends$$1 = Object.assign || function (target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];

                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }

                    return target;
                };

                var pagerDefaults = {
                    pager: false
                };

                var Pager = function Pager(element) {

                    this.el = element;

                    this.core = window.lgData[this.el.getAttribute('lg-uid')];
                    this.core.s = _extends$$1({}, pagerDefaults, this.core.s);

                    if (this.core.s.pager && this.core.items.length > 1) {
                        this.init();
                    }

                    return this;
                };

                Pager.prototype.init = function () {
                    var _this = this;
                    var pagerList = '';
                    var $pagerCont;
                    var $pagerOuter;
                    var timeout;

                    _this.core.outer.querySelector('.lg').insertAdjacentHTML('beforeend', '<div class="lg-pager-outer"></div>');

                    if (_this.core.s.dynamic) {
                        for (var j = 0; j < _this.core.s.dynamicEl.length; j++) {
                            pagerList += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + _this.core.s.dynamicEl[j].thumb + '" /></div></span>';
                        }
                    } else {
                        for (var i = 0; i < _this.core.items.length; i++) {
                            if (!_this.core.s.exThumbImage) {
                                pagerList += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + _this.core.items[i].querySelector('img').getAttribute('src') + '" /></div></span>';
                            } else {
                                pagerList += '<span class="lg-pager-cont"> <span class="lg-pager"></span><div class="lg-pager-thumb-cont"><span class="lg-caret"></span> <img src="' + _this.core.items[i].getAttribute(_this.core.s.exThumbImage) + '" /></div></span>';
                            }
                        }
                    }

                    $pagerOuter = _this.core.outer.querySelector('.lg-pager-outer');

                    $pagerOuter.innerHTML = pagerList;

                    $pagerCont = _this.core.outer.querySelectorAll('.lg-pager-cont');
                    for (var k = 0; k < $pagerCont.length; k++) {

                        /*jshint loopfunc: true */
                        (function (index) {
                            utils.on($pagerCont[index], 'click.lg touchend.lg', function () {
                                _this.core.index = index;
                                _this.core.slide(_this.core.index, false, false);
                            });
                        })(k);
                    }

                    utils.on($pagerOuter, 'mouseover.lg', function () {
                        clearTimeout(timeout);
                        utils.addClass($pagerOuter, 'lg-pager-hover');
                    });

                    utils.on($pagerOuter, 'mouseout.lg', function () {
                        timeout = setTimeout(function () {
                            utils.removeClass($pagerOuter, 'lg-pager-hover');
                        });
                    });

                    utils.on(_this.core.el, 'onBeforeSlide.lgtm', function (e) {
                        for (var n = 0; n < $pagerCont.length; n++) {
                            utils.removeClass($pagerCont[n], 'lg-pager-active');
                            if (e.detail.index === n) {
                                utils.addClass($pagerCont[n], 'lg-pager-active');
                            }
                        }
                    });
                };

                Pager.prototype.destroy = function () {};

                window.lgModules.pager = Pager;
            });
        }, {}] }, {}, [1])(1);
});

var thumbnailDefaults = {
    thumbnail: true,

    animateThumb: true,
    currentPagerPosition: 'middle',

    thumbWidth: 100,
    thumbContHeight: 100,
    thumbMargin: 5,

    exThumbImage: false,
    showThumbByDefault: true,
    toggleThumb: true,
    pullCaptionUp: true,

    enableThumbDrag: true,
    enableThumbSwipe: true,
    swipeThreshold: 50,

    loadYoutubeThumbnail: true,
    youtubeThumbSize: 1,

    loadVimeoThumbnail: true,
    vimeoThumbSize: 'thumbnail_small',

    loadDailymotionThumbnail: true
};

var Thumbnail = function Thumbnail(element) {

    this.el = element;

    this.core = window.lgData[this.el.getAttribute('lg-uid')];
    this.core.s = Object.assign({}, thumbnailDefaults, this.core.s);

    this.thumbOuter = null;
    this.thumbOuterWidth = 0;
    this.thumbTotalWidth = this.core.items.length * (this.core.s.thumbWidth + this.core.s.thumbMargin);
    this.thumbIndex = this.core.index;

    // Thumbnail animation value
    this.left = 0;

    this.init();

    return this;
};

Thumbnail.prototype.init = function () {
    var _this = this;
    if (this.core.s.thumbnail && this.core.items.length > 1) {
        if (this.core.s.showThumbByDefault) {
            setTimeout(function () {
                utils.addClass(_this.core.outer, 'lg-thumb-open');
            }, 700);
        }

        if (this.core.s.pullCaptionUp) {
            utils.addClass(this.core.outer, 'lg-pull-caption-up');
        }

        this.build();
        if (this.core.s.animateThumb) {
            if (this.core.s.enableThumbDrag && !this.core.isTouch && this.core.doCss()) {
                this.enableThumbDrag();
            }

            if (this.core.s.enableThumbSwipe && this.core.isTouch && this.core.doCss()) {
                this.enableThumbSwipe();
            }

            this.thumbClickable = false;
        } else {
            this.thumbClickable = true;
        }

        this.toggle();
        this.thumbkeyPress();
    }
};

Thumbnail.prototype.build = function () {
    var _this = this;
    var thumbList = '';
    var vimeoErrorThumbSize = '';
    var $thumb;
    var html = '<div class="lg-thumb-outer">' + '<div class="lg-thumb group">' + '</div>' + '</div>';

    switch (this.core.s.vimeoThumbSize) {
        case 'thumbnail_large':
            vimeoErrorThumbSize = '640';
            break;
        case 'thumbnail_medium':
            vimeoErrorThumbSize = '200x150';
            break;
        case 'thumbnail_small':
            vimeoErrorThumbSize = '100x75';
    }

    utils.addClass(_this.core.outer, 'lg-has-thumb');

    _this.core.outer.querySelector('.lg').insertAdjacentHTML('beforeend', html);

    _this.thumbOuter = _this.core.outer.querySelector('.lg-thumb-outer');
    _this.thumbOuterWidth = _this.thumbOuter.offsetWidth;

    if (_this.core.s.animateThumb) {
        _this.core.outer.querySelector('.lg-thumb').style.width = _this.thumbTotalWidth + 'px';
        _this.core.outer.querySelector('.lg-thumb').style.position = 'relative';
    }

    if (this.core.s.animateThumb) {
        _this.thumbOuter.style.height = _this.core.s.thumbContHeight + 'px';
    }

    function getThumb(src, thumb, index) {
        var isVideo = _this.core.isVideo(src, index) || {};
        var thumbImg;
        var vimeoId = '';

        if (isVideo.youtube || isVideo.vimeo || isVideo.dailymotion) {
            if (isVideo.youtube) {
                if (_this.core.s.loadYoutubeThumbnail) {
                    thumbImg = '//img.youtube.com/vi/' + isVideo.youtube[1] + '/' + _this.core.s.youtubeThumbSize + '.jpg';
                } else {
                    thumbImg = thumb;
                }
            } else if (isVideo.vimeo) {
                if (_this.core.s.loadVimeoThumbnail) {
                    thumbImg = '//i.vimeocdn.com/video/error_' + vimeoErrorThumbSize + '.jpg';
                    vimeoId = isVideo.vimeo[1];
                } else {
                    thumbImg = thumb;
                }
            } else if (isVideo.dailymotion) {
                if (_this.core.s.loadDailymotionThumbnail) {
                    thumbImg = '//www.dailymotion.com/thumbnail/video/' + isVideo.dailymotion[1];
                } else {
                    thumbImg = thumb;
                }
            }
        } else {
            thumbImg = thumb;
        }

        thumbList += '<div data-vimeo-id="' + vimeoId + '" class="lg-thumb-item" style="width:' + _this.core.s.thumbWidth + 'px; margin-right: ' + _this.core.s.thumbMargin + 'px"><img src="' + thumbImg + '" /></div>';
        vimeoId = '';
    }

    if (_this.core.s.dynamic) {
        for (var j = 0; j < _this.core.s.dynamicEl.length; j++) {
            getThumb(_this.core.s.dynamicEl[j].src, _this.core.s.dynamicEl[j].thumb, j);
        }
    } else {
        for (var i = 0; i < _this.core.items.length; i++) {
            if (!_this.core.s.exThumbImage) {
                getThumb(_this.core.items[i].getAttribute('href') || _this.core.items[i].getAttribute('data-src'), _this.core.items[i].querySelector('img').getAttribute('src'), i);
            } else {
                getThumb(_this.core.items[i].getAttribute('href') || _this.core.items[i].getAttribute('data-src'), _this.core.items[i].getAttribute(_this.core.s.exThumbImage), i);
            }
        }
    }

    _this.core.outer.querySelector('.lg-thumb').innerHTML = thumbList;

    $thumb = _this.core.outer.querySelectorAll('.lg-thumb-item');

    for (var n = 0; n < $thumb.length; n++) {

        /*jshint loopfunc: true */
        (function (index) {
            var $this = $thumb[index];
            var vimeoVideoId = $this.getAttribute('data-vimeo-id');
            if (vimeoVideoId) {

                window['lgJsonP' + _this.el.getAttribute('lg-uid') + '' + n] = function (content) {
                    $this.querySelector('img').setAttribute('src', content[0][_this.core.s.vimeoThumbSize]);
                };

                var script = document.createElement('script');
                script.className = 'lg-script';
                script.src = '//www.vimeo.com/api/v2/video/' + vimeoVideoId + '.json?callback=lgJsonP' + _this.el.getAttribute('lg-uid') + '' + n;
                document.body.appendChild(script);
            }
        })(n);
    }

    // manage active class for thumbnail
    utils.addClass($thumb[_this.core.index], 'active');
    utils.on(_this.core.el, 'onBeforeSlide.lgtm', function () {

        for (var j = 0; j < $thumb.length; j++) {
            utils.removeClass($thumb[j], 'active');
        }

        utils.addClass($thumb[_this.core.index], 'active');
    });

    for (var k = 0; k < $thumb.length; k++) {

        /*jshint loopfunc: true */
        (function (index) {

            utils.on($thumb[index], 'click.lg touchend.lg', function () {

                setTimeout(function () {

                    // In IE9 and bellow touch does not support
                    // Go to slide if browser does not support css transitions
                    if (_this.thumbClickable && !_this.core.lgBusy || !_this.core.doCss()) {
                        _this.core.index = index;
                        _this.core.slide(_this.core.index, false, true);
                    }
                }, 50);
            });
        })(k);
    }

    utils.on(_this.core.el, 'onBeforeSlide.lgtm', function () {
        _this.animateThumb(_this.core.index);
    });

    utils.on(window, 'resize.lgthumb orientationchange.lgthumb', function () {
        setTimeout(function () {
            _this.animateThumb(_this.core.index);
            _this.thumbOuterWidth = _this.thumbOuter.offsetWidth;
        }, 200);
    });
};

Thumbnail.prototype.setTranslate = function (value) {
    utils.setVendor(this.core.outer.querySelector('.lg-thumb'), 'Transform', 'translate3d(-' + value + 'px, 0px, 0px)');
};

Thumbnail.prototype.animateThumb = function (index) {
    var $thumb = this.core.outer.querySelector('.lg-thumb');
    if (this.core.s.animateThumb) {
        var position;
        switch (this.core.s.currentPagerPosition) {
            case 'left':
                position = 0;
                break;
            case 'middle':
                position = this.thumbOuterWidth / 2 - this.core.s.thumbWidth / 2;
                break;
            case 'right':
                position = this.thumbOuterWidth - this.core.s.thumbWidth;
        }
        this.left = (this.core.s.thumbWidth + this.core.s.thumbMargin) * index - 1 - position;
        if (this.left > this.thumbTotalWidth - this.thumbOuterWidth) {
            this.left = this.thumbTotalWidth - this.thumbOuterWidth;
        }

        if (this.left < 0) {
            this.left = 0;
        }

        if (this.core.lGalleryOn) {
            if (!utils.hasClass($thumb, 'on')) {
                utils.setVendor(this.core.outer.querySelector('.lg-thumb'), 'TransitionDuration', this.core.s.speed + 'ms');
            }

            if (!this.core.doCss()) {
                $thumb.style.left = -this.left + 'px';
            }
        } else {
            if (!this.core.doCss()) {
                $thumb.style.left = -this.left + 'px';
            }
        }

        this.setTranslate(this.left);
    }
};

// Enable thumbnail dragging and swiping
Thumbnail.prototype.enableThumbDrag = function () {

    var _this = this;
    var startCoords = 0;
    var endCoords = 0;
    var isDraging = false;
    var isMoved = false;
    var tempLeft = 0;

    utils.addClass(_this.thumbOuter, 'lg-grab');

    utils.on(_this.core.outer.querySelector('.lg-thumb'), 'mousedown.lgthumb', function (e) {
        if (_this.thumbTotalWidth > _this.thumbOuterWidth) {
            // execute only on .lg-object
            e.preventDefault();
            startCoords = e.pageX;
            isDraging = true;

            // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
            _this.core.outer.scrollLeft += 1;
            _this.core.outer.scrollLeft -= 1;

            // *
            _this.thumbClickable = false;
            utils.removeClass(_this.thumbOuter, 'lg-grab');
            utils.addClass(_this.thumbOuter, 'lg-grabbing');
        }
    });

    utils.on(window, 'mousemove.lgthumb', function (e) {
        if (isDraging) {
            tempLeft = _this.left;
            isMoved = true;
            endCoords = e.pageX;

            utils.addClass(_this.thumbOuter, 'lg-dragging');

            tempLeft = tempLeft - (endCoords - startCoords);

            if (tempLeft > _this.thumbTotalWidth - _this.thumbOuterWidth) {
                tempLeft = _this.thumbTotalWidth - _this.thumbOuterWidth;
            }

            if (tempLeft < 0) {
                tempLeft = 0;
            }

            // move current slide
            _this.setTranslate(tempLeft);
        }
    });

    utils.on(window, 'mouseup.lgthumb', function () {
        if (isMoved) {
            isMoved = false;
            utils.removeClass(_this.thumbOuter, 'lg-dragging');

            _this.left = tempLeft;

            if (Math.abs(endCoords - startCoords) < _this.core.s.swipeThreshold) {
                _this.thumbClickable = true;
            }
        } else {
            _this.thumbClickable = true;
        }

        if (isDraging) {
            isDraging = false;
            utils.removeClass(_this.thumbOuter, 'lg-grabbing');
            utils.addClass(_this.thumbOuter, 'lg-grab');
        }
    });
};

Thumbnail.prototype.enableThumbSwipe = function () {
    var _this = this;
    var startCoords = 0;
    var endCoords = 0;
    var isMoved = false;
    var tempLeft = 0;

    utils.on(_this.core.outer.querySelector('.lg-thumb'), 'touchstart.lg', function (e) {
        if (_this.thumbTotalWidth > _this.thumbOuterWidth) {
            e.preventDefault();
            startCoords = e.targetTouches[0].pageX;
            _this.thumbClickable = false;
        }
    });

    utils.on(_this.core.outer.querySelector('.lg-thumb'), 'touchmove.lg', function (e) {
        if (_this.thumbTotalWidth > _this.thumbOuterWidth) {
            e.preventDefault();
            endCoords = e.targetTouches[0].pageX;
            isMoved = true;

            utils.addClass(_this.thumbOuter, 'lg-dragging');

            tempLeft = _this.left;

            tempLeft = tempLeft - (endCoords - startCoords);

            if (tempLeft > _this.thumbTotalWidth - _this.thumbOuterWidth) {
                tempLeft = _this.thumbTotalWidth - _this.thumbOuterWidth;
            }

            if (tempLeft < 0) {
                tempLeft = 0;
            }

            // move current slide
            _this.setTranslate(tempLeft);
        }
    });

    utils.on(_this.core.outer.querySelector('.lg-thumb'), 'touchend.lg', function () {
        if (_this.thumbTotalWidth > _this.thumbOuterWidth) {

            if (isMoved) {
                isMoved = false;
                utils.removeClass(_this.thumbOuter, 'lg-dragging');
                if (Math.abs(endCoords - startCoords) < _this.core.s.swipeThreshold) {
                    _this.thumbClickable = true;
                }

                _this.left = tempLeft;
            } else {
                _this.thumbClickable = true;
            }
        } else {
            _this.thumbClickable = true;
        }
    });
};

Thumbnail.prototype.toggle = function () {
    var _this = this;
    if (_this.core.s.toggleThumb) {
        utils.addClass(_this.core.outer, 'lg-can-toggle');
        _this.thumbOuter.insertAdjacentHTML('beforeend', '<span class="lg-toggle-thumb lg-icon"></span>');
        utils.on(_this.core.outer.querySelector('.lg-toggle-thumb'), 'click.lg', function () {
            if (utils.hasClass(_this.core.outer, 'lg-thumb-open')) {
                utils.removeClass(_this.core.outer, 'lg-thumb-open');
            } else {
                utils.addClass(_this.core.outer, 'lg-thumb-open');
            }
        });
    }
};

Thumbnail.prototype.thumbkeyPress = function () {
    var _this = this;
    utils.on(window, 'keydown.lgthumb', function (e) {
        if (e.keyCode === 38) {
            e.preventDefault();
            utils.addClass(_this.core.outer, 'lg-thumb-open');
        } else if (e.keyCode === 40) {
            e.preventDefault();
            utils.removeClass(_this.core.outer, 'lg-thumb-open');
        }
    });
};

Thumbnail.prototype.destroy = function (d) {
    if (this.core.s.thumbnail && this.core.items.length > 1) {
        utils.off(window, '.lgthumb');
        if (!d) {
            this.thumbOuter.parentNode.removeChild(this.thumbOuter);
        }
        utils.removeClass(this.core.outer, 'lg-has-thumb');

        var lgScript = document.getElementsByClassName('lg-script');
        while (lgScript[0]) {
            lgScript[0].parentNode.removeChild(lgScript[0]);
        }
    }
};

window.lgModules.thumbnail = Thumbnail;

var LightGalleryHelper = {

    create: function create() {
        document.querySelectorAll('.js-gallery').forEach(function (gallery) {
            lightGallery(gallery, {
                thumbnail: true,
                download: false,
                preload: 1

            });
        });
    },

    destroyAll: function destroyAll() {

        var galleries = document.querySelectorAll('.js-gallery');

        galleries.forEach(function (gallery) {
            window.lgData[gallery.getAttribute('lg-uid')].destroy(true);
        });
    }
};

window.LightGalleryHelper = LightGalleryHelper;

LightGalleryHelper.create();

document.addEventListener('LokiRequestEnd', function () {
    LightGalleryHelper.create();
});

var accordionComponent = {
    accordionNodes: null,

    init: function init() {
        var self = this;

        self._destroyClickEvent();
        self.accordionNodes = null;
        self.accordionNodes = document.querySelectorAll('.c-accordion');

        if (!self.accordionNodes.length) {
            return;
        }

        self._initClickEvent();
    },
    _initClickEvent: function _initClickEvent() {
        var self = this;
        self.accordionNodes.forEach(function (accordionNode) {
            if (accordionNode.querySelector('.c-accordion__content > div').offsetHeight < 120 && accordionNode.dataset.minHeight === "true") {
                accordionNode.classList.add('js-accordion-small-content');
                return;
            }
            accordionNode.classList.add('js-initialized');
            accordionNode.querySelectorAll('.js-accordion-button').forEach(function (accordionButton) {
                var accordionItem = accordionNode.querySelector('.c-accordion__item');
                accordionButton.addEventListener('click', self._toggleContent, false);

                accordionItem.querySelector('.c-accordion__content').dataset.height = accordionItem.querySelector('.c-accordion__content').offsetHeight;
                if (accordionItem.dataset.collapsed === 'true') {
                    accordionItem.querySelector('.c-accordion__content').style.height = accordionItem.querySelector('.c-accordion__content').offsetHeight + "px";
                }
            });
        });
    },
    _toggleContent: function _toggleContent() {
        var self = this;
        var accordionItem = self.closest('.c-accordion').querySelector('.c-accordion__item');
        var accordionContent = accordionItem.querySelector('.c-accordion__content');
        var accordionButton = self.closest('.c-accordion').querySelector('.js-accordion-button');

        if (accordionItem.dataset.collapsed === "false") {
            accordionItem.dataset.collapsed = "true";
            accordionItem.setAttribute('aria-expanded', 'true');
            gsapWithCSS.to(accordionContent, 0.3, { height: 'auto' });
            accordionButton.classList.add('c-accordion--opened');
        } else {
            gsapWithCSS.to(accordionContent, 0.3, { height: accordionContent.dataset.height, onComplete: function onComplete() {
                    accordionItem.dataset.collapsed = "false";
                    accordionContent.removeAttribute('style');
                    accordionItem.setAttribute('aria-expanded', 'false');
                    accordionButton.classList.remove('c-accordion--opened');
                } });
        }
    },
    _destroyClickEvent: function _destroyClickEvent() {
        var self = this;

        if (!self.accordionNodes) {
            return;
        }

        self.accordionNodes.forEach(function (accordionNode) {
            if (!accordionNode.classList.contains('js-initialized')) {
                return;
            }

            accordionNode.querySelectorAll('.c-accordion__item').forEach(function (accordionItem) {
                accordionItem.querySelector('.c-accordion__content').removeEventListener('click', self._toggleContent, false);
            });
        });
    }
};

accordionComponent.init();

document.addEventListener('LokiRequestEnd', function () {
    accordionComponent.init();
});

}());
